/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
const $Object = $util.global.Object, $undefined = $util.global.undefined, $Error = $util.global.Error, $RangeError = $util.global.RangeError;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const app = $root.app = (() => {

    /**
     * Namespace app.
     * @exports app
     * @namespace
     */
    const app = {};

    app.zyno = (function() {

        /**
         * Namespace zyno.
         * @memberof app
         * @namespace
         */
        const zyno = {};

        zyno.talk = (function() {

            /**
             * Namespace talk.
             * @memberof app.zyno
             * @namespace
             */
            const talk = {};

            talk.softphone = (function() {

                /**
                 * Namespace softphone.
                 * @memberof app.zyno.talk
                 * @namespace
                 */
                const softphone = {};

                softphone.PingPong = (function() {

                    /**
                     * Properties of a PingPong.
                     * @typedef {Object} app.zyno.talk.softphone.PingPong.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a PingPong.
                     * @memberof app.zyno.talk.softphone
                     * @interface IPingPong
                     * @augments app.zyno.talk.softphone.PingPong.$Properties
                     * @deprecated Use app.zyno.talk.softphone.PingPong.$Properties instead.
                     */

                    /**
                     * Shape of a PingPong.
                     * @typedef {app.zyno.talk.softphone.PingPong.$Properties} app.zyno.talk.softphone.PingPong.$Shape
                     */

                    /**
                     * Constructs a new PingPong.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a PingPong.
                     * @constructor
                     * @param {app.zyno.talk.softphone.PingPong.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const PingPong = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified PingPong message. Does not implicitly {@link app.zyno.talk.softphone.PingPong.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.PingPong
                     * @static
                     * @param {app.zyno.talk.softphone.PingPong.$Properties} message PingPong message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PingPong.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a PingPong message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.PingPong
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.PingPong & app.zyno.talk.softphone.PingPong.$Shape} PingPong
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PingPong.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.PingPong();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a PingPong message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.PingPong
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PingPong.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for PingPong
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.PingPong
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    PingPong.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.PingPong";
                    };

                    return PingPong;
                })();

                softphone.WriteByteStream = (function() {

                    /**
                     * Properties of a WriteByteStream.
                     * @typedef {Object} app.zyno.talk.softphone.WriteByteStream.$Properties
                     * @property {Uint8Array|null} [chunk] WriteByteStream chunk
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a WriteByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @interface IWriteByteStream
                     * @augments app.zyno.talk.softphone.WriteByteStream.$Properties
                     * @deprecated Use app.zyno.talk.softphone.WriteByteStream.$Properties instead.
                     */

                    /**
                     * Shape of a WriteByteStream.
                     * @typedef {app.zyno.talk.softphone.WriteByteStream.$Properties} app.zyno.talk.softphone.WriteByteStream.$Shape
                     */

                    /**
                     * Constructs a new WriteByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a WriteByteStream.
                     * @constructor
                     * @param {app.zyno.talk.softphone.WriteByteStream.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const WriteByteStream = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * WriteByteStream chunk.
                     * @member {Uint8Array} chunk
                     * @memberof app.zyno.talk.softphone.WriteByteStream
                     * @instance
                     */
                    WriteByteStream.prototype.chunk = $util.newBuffer([]);

                    /**
                     * Encodes the specified WriteByteStream message. Does not implicitly {@link app.zyno.talk.softphone.WriteByteStream.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.WriteByteStream
                     * @static
                     * @param {app.zyno.talk.softphone.WriteByteStream.$Properties} message WriteByteStream message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WriteByteStream.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.chunk != null && $Object.hasOwnProperty.call(message, "chunk") && message.chunk.length)
                            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.chunk);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a WriteByteStream message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.WriteByteStream
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.WriteByteStream & app.zyno.talk.softphone.WriteByteStream.$Shape} WriteByteStream
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WriteByteStream.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.WriteByteStream();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.bytes()).length)
                                        message.chunk = value;
                                    else
                                        delete message.chunk;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a WriteByteStream message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.WriteByteStream
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WriteByteStream.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.chunk != null && $Object.hasOwnProperty.call(message, "chunk"))
                            if (!(message.chunk && typeof message.chunk.length === "number" || $util.isString(message.chunk)))
                                return "chunk: buffer expected";
                        return null;
                    };

                    /**
                     * Gets the type url for WriteByteStream
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.WriteByteStream
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    WriteByteStream.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.WriteByteStream";
                    };

                    return WriteByteStream;
                })();

                softphone.FinishByteStream = (function() {

                    /**
                     * Properties of a FinishByteStream.
                     * @typedef {Object} app.zyno.talk.softphone.FinishByteStream.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a FinishByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @interface IFinishByteStream
                     * @augments app.zyno.talk.softphone.FinishByteStream.$Properties
                     * @deprecated Use app.zyno.talk.softphone.FinishByteStream.$Properties instead.
                     */

                    /**
                     * Shape of a FinishByteStream.
                     * @typedef {app.zyno.talk.softphone.FinishByteStream.$Properties} app.zyno.talk.softphone.FinishByteStream.$Shape
                     */

                    /**
                     * Constructs a new FinishByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a FinishByteStream.
                     * @constructor
                     * @param {app.zyno.talk.softphone.FinishByteStream.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const FinishByteStream = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified FinishByteStream message. Does not implicitly {@link app.zyno.talk.softphone.FinishByteStream.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.FinishByteStream
                     * @static
                     * @param {app.zyno.talk.softphone.FinishByteStream.$Properties} message FinishByteStream message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FinishByteStream.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a FinishByteStream message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.FinishByteStream
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.FinishByteStream & app.zyno.talk.softphone.FinishByteStream.$Shape} FinishByteStream
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FinishByteStream.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.FinishByteStream();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a FinishByteStream message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.FinishByteStream
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FinishByteStream.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for FinishByteStream
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.FinishByteStream
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    FinishByteStream.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.FinishByteStream";
                    };

                    return FinishByteStream;
                })();

                softphone.DestroyByteStream = (function() {

                    /**
                     * Properties of a DestroyByteStream.
                     * @typedef {Object} app.zyno.talk.softphone.DestroyByteStream.$Properties
                     * @property {string|null} [error] DestroyByteStream error
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a DestroyByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @interface IDestroyByteStream
                     * @augments app.zyno.talk.softphone.DestroyByteStream.$Properties
                     * @deprecated Use app.zyno.talk.softphone.DestroyByteStream.$Properties instead.
                     */

                    /**
                     * Shape of a DestroyByteStream.
                     * @typedef {app.zyno.talk.softphone.DestroyByteStream.$Properties} app.zyno.talk.softphone.DestroyByteStream.$Shape
                     */

                    /**
                     * Constructs a new DestroyByteStream.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a DestroyByteStream.
                     * @constructor
                     * @param {app.zyno.talk.softphone.DestroyByteStream.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const DestroyByteStream = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * DestroyByteStream error.
                     * @member {string|null|undefined} error
                     * @memberof app.zyno.talk.softphone.DestroyByteStream
                     * @instance
                     */
                    DestroyByteStream.prototype.error = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(DestroyByteStream.prototype, "_error", {
                        get: $util.oneOfGetter($oneOfFields = ["error"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified DestroyByteStream message. Does not implicitly {@link app.zyno.talk.softphone.DestroyByteStream.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.DestroyByteStream
                     * @static
                     * @param {app.zyno.talk.softphone.DestroyByteStream.$Properties} message DestroyByteStream message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DestroyByteStream.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.error);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a DestroyByteStream message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.DestroyByteStream
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.DestroyByteStream & app.zyno.talk.softphone.DestroyByteStream.$Shape} DestroyByteStream
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DestroyByteStream.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.DestroyByteStream();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    message.error = reader.stringVerify();
                                    message._error = "error";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a DestroyByteStream message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.DestroyByteStream
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DestroyByteStream.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error")) {
                            properties._error = 1;
                            if (!$util.isString(message.error))
                                return "error: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for DestroyByteStream
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.DestroyByteStream
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    DestroyByteStream.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.DestroyByteStream";
                    };

                    return DestroyByteStream;
                })();

                softphone.ByteStreamOperation = (function() {

                    /**
                     * Properties of a ByteStreamOperation.
                     * @typedef {Object} app.zyno.talk.softphone.ByteStreamOperation.$Properties
                     * @property {number|null} [streamId] ByteStreamOperation streamId
                     * @property {app.zyno.talk.softphone.WriteByteStream.$Properties|null} [write] ByteStreamOperation write
                     * @property {app.zyno.talk.softphone.FinishByteStream.$Properties|null} [finish] ByteStreamOperation finish
                     * @property {app.zyno.talk.softphone.DestroyByteStream.$Properties|null} [destroy] ByteStreamOperation destroy
                     * @property {"write"|"finish"|"destroy"} [operation] ByteStreamOperation operation
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a ByteStreamOperation.
                     * @memberof app.zyno.talk.softphone
                     * @interface IByteStreamOperation
                     * @augments app.zyno.talk.softphone.ByteStreamOperation.$Properties
                     * @deprecated Use app.zyno.talk.softphone.ByteStreamOperation.$Properties instead.
                     */

                    /**
                     * Narrowed shape of a ByteStreamOperation.
                     * @typedef {{
                     *   streamId?: number|null;
                     *   write?: app.zyno.talk.softphone.WriteByteStream.$Shape|null;
                     *   finish?: app.zyno.talk.softphone.FinishByteStream.$Shape|null;
                     *   destroy?: app.zyno.talk.softphone.DestroyByteStream.$Shape|null;
                     *   $unknowns?: Array.<Uint8Array>;
                     * } & (
                     *   ({ operation?: undefined; write?: null; finish?: null; destroy?: null }|{ operation?: "write"; write: app.zyno.talk.softphone.WriteByteStream.$Shape; finish?: null; destroy?: null }|{ operation?: "finish"; write?: null; finish: app.zyno.talk.softphone.FinishByteStream.$Shape; destroy?: null }|{ operation?: "destroy"; write?: null; finish?: null; destroy: app.zyno.talk.softphone.DestroyByteStream.$Shape })
                     * )} app.zyno.talk.softphone.ByteStreamOperation.$Shape
                     */

                    /**
                     * Constructs a new ByteStreamOperation.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a ByteStreamOperation.
                     * @constructor
                     * @param {app.zyno.talk.softphone.ByteStreamOperation.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const ByteStreamOperation = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * ByteStreamOperation streamId.
                     * @member {number} streamId
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @instance
                     */
                    ByteStreamOperation.prototype.streamId = 0;

                    /**
                     * ByteStreamOperation write.
                     * @member {app.zyno.talk.softphone.WriteByteStream.$Properties|null|undefined} write
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @instance
                     */
                    ByteStreamOperation.prototype.write = null;

                    /**
                     * ByteStreamOperation finish.
                     * @member {app.zyno.talk.softphone.FinishByteStream.$Properties|null|undefined} finish
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @instance
                     */
                    ByteStreamOperation.prototype.finish = null;

                    /**
                     * ByteStreamOperation destroy.
                     * @member {app.zyno.talk.softphone.DestroyByteStream.$Properties|null|undefined} destroy
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @instance
                     */
                    ByteStreamOperation.prototype.destroy = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * ByteStreamOperation operation.
                     * @member {"write"|"finish"|"destroy"|undefined} operation
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @instance
                     */
                    $Object.defineProperty(ByteStreamOperation.prototype, "operation", {
                        get: $util.oneOfGetter($oneOfFields = ["write", "finish", "destroy"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified ByteStreamOperation message. Does not implicitly {@link app.zyno.talk.softphone.ByteStreamOperation.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @static
                     * @param {app.zyno.talk.softphone.ByteStreamOperation.$Properties} message ByteStreamOperation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ByteStreamOperation.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.streamId != null && $Object.hasOwnProperty.call(message, "streamId") && message.streamId !== 0)
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.streamId);
                        if (message.write != null && $Object.hasOwnProperty.call(message, "write"))
                            $root.app.zyno.talk.softphone.WriteByteStream.encode(message.write, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
                        if (message.finish != null && $Object.hasOwnProperty.call(message, "finish"))
                            $root.app.zyno.talk.softphone.FinishByteStream.encode(message.finish, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                        if (message.destroy != null && $Object.hasOwnProperty.call(message, "destroy"))
                            $root.app.zyno.talk.softphone.DestroyByteStream.encode(message.destroy, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a ByteStreamOperation message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.ByteStreamOperation & app.zyno.talk.softphone.ByteStreamOperation.$Shape} ByteStreamOperation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ByteStreamOperation.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.ByteStreamOperation();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.int32())
                                        message.streamId = value;
                                    else
                                        delete message.streamId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    message.write = $root.app.zyno.talk.softphone.WriteByteStream.decode(reader, reader.size(), $undefined, _depth + 1, message.write);
                                    message.operation = "write";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.finish = $root.app.zyno.talk.softphone.FinishByteStream.decode(reader, reader.size(), $undefined, _depth + 1, message.finish);
                                    message.operation = "finish";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.destroy = $root.app.zyno.talk.softphone.DestroyByteStream.decode(reader, reader.size(), $undefined, _depth + 1, message.destroy);
                                    message.operation = "destroy";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a ByteStreamOperation message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ByteStreamOperation.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.streamId != null && $Object.hasOwnProperty.call(message, "streamId"))
                            if (!$util.isInteger(message.streamId))
                                return "streamId: integer expected";
                        if (message.write != null && $Object.hasOwnProperty.call(message, "write")) {
                            properties.operation = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.WriteByteStream.verify(message.write, _depth + 1);
                                if (error)
                                    return "write." + error;
                            }
                        }
                        if (message.finish != null && $Object.hasOwnProperty.call(message, "finish")) {
                            if (properties.operation === 1)
                                return "operation: multiple values";
                            properties.operation = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.FinishByteStream.verify(message.finish, _depth + 1);
                                if (error)
                                    return "finish." + error;
                            }
                        }
                        if (message.destroy != null && $Object.hasOwnProperty.call(message, "destroy")) {
                            if (properties.operation === 1)
                                return "operation: multiple values";
                            properties.operation = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.DestroyByteStream.verify(message.destroy, _depth + 1);
                                if (error)
                                    return "destroy." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for ByteStreamOperation
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.ByteStreamOperation
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    ByteStreamOperation.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.ByteStreamOperation";
                    };

                    return ByteStreamOperation;
                })();

                softphone.TraceContext = (function() {

                    /**
                     * Properties of a TraceContext.
                     * @typedef {Object} app.zyno.talk.softphone.TraceContext.$Properties
                     * @property {string|null} [traceId] TraceContext traceId
                     * @property {string|null} [spanId] TraceContext spanId
                     * @property {number|null} [traceFlags] TraceContext traceFlags
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a TraceContext.
                     * @memberof app.zyno.talk.softphone
                     * @interface ITraceContext
                     * @augments app.zyno.talk.softphone.TraceContext.$Properties
                     * @deprecated Use app.zyno.talk.softphone.TraceContext.$Properties instead.
                     */

                    /**
                     * Shape of a TraceContext.
                     * @typedef {app.zyno.talk.softphone.TraceContext.$Properties} app.zyno.talk.softphone.TraceContext.$Shape
                     */

                    /**
                     * Constructs a new TraceContext.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a TraceContext.
                     * @constructor
                     * @param {app.zyno.talk.softphone.TraceContext.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const TraceContext = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * TraceContext traceId.
                     * @member {string} traceId
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @instance
                     */
                    TraceContext.prototype.traceId = "";

                    /**
                     * TraceContext spanId.
                     * @member {string} spanId
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @instance
                     */
                    TraceContext.prototype.spanId = "";

                    /**
                     * TraceContext traceFlags.
                     * @member {number} traceFlags
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @instance
                     */
                    TraceContext.prototype.traceFlags = 0;

                    /**
                     * Encodes the specified TraceContext message. Does not implicitly {@link app.zyno.talk.softphone.TraceContext.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @static
                     * @param {app.zyno.talk.softphone.TraceContext.$Properties} message TraceContext message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TraceContext.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.traceId != null && $Object.hasOwnProperty.call(message, "traceId") && message.traceId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.traceId);
                        if (message.spanId != null && $Object.hasOwnProperty.call(message, "spanId") && message.spanId !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.spanId);
                        if (message.traceFlags != null && $Object.hasOwnProperty.call(message, "traceFlags") && message.traceFlags !== 0)
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.traceFlags);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a TraceContext message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.TraceContext & app.zyno.talk.softphone.TraceContext.$Shape} TraceContext
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TraceContext.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.TraceContext();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.traceId = value;
                                    else
                                        delete message.traceId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.spanId = value;
                                    else
                                        delete message.spanId;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.int32())
                                        message.traceFlags = value;
                                    else
                                        delete message.traceFlags;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a TraceContext message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TraceContext.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.traceId != null && $Object.hasOwnProperty.call(message, "traceId"))
                            if (!$util.isString(message.traceId))
                                return "traceId: string expected";
                        if (message.spanId != null && $Object.hasOwnProperty.call(message, "spanId"))
                            if (!$util.isString(message.spanId))
                                return "spanId: string expected";
                        if (message.traceFlags != null && $Object.hasOwnProperty.call(message, "traceFlags"))
                            if (!$util.isInteger(message.traceFlags))
                                return "traceFlags: integer expected";
                        return null;
                    };

                    /**
                     * Gets the type url for TraceContext
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.TraceContext
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    TraceContext.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.TraceContext";
                    };

                    return TraceContext;
                })();

                /**
                 * CallStatus enum.
                 * @name app.zyno.talk.softphone.CallStatus
                 * @enum {number}
                 * @property {number} UNKNOWN=0 UNKNOWN value
                 * @property {number} RINGING=1 RINGING value
                 * @property {number} CONNECTED=2 CONNECTED value
                 * @property {number} ENDED=3 ENDED value
                 * @property {number} FAILED=4 FAILED value
                 */
                softphone.CallStatus = (function() {
                    const valuesById = $Object.create(null), values = $Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN"] = 0;
                    values[valuesById[1] = "RINGING"] = 1;
                    values[valuesById[2] = "CONNECTED"] = 2;
                    values[valuesById[3] = "ENDED"] = 3;
                    values[valuesById[4] = "FAILED"] = 4;
                    return values;
                })();

                /**
                 * CallPhase enum.
                 * @name app.zyno.talk.softphone.CallPhase
                 * @enum {number}
                 * @property {number} PHASE_UNKNOWN=0 PHASE_UNKNOWN value
                 * @property {number} PHASE_RINGING=1 PHASE_RINGING value
                 * @property {number} PHASE_PENDING_OFFER=2 PHASE_PENDING_OFFER value
                 * @property {number} PHASE_CONNECTING=3 PHASE_CONNECTING value
                 * @property {number} PHASE_CONNECTED=4 PHASE_CONNECTED value
                 */
                softphone.CallPhase = (function() {
                    const valuesById = $Object.create(null), values = $Object.create(valuesById);
                    values[valuesById[0] = "PHASE_UNKNOWN"] = 0;
                    values[valuesById[1] = "PHASE_RINGING"] = 1;
                    values[valuesById[2] = "PHASE_PENDING_OFFER"] = 2;
                    values[valuesById[3] = "PHASE_CONNECTING"] = 3;
                    values[valuesById[4] = "PHASE_CONNECTED"] = 4;
                    return values;
                })();

                /**
                 * CallEndReason enum.
                 * @name app.zyno.talk.softphone.CallEndReason
                 * @enum {number}
                 * @property {number} HANGUP=0 HANGUP value
                 * @property {number} ICE_FAILURE=1 ICE_FAILURE value
                 * @property {number} OUTBOUND_SETUP_ERROR=2 OUTBOUND_SETUP_ERROR value
                 * @property {number} INBOUND_SETUP_ERROR=3 INBOUND_SETUP_ERROR value
                 * @property {number} MISSING_SDP=4 MISSING_SDP value
                 * @property {number} REATTACH_FAILED=5 REATTACH_FAILED value
                 * @property {number} SERVER_REPORTED_FAILURE=6 SERVER_REPORTED_FAILURE value
                 * @property {number} SDP_DESYNC=7 SDP_DESYNC value
                 * @property {number} SETUP_RETRY_EXHAUSTED=8 SETUP_RETRY_EXHAUSTED value
                 */
                softphone.CallEndReason = (function() {
                    const valuesById = $Object.create(null), values = $Object.create(valuesById);
                    values[valuesById[0] = "HANGUP"] = 0;
                    values[valuesById[1] = "ICE_FAILURE"] = 1;
                    values[valuesById[2] = "OUTBOUND_SETUP_ERROR"] = 2;
                    values[valuesById[3] = "INBOUND_SETUP_ERROR"] = 3;
                    values[valuesById[4] = "MISSING_SDP"] = 4;
                    values[valuesById[5] = "REATTACH_FAILED"] = 5;
                    values[valuesById[6] = "SERVER_REPORTED_FAILURE"] = 6;
                    values[valuesById[7] = "SDP_DESYNC"] = 7;
                    values[valuesById[8] = "SETUP_RETRY_EXHAUSTED"] = 8;
                    return values;
                })();

                softphone.TurnInfo = (function() {

                    /**
                     * Properties of a TurnInfo.
                     * @typedef {Object} app.zyno.talk.softphone.TurnInfo.$Properties
                     * @property {string|null} [turnIp] TurnInfo turnIp
                     * @property {string|null} [turnUsername] TurnInfo turnUsername
                     * @property {string|null} [turnCredential] TurnInfo turnCredential
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a TurnInfo.
                     * @memberof app.zyno.talk.softphone
                     * @interface ITurnInfo
                     * @augments app.zyno.talk.softphone.TurnInfo.$Properties
                     * @deprecated Use app.zyno.talk.softphone.TurnInfo.$Properties instead.
                     */

                    /**
                     * Shape of a TurnInfo.
                     * @typedef {app.zyno.talk.softphone.TurnInfo.$Properties} app.zyno.talk.softphone.TurnInfo.$Shape
                     */

                    /**
                     * Constructs a new TurnInfo.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a TurnInfo.
                     * @constructor
                     * @param {app.zyno.talk.softphone.TurnInfo.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const TurnInfo = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * TurnInfo turnIp.
                     * @member {string} turnIp
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @instance
                     */
                    TurnInfo.prototype.turnIp = "";

                    /**
                     * TurnInfo turnUsername.
                     * @member {string} turnUsername
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @instance
                     */
                    TurnInfo.prototype.turnUsername = "";

                    /**
                     * TurnInfo turnCredential.
                     * @member {string} turnCredential
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @instance
                     */
                    TurnInfo.prototype.turnCredential = "";

                    /**
                     * Encodes the specified TurnInfo message. Does not implicitly {@link app.zyno.talk.softphone.TurnInfo.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @static
                     * @param {app.zyno.talk.softphone.TurnInfo.$Properties} message TurnInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TurnInfo.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.turnIp != null && $Object.hasOwnProperty.call(message, "turnIp") && message.turnIp !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.turnIp);
                        if (message.turnUsername != null && $Object.hasOwnProperty.call(message, "turnUsername") && message.turnUsername !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.turnUsername);
                        if (message.turnCredential != null && $Object.hasOwnProperty.call(message, "turnCredential") && message.turnCredential !== "")
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.turnCredential);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a TurnInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.TurnInfo & app.zyno.talk.softphone.TurnInfo.$Shape} TurnInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TurnInfo.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.TurnInfo();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.turnIp = value;
                                    else
                                        delete message.turnIp;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.turnUsername = value;
                                    else
                                        delete message.turnUsername;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.turnCredential = value;
                                    else
                                        delete message.turnCredential;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a TurnInfo message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TurnInfo.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.turnIp != null && $Object.hasOwnProperty.call(message, "turnIp"))
                            if (!$util.isString(message.turnIp))
                                return "turnIp: string expected";
                        if (message.turnUsername != null && $Object.hasOwnProperty.call(message, "turnUsername"))
                            if (!$util.isString(message.turnUsername))
                                return "turnUsername: string expected";
                        if (message.turnCredential != null && $Object.hasOwnProperty.call(message, "turnCredential"))
                            if (!$util.isString(message.turnCredential))
                                return "turnCredential: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for TurnInfo
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.TurnInfo
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    TurnInfo.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.TurnInfo";
                    };

                    return TurnInfo;
                })();

                softphone.CPlaceCallRequest = (function() {

                    /**
                     * Properties of a CPlaceCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CPlaceCallRequest.$Properties
                     * @property {string|null} [extensionId] CPlaceCallRequest extensionId
                     * @property {string|null} [destination] CPlaceCallRequest destination
                     * @property {string|null} [authToken] CPlaceCallRequest authToken
                     * @property {string|null} [consultationOfCallId] CPlaceCallRequest consultationOfCallId
                     * @property {string|null} [listenToken] CPlaceCallRequest listenToken
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CPlaceCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICPlaceCallRequest
                     * @augments app.zyno.talk.softphone.CPlaceCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CPlaceCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CPlaceCallRequest.
                     * @typedef {app.zyno.talk.softphone.CPlaceCallRequest.$Properties} app.zyno.talk.softphone.CPlaceCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CPlaceCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CPlaceCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CPlaceCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CPlaceCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CPlaceCallRequest extensionId.
                     * @member {string} extensionId
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @instance
                     */
                    CPlaceCallRequest.prototype.extensionId = "";

                    /**
                     * CPlaceCallRequest destination.
                     * @member {string} destination
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @instance
                     */
                    CPlaceCallRequest.prototype.destination = "";

                    /**
                     * CPlaceCallRequest authToken.
                     * @member {string} authToken
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @instance
                     */
                    CPlaceCallRequest.prototype.authToken = "";

                    /**
                     * CPlaceCallRequest consultationOfCallId.
                     * @member {string|null|undefined} consultationOfCallId
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @instance
                     */
                    CPlaceCallRequest.prototype.consultationOfCallId = null;

                    /**
                     * CPlaceCallRequest listenToken.
                     * @member {string|null|undefined} listenToken
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @instance
                     */
                    CPlaceCallRequest.prototype.listenToken = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CPlaceCallRequest.prototype, "_consultationOfCallId", {
                        get: $util.oneOfGetter($oneOfFields = ["consultationOfCallId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CPlaceCallRequest.prototype, "_listenToken", {
                        get: $util.oneOfGetter($oneOfFields = ["listenToken"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CPlaceCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CPlaceCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CPlaceCallRequest.$Properties} message CPlaceCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CPlaceCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId") && message.extensionId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.extensionId);
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination") && message.destination !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.destination);
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken") && message.authToken !== "")
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.authToken);
                        if (message.consultationOfCallId != null && $Object.hasOwnProperty.call(message, "consultationOfCallId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.consultationOfCallId);
                        if (message.listenToken != null && $Object.hasOwnProperty.call(message, "listenToken"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.listenToken);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CPlaceCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CPlaceCallRequest & app.zyno.talk.softphone.CPlaceCallRequest.$Shape} CPlaceCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CPlaceCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CPlaceCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.extensionId = value;
                                    else
                                        delete message.extensionId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.destination = value;
                                    else
                                        delete message.destination;
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.authToken = value;
                                    else
                                        delete message.authToken;
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.consultationOfCallId = reader.stringVerify();
                                    message._consultationOfCallId = "consultationOfCallId";
                                    continue;
                                }
                            case 7: {
                                    if (wireType !== 2)
                                        break;
                                    message.listenToken = reader.stringVerify();
                                    message._listenToken = "listenToken";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CPlaceCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CPlaceCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination"))
                            if (!$util.isString(message.destination))
                                return "destination: string expected";
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken"))
                            if (!$util.isString(message.authToken))
                                return "authToken: string expected";
                        if (message.consultationOfCallId != null && $Object.hasOwnProperty.call(message, "consultationOfCallId")) {
                            properties._consultationOfCallId = 1;
                            if (!$util.isString(message.consultationOfCallId))
                                return "consultationOfCallId: string expected";
                        }
                        if (message.listenToken != null && $Object.hasOwnProperty.call(message, "listenToken")) {
                            properties._listenToken = 1;
                            if (!$util.isString(message.listenToken))
                                return "listenToken: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CPlaceCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CPlaceCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CPlaceCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CPlaceCallRequest";
                    };

                    return CPlaceCallRequest;
                })();

                softphone.CPickupCallRequest = (function() {

                    /**
                     * Properties of a CPickupCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CPickupCallRequest.$Properties
                     * @property {string|null} [callId] CPickupCallRequest callId
                     * @property {string|null} [extensionId] CPickupCallRequest extensionId
                     * @property {string|null} [targetExtensionId] CPickupCallRequest targetExtensionId
                     * @property {string|null} [authToken] CPickupCallRequest authToken
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CPickupCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICPickupCallRequest
                     * @augments app.zyno.talk.softphone.CPickupCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CPickupCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CPickupCallRequest.
                     * @typedef {app.zyno.talk.softphone.CPickupCallRequest.$Properties} app.zyno.talk.softphone.CPickupCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CPickupCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CPickupCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CPickupCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CPickupCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CPickupCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @instance
                     */
                    CPickupCallRequest.prototype.callId = "";

                    /**
                     * CPickupCallRequest extensionId.
                     * @member {string} extensionId
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @instance
                     */
                    CPickupCallRequest.prototype.extensionId = "";

                    /**
                     * CPickupCallRequest targetExtensionId.
                     * @member {string} targetExtensionId
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @instance
                     */
                    CPickupCallRequest.prototype.targetExtensionId = "";

                    /**
                     * CPickupCallRequest authToken.
                     * @member {string} authToken
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @instance
                     */
                    CPickupCallRequest.prototype.authToken = "";

                    /**
                     * Encodes the specified CPickupCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CPickupCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CPickupCallRequest.$Properties} message CPickupCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CPickupCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId") && message.extensionId !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.extensionId);
                        if (message.targetExtensionId != null && $Object.hasOwnProperty.call(message, "targetExtensionId") && message.targetExtensionId !== "")
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetExtensionId);
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken") && message.authToken !== "")
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.authToken);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CPickupCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CPickupCallRequest & app.zyno.talk.softphone.CPickupCallRequest.$Shape} CPickupCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CPickupCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CPickupCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.extensionId = value;
                                    else
                                        delete message.extensionId;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.targetExtensionId = value;
                                    else
                                        delete message.targetExtensionId;
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.authToken = value;
                                    else
                                        delete message.authToken;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CPickupCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CPickupCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        if (message.targetExtensionId != null && $Object.hasOwnProperty.call(message, "targetExtensionId"))
                            if (!$util.isString(message.targetExtensionId))
                                return "targetExtensionId: string expected";
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken"))
                            if (!$util.isString(message.authToken))
                                return "authToken: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CPickupCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CPickupCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CPickupCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CPickupCallRequest";
                    };

                    return CPickupCallRequest;
                })();

                softphone.CRetrieveParkedCallRequest = (function() {

                    /**
                     * Properties of a CRetrieveParkedCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties
                     * @property {string|null} [callId] CRetrieveParkedCallRequest callId
                     * @property {string|null} [extensionId] CRetrieveParkedCallRequest extensionId
                     * @property {string|null} [parkingLotId] CRetrieveParkedCallRequest parkingLotId
                     * @property {string|null} [parkingInstanceId] CRetrieveParkedCallRequest parkingInstanceId
                     * @property {string|null} [authToken] CRetrieveParkedCallRequest authToken
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CRetrieveParkedCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICRetrieveParkedCallRequest
                     * @augments app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CRetrieveParkedCallRequest.
                     * @typedef {app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties} app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CRetrieveParkedCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CRetrieveParkedCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CRetrieveParkedCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CRetrieveParkedCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @instance
                     */
                    CRetrieveParkedCallRequest.prototype.callId = "";

                    /**
                     * CRetrieveParkedCallRequest extensionId.
                     * @member {string} extensionId
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @instance
                     */
                    CRetrieveParkedCallRequest.prototype.extensionId = "";

                    /**
                     * CRetrieveParkedCallRequest parkingLotId.
                     * @member {string} parkingLotId
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @instance
                     */
                    CRetrieveParkedCallRequest.prototype.parkingLotId = "";

                    /**
                     * CRetrieveParkedCallRequest parkingInstanceId.
                     * @member {string} parkingInstanceId
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @instance
                     */
                    CRetrieveParkedCallRequest.prototype.parkingInstanceId = "";

                    /**
                     * CRetrieveParkedCallRequest authToken.
                     * @member {string} authToken
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @instance
                     */
                    CRetrieveParkedCallRequest.prototype.authToken = "";

                    /**
                     * Encodes the specified CRetrieveParkedCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CRetrieveParkedCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties} message CRetrieveParkedCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CRetrieveParkedCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId") && message.extensionId !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.extensionId);
                        if (message.parkingLotId != null && $Object.hasOwnProperty.call(message, "parkingLotId") && message.parkingLotId !== "")
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.parkingLotId);
                        if (message.parkingInstanceId != null && $Object.hasOwnProperty.call(message, "parkingInstanceId") && message.parkingInstanceId !== "")
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.parkingInstanceId);
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken") && message.authToken !== "")
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.authToken);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CRetrieveParkedCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CRetrieveParkedCallRequest & app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Shape} CRetrieveParkedCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CRetrieveParkedCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CRetrieveParkedCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.extensionId = value;
                                    else
                                        delete message.extensionId;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.parkingLotId = value;
                                    else
                                        delete message.parkingLotId;
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.parkingInstanceId = value;
                                    else
                                        delete message.parkingInstanceId;
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.authToken = value;
                                    else
                                        delete message.authToken;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CRetrieveParkedCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CRetrieveParkedCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        if (message.parkingLotId != null && $Object.hasOwnProperty.call(message, "parkingLotId"))
                            if (!$util.isString(message.parkingLotId))
                                return "parkingLotId: string expected";
                        if (message.parkingInstanceId != null && $Object.hasOwnProperty.call(message, "parkingInstanceId"))
                            if (!$util.isString(message.parkingInstanceId))
                                return "parkingInstanceId: string expected";
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken"))
                            if (!$util.isString(message.authToken))
                                return "authToken: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CRetrieveParkedCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CRetrieveParkedCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CRetrieveParkedCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CRetrieveParkedCallRequest";
                    };

                    return CRetrieveParkedCallRequest;
                })();

                softphone.CTargetAttachmentRequest = (function() {

                    /**
                     * Properties of a CTargetAttachmentRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties
                     * @property {string|null} [callId] CTargetAttachmentRequest callId
                     * @property {string|null} [extensionId] CTargetAttachmentRequest extensionId
                     * @property {string|null} [setupId] CTargetAttachmentRequest setupId
                     * @property {string|null} [authToken] CTargetAttachmentRequest authToken
                     * @property {string|null} [answerSdp] CTargetAttachmentRequest answerSdp
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CTargetAttachmentRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICTargetAttachmentRequest
                     * @augments app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CTargetAttachmentRequest.
                     * @typedef {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties} app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape
                     */

                    /**
                     * Constructs a new CTargetAttachmentRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CTargetAttachmentRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CTargetAttachmentRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CTargetAttachmentRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @instance
                     */
                    CTargetAttachmentRequest.prototype.callId = "";

                    /**
                     * CTargetAttachmentRequest extensionId.
                     * @member {string} extensionId
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @instance
                     */
                    CTargetAttachmentRequest.prototype.extensionId = "";

                    /**
                     * CTargetAttachmentRequest setupId.
                     * @member {string} setupId
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @instance
                     */
                    CTargetAttachmentRequest.prototype.setupId = "";

                    /**
                     * CTargetAttachmentRequest authToken.
                     * @member {string} authToken
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @instance
                     */
                    CTargetAttachmentRequest.prototype.authToken = "";

                    /**
                     * CTargetAttachmentRequest answerSdp.
                     * @member {string|null|undefined} answerSdp
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @instance
                     */
                    CTargetAttachmentRequest.prototype.answerSdp = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTargetAttachmentRequest.prototype, "_answerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["answerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CTargetAttachmentRequest message. Does not implicitly {@link app.zyno.talk.softphone.CTargetAttachmentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties} message CTargetAttachmentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CTargetAttachmentRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId") && message.extensionId !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.extensionId);
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId") && message.setupId !== "")
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.setupId);
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken") && message.authToken !== "")
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.authToken);
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.answerSdp);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CTargetAttachmentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CTargetAttachmentRequest & app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape} CTargetAttachmentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CTargetAttachmentRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CTargetAttachmentRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.extensionId = value;
                                    else
                                        delete message.extensionId;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.setupId = value;
                                    else
                                        delete message.setupId;
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.authToken = value;
                                    else
                                        delete message.authToken;
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.answerSdp = reader.stringVerify();
                                    message._answerSdp = "answerSdp";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CTargetAttachmentRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CTargetAttachmentRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId"))
                            if (!$util.isString(message.setupId))
                                return "setupId: string expected";
                        if (message.authToken != null && $Object.hasOwnProperty.call(message, "authToken"))
                            if (!$util.isString(message.authToken))
                                return "authToken: string expected";
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp")) {
                            properties._answerSdp = 1;
                            if (!$util.isString(message.answerSdp))
                                return "answerSdp: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CTargetAttachmentRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CTargetAttachmentRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CTargetAttachmentRequest";
                    };

                    return CTargetAttachmentRequest;
                })();

                softphone.CTargetAttachmentResponse = (function() {

                    /**
                     * Properties of a CTargetAttachmentResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties
                     * @property {string|null} [callId] CTargetAttachmentResponse callId
                     * @property {string|null} [setupId] CTargetAttachmentResponse setupId
                     * @property {string|null} [status] CTargetAttachmentResponse status
                     * @property {string|null} [offerSdp] CTargetAttachmentResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CTargetAttachmentResponse turnInfo
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CTargetAttachmentResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICTargetAttachmentResponse
                     * @augments app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CTargetAttachmentResponse.
                     * @typedef {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties} app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape
                     */

                    /**
                     * Constructs a new CTargetAttachmentResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CTargetAttachmentResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CTargetAttachmentResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CTargetAttachmentResponse callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @instance
                     */
                    CTargetAttachmentResponse.prototype.callId = "";

                    /**
                     * CTargetAttachmentResponse setupId.
                     * @member {string} setupId
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @instance
                     */
                    CTargetAttachmentResponse.prototype.setupId = "";

                    /**
                     * CTargetAttachmentResponse status.
                     * @member {string} status
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @instance
                     */
                    CTargetAttachmentResponse.prototype.status = "";

                    /**
                     * CTargetAttachmentResponse offerSdp.
                     * @member {string|null|undefined} offerSdp
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @instance
                     */
                    CTargetAttachmentResponse.prototype.offerSdp = null;

                    /**
                     * CTargetAttachmentResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @instance
                     */
                    CTargetAttachmentResponse.prototype.turnInfo = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTargetAttachmentResponse.prototype, "_offerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["offerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTargetAttachmentResponse.prototype, "_turnInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["turnInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CTargetAttachmentResponse message. Does not implicitly {@link app.zyno.talk.softphone.CTargetAttachmentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties} message CTargetAttachmentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CTargetAttachmentResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId") && message.setupId !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.setupId);
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status") && message.status !== "")
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.status);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CTargetAttachmentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CTargetAttachmentResponse & app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape} CTargetAttachmentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CTargetAttachmentResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CTargetAttachmentResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.setupId = value;
                                    else
                                        delete message.setupId;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.status = value;
                                    else
                                        delete message.status;
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.offerSdp = reader.stringVerify();
                                    message._offerSdp = "offerSdp";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    message._turnInfo = "turnInfo";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CTargetAttachmentResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CTargetAttachmentResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId"))
                            if (!$util.isString(message.setupId))
                                return "setupId: string expected";
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status"))
                            if (!$util.isString(message.status))
                                return "status: string expected";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp")) {
                            properties._offerSdp = 1;
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        }
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            properties._turnInfo = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                                if (error)
                                    return "turnInfo." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CTargetAttachmentResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CTargetAttachmentResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CTargetAttachmentResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CTargetAttachmentResponse";
                    };

                    return CTargetAttachmentResponse;
                })();

                softphone.CPlaceCallResponse = (function() {

                    /**
                     * Properties of a CPlaceCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CPlaceCallResponse.$Properties
                     * @property {string|null} [callId] CPlaceCallResponse callId
                     * @property {string|null} [offerSdp] CPlaceCallResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CPlaceCallResponse turnInfo
                     * @property {string|null} [setupId] CPlaceCallResponse setupId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CPlaceCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICPlaceCallResponse
                     * @augments app.zyno.talk.softphone.CPlaceCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CPlaceCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CPlaceCallResponse.
                     * @typedef {app.zyno.talk.softphone.CPlaceCallResponse.$Properties} app.zyno.talk.softphone.CPlaceCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CPlaceCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CPlaceCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CPlaceCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CPlaceCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CPlaceCallResponse callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @instance
                     */
                    CPlaceCallResponse.prototype.callId = "";

                    /**
                     * CPlaceCallResponse offerSdp.
                     * @member {string} offerSdp
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @instance
                     */
                    CPlaceCallResponse.prototype.offerSdp = "";

                    /**
                     * CPlaceCallResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @instance
                     */
                    CPlaceCallResponse.prototype.turnInfo = null;

                    /**
                     * CPlaceCallResponse setupId.
                     * @member {string|null|undefined} setupId
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @instance
                     */
                    CPlaceCallResponse.prototype.setupId = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CPlaceCallResponse.prototype, "_setupId", {
                        get: $util.oneOfGetter($oneOfFields = ["setupId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CPlaceCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CPlaceCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CPlaceCallResponse.$Properties} message CPlaceCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CPlaceCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp") && message.offerSdp !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.setupId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CPlaceCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CPlaceCallResponse & app.zyno.talk.softphone.CPlaceCallResponse.$Shape} CPlaceCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CPlaceCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CPlaceCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.offerSdp = value;
                                    else
                                        delete message.offerSdp;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.setupId = reader.stringVerify();
                                    message._setupId = "setupId";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CPlaceCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CPlaceCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                            if (error)
                                return "turnInfo." + error;
                        }
                        if (message.setupId != null && $Object.hasOwnProperty.call(message, "setupId")) {
                            properties._setupId = 1;
                            if (!$util.isString(message.setupId))
                                return "setupId: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CPlaceCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CPlaceCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CPlaceCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CPlaceCallResponse";
                    };

                    return CPlaceCallResponse;
                })();

                softphone.CPlaceAiAgentTestCallRequest = (function() {

                    /**
                     * Properties of a CPlaceAiAgentTestCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties
                     * @property {string|null} [destination] CPlaceAiAgentTestCallRequest destination
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CPlaceAiAgentTestCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICPlaceAiAgentTestCallRequest
                     * @augments app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CPlaceAiAgentTestCallRequest.
                     * @typedef {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties} app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CPlaceAiAgentTestCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CPlaceAiAgentTestCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CPlaceAiAgentTestCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CPlaceAiAgentTestCallRequest destination.
                     * @member {string} destination
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest
                     * @instance
                     */
                    CPlaceAiAgentTestCallRequest.prototype.destination = "";

                    /**
                     * Encodes the specified CPlaceAiAgentTestCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties} message CPlaceAiAgentTestCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CPlaceAiAgentTestCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination") && message.destination !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.destination);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CPlaceAiAgentTestCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest & app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Shape} CPlaceAiAgentTestCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CPlaceAiAgentTestCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.destination = value;
                                    else
                                        delete message.destination;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CPlaceAiAgentTestCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CPlaceAiAgentTestCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination"))
                            if (!$util.isString(message.destination))
                                return "destination: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CPlaceAiAgentTestCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CPlaceAiAgentTestCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest";
                    };

                    return CPlaceAiAgentTestCallRequest;
                })();

                softphone.CPlaceAiAgentTestCallResponse = (function() {

                    /**
                     * Properties of a CPlaceAiAgentTestCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties
                     * @property {string|null} [callId] CPlaceAiAgentTestCallResponse callId
                     * @property {string|null} [offerSdp] CPlaceAiAgentTestCallResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CPlaceAiAgentTestCallResponse turnInfo
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CPlaceAiAgentTestCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICPlaceAiAgentTestCallResponse
                     * @augments app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CPlaceAiAgentTestCallResponse.
                     * @typedef {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties} app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CPlaceAiAgentTestCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CPlaceAiAgentTestCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CPlaceAiAgentTestCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CPlaceAiAgentTestCallResponse callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @instance
                     */
                    CPlaceAiAgentTestCallResponse.prototype.callId = "";

                    /**
                     * CPlaceAiAgentTestCallResponse offerSdp.
                     * @member {string} offerSdp
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @instance
                     */
                    CPlaceAiAgentTestCallResponse.prototype.offerSdp = "";

                    /**
                     * CPlaceAiAgentTestCallResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @instance
                     */
                    CPlaceAiAgentTestCallResponse.prototype.turnInfo = null;

                    /**
                     * Encodes the specified CPlaceAiAgentTestCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties} message CPlaceAiAgentTestCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CPlaceAiAgentTestCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp") && message.offerSdp !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CPlaceAiAgentTestCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse & app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Shape} CPlaceAiAgentTestCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CPlaceAiAgentTestCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.offerSdp = value;
                                    else
                                        delete message.offerSdp;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CPlaceAiAgentTestCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CPlaceAiAgentTestCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                            if (error)
                                return "turnInfo." + error;
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CPlaceAiAgentTestCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CPlaceAiAgentTestCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse";
                    };

                    return CPlaceAiAgentTestCallResponse;
                })();

                softphone.CAcceptCallRequest = (function() {

                    /**
                     * Properties of a CAcceptCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CAcceptCallRequest.$Properties
                     * @property {string|null} [callId] CAcceptCallRequest callId
                     * @property {string|null} [answerSdp] CAcceptCallRequest answerSdp
                     * @property {string|null} [deviceId] CAcceptCallRequest deviceId
                     * @property {string|null} [extensionId] CAcceptCallRequest extensionId
                     * @property {string|null} [notificationId] CAcceptCallRequest notificationId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CAcceptCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICAcceptCallRequest
                     * @augments app.zyno.talk.softphone.CAcceptCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CAcceptCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CAcceptCallRequest.
                     * @typedef {app.zyno.talk.softphone.CAcceptCallRequest.$Properties} app.zyno.talk.softphone.CAcceptCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CAcceptCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CAcceptCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CAcceptCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CAcceptCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CAcceptCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @instance
                     */
                    CAcceptCallRequest.prototype.callId = "";

                    /**
                     * CAcceptCallRequest answerSdp.
                     * @member {string|null|undefined} answerSdp
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @instance
                     */
                    CAcceptCallRequest.prototype.answerSdp = null;

                    /**
                     * CAcceptCallRequest deviceId.
                     * @member {string|null|undefined} deviceId
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @instance
                     */
                    CAcceptCallRequest.prototype.deviceId = null;

                    /**
                     * CAcceptCallRequest extensionId.
                     * @member {string|null|undefined} extensionId
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @instance
                     */
                    CAcceptCallRequest.prototype.extensionId = null;

                    /**
                     * CAcceptCallRequest notificationId.
                     * @member {string|null|undefined} notificationId
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @instance
                     */
                    CAcceptCallRequest.prototype.notificationId = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallRequest.prototype, "_answerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["answerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallRequest.prototype, "_deviceId", {
                        get: $util.oneOfGetter($oneOfFields = ["deviceId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallRequest.prototype, "_extensionId", {
                        get: $util.oneOfGetter($oneOfFields = ["extensionId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallRequest.prototype, "_notificationId", {
                        get: $util.oneOfGetter($oneOfFields = ["notificationId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CAcceptCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CAcceptCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CAcceptCallRequest.$Properties} message CAcceptCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CAcceptCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.answerSdp);
                        if (message.deviceId != null && $Object.hasOwnProperty.call(message, "deviceId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.extensionId);
                        if (message.notificationId != null && $Object.hasOwnProperty.call(message, "notificationId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.notificationId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CAcceptCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CAcceptCallRequest & app.zyno.talk.softphone.CAcceptCallRequest.$Shape} CAcceptCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CAcceptCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CAcceptCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    message.answerSdp = reader.stringVerify();
                                    message._answerSdp = "answerSdp";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.deviceId = reader.stringVerify();
                                    message._deviceId = "deviceId";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.extensionId = reader.stringVerify();
                                    message._extensionId = "extensionId";
                                    continue;
                                }
                            case 7: {
                                    if (wireType !== 2)
                                        break;
                                    message.notificationId = reader.stringVerify();
                                    message._notificationId = "notificationId";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CAcceptCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CAcceptCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp")) {
                            properties._answerSdp = 1;
                            if (!$util.isString(message.answerSdp))
                                return "answerSdp: string expected";
                        }
                        if (message.deviceId != null && $Object.hasOwnProperty.call(message, "deviceId")) {
                            properties._deviceId = 1;
                            if (!$util.isString(message.deviceId))
                                return "deviceId: string expected";
                        }
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId")) {
                            properties._extensionId = 1;
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        }
                        if (message.notificationId != null && $Object.hasOwnProperty.call(message, "notificationId")) {
                            properties._notificationId = 1;
                            if (!$util.isString(message.notificationId))
                                return "notificationId: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CAcceptCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CAcceptCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CAcceptCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CAcceptCallRequest";
                    };

                    return CAcceptCallRequest;
                })();

                softphone.CAcceptCallResponse = (function() {

                    /**
                     * Properties of a CAcceptCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CAcceptCallResponse.$Properties
                     * @property {string|null} [offerSdp] CAcceptCallResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CAcceptCallResponse turnInfo
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CAcceptCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICAcceptCallResponse
                     * @augments app.zyno.talk.softphone.CAcceptCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CAcceptCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CAcceptCallResponse.
                     * @typedef {app.zyno.talk.softphone.CAcceptCallResponse.$Properties} app.zyno.talk.softphone.CAcceptCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CAcceptCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CAcceptCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CAcceptCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CAcceptCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CAcceptCallResponse offerSdp.
                     * @member {string|null|undefined} offerSdp
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @instance
                     */
                    CAcceptCallResponse.prototype.offerSdp = null;

                    /**
                     * CAcceptCallResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @instance
                     */
                    CAcceptCallResponse.prototype.turnInfo = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallResponse.prototype, "_offerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["offerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CAcceptCallResponse.prototype, "_turnInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["turnInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CAcceptCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CAcceptCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CAcceptCallResponse.$Properties} message CAcceptCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CAcceptCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CAcceptCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CAcceptCallResponse & app.zyno.talk.softphone.CAcceptCallResponse.$Shape} CAcceptCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CAcceptCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CAcceptCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    message.offerSdp = reader.stringVerify();
                                    message._offerSdp = "offerSdp";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    message._turnInfo = "turnInfo";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CAcceptCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CAcceptCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp")) {
                            properties._offerSdp = 1;
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        }
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            properties._turnInfo = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                                if (error)
                                    return "turnInfo." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CAcceptCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CAcceptCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CAcceptCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CAcceptCallResponse";
                    };

                    return CAcceptCallResponse;
                })();

                softphone.CSubmitAnswerRequest = (function() {

                    /**
                     * Properties of a CSubmitAnswerRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties
                     * @property {string|null} [callId] CSubmitAnswerRequest callId
                     * @property {string|null} [answerSdp] CSubmitAnswerRequest answerSdp
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CSubmitAnswerRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICSubmitAnswerRequest
                     * @augments app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CSubmitAnswerRequest.
                     * @typedef {app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties} app.zyno.talk.softphone.CSubmitAnswerRequest.$Shape
                     */

                    /**
                     * Constructs a new CSubmitAnswerRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CSubmitAnswerRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CSubmitAnswerRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CSubmitAnswerRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @instance
                     */
                    CSubmitAnswerRequest.prototype.callId = "";

                    /**
                     * CSubmitAnswerRequest answerSdp.
                     * @member {string} answerSdp
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @instance
                     */
                    CSubmitAnswerRequest.prototype.answerSdp = "";

                    /**
                     * Encodes the specified CSubmitAnswerRequest message. Does not implicitly {@link app.zyno.talk.softphone.CSubmitAnswerRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties} message CSubmitAnswerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CSubmitAnswerRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp") && message.answerSdp !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.answerSdp);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CSubmitAnswerRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CSubmitAnswerRequest & app.zyno.talk.softphone.CSubmitAnswerRequest.$Shape} CSubmitAnswerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CSubmitAnswerRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CSubmitAnswerRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.answerSdp = value;
                                    else
                                        delete message.answerSdp;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CSubmitAnswerRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CSubmitAnswerRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp"))
                            if (!$util.isString(message.answerSdp))
                                return "answerSdp: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CSubmitAnswerRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CSubmitAnswerRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CSubmitAnswerRequest";
                    };

                    return CSubmitAnswerRequest;
                })();

                softphone.CSubmitAnswerResponse = (function() {

                    /**
                     * Properties of a CSubmitAnswerResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CSubmitAnswerResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICSubmitAnswerResponse
                     * @augments app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CSubmitAnswerResponse.
                     * @typedef {app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties} app.zyno.talk.softphone.CSubmitAnswerResponse.$Shape
                     */

                    /**
                     * Constructs a new CSubmitAnswerResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CSubmitAnswerResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CSubmitAnswerResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified CSubmitAnswerResponse message. Does not implicitly {@link app.zyno.talk.softphone.CSubmitAnswerResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties} message CSubmitAnswerResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CSubmitAnswerResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CSubmitAnswerResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CSubmitAnswerResponse & app.zyno.talk.softphone.CSubmitAnswerResponse.$Shape} CSubmitAnswerResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CSubmitAnswerResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CSubmitAnswerResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CSubmitAnswerResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CSubmitAnswerResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for CSubmitAnswerResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CSubmitAnswerResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CSubmitAnswerResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CSubmitAnswerResponse";
                    };

                    return CSubmitAnswerResponse;
                })();

                softphone.CRequestIceRestartRequest = (function() {

                    /**
                     * Properties of a CRequestIceRestartRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties
                     * @property {string|null} [callId] CRequestIceRestartRequest callId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CRequestIceRestartRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICRequestIceRestartRequest
                     * @augments app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CRequestIceRestartRequest.
                     * @typedef {app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties} app.zyno.talk.softphone.CRequestIceRestartRequest.$Shape
                     */

                    /**
                     * Constructs a new CRequestIceRestartRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CRequestIceRestartRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CRequestIceRestartRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CRequestIceRestartRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartRequest
                     * @instance
                     */
                    CRequestIceRestartRequest.prototype.callId = "";

                    /**
                     * Encodes the specified CRequestIceRestartRequest message. Does not implicitly {@link app.zyno.talk.softphone.CRequestIceRestartRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties} message CRequestIceRestartRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CRequestIceRestartRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CRequestIceRestartRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CRequestIceRestartRequest & app.zyno.talk.softphone.CRequestIceRestartRequest.$Shape} CRequestIceRestartRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CRequestIceRestartRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CRequestIceRestartRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CRequestIceRestartRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CRequestIceRestartRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CRequestIceRestartRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CRequestIceRestartRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CRequestIceRestartRequest";
                    };

                    return CRequestIceRestartRequest;
                })();

                softphone.CRequestIceRestartResponse = (function() {

                    /**
                     * Properties of a CRequestIceRestartResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties
                     * @property {string|null} [offerSdp] CRequestIceRestartResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CRequestIceRestartResponse turnInfo
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CRequestIceRestartResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICRequestIceRestartResponse
                     * @augments app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CRequestIceRestartResponse.
                     * @typedef {app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties} app.zyno.talk.softphone.CRequestIceRestartResponse.$Shape
                     */

                    /**
                     * Constructs a new CRequestIceRestartResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CRequestIceRestartResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CRequestIceRestartResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CRequestIceRestartResponse offerSdp.
                     * @member {string} offerSdp
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @instance
                     */
                    CRequestIceRestartResponse.prototype.offerSdp = "";

                    /**
                     * CRequestIceRestartResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @instance
                     */
                    CRequestIceRestartResponse.prototype.turnInfo = null;

                    /**
                     * Encodes the specified CRequestIceRestartResponse message. Does not implicitly {@link app.zyno.talk.softphone.CRequestIceRestartResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties} message CRequestIceRestartResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CRequestIceRestartResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp") && message.offerSdp !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CRequestIceRestartResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CRequestIceRestartResponse & app.zyno.talk.softphone.CRequestIceRestartResponse.$Shape} CRequestIceRestartResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CRequestIceRestartResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CRequestIceRestartResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.offerSdp = value;
                                    else
                                        delete message.offerSdp;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CRequestIceRestartResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CRequestIceRestartResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                            if (error)
                                return "turnInfo." + error;
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CRequestIceRestartResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CRequestIceRestartResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CRequestIceRestartResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CRequestIceRestartResponse";
                    };

                    return CRequestIceRestartResponse;
                })();

                softphone.CRequestMediaReplacementRequest = (function() {

                    /**
                     * Properties of a CRequestMediaReplacementRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties
                     * @property {string|null} [callId] CRequestMediaReplacementRequest callId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CRequestMediaReplacementRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICRequestMediaReplacementRequest
                     * @augments app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CRequestMediaReplacementRequest.
                     * @typedef {app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties} app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Shape
                     */

                    /**
                     * Constructs a new CRequestMediaReplacementRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CRequestMediaReplacementRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CRequestMediaReplacementRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CRequestMediaReplacementRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementRequest
                     * @instance
                     */
                    CRequestMediaReplacementRequest.prototype.callId = "";

                    /**
                     * Encodes the specified CRequestMediaReplacementRequest message. Does not implicitly {@link app.zyno.talk.softphone.CRequestMediaReplacementRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties} message CRequestMediaReplacementRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CRequestMediaReplacementRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CRequestMediaReplacementRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CRequestMediaReplacementRequest & app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Shape} CRequestMediaReplacementRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CRequestMediaReplacementRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CRequestMediaReplacementRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CRequestMediaReplacementRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CRequestMediaReplacementRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CRequestMediaReplacementRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CRequestMediaReplacementRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CRequestMediaReplacementRequest";
                    };

                    return CRequestMediaReplacementRequest;
                })();

                softphone.CRequestMediaReplacementResponse = (function() {

                    /**
                     * Properties of a CRequestMediaReplacementResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties
                     * @property {string|null} [offerSdp] CRequestMediaReplacementResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CRequestMediaReplacementResponse turnInfo
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CRequestMediaReplacementResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICRequestMediaReplacementResponse
                     * @augments app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CRequestMediaReplacementResponse.
                     * @typedef {app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties} app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Shape
                     */

                    /**
                     * Constructs a new CRequestMediaReplacementResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CRequestMediaReplacementResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CRequestMediaReplacementResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CRequestMediaReplacementResponse offerSdp.
                     * @member {string} offerSdp
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @instance
                     */
                    CRequestMediaReplacementResponse.prototype.offerSdp = "";

                    /**
                     * CRequestMediaReplacementResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @instance
                     */
                    CRequestMediaReplacementResponse.prototype.turnInfo = null;

                    /**
                     * Encodes the specified CRequestMediaReplacementResponse message. Does not implicitly {@link app.zyno.talk.softphone.CRequestMediaReplacementResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties} message CRequestMediaReplacementResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CRequestMediaReplacementResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp") && message.offerSdp !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CRequestMediaReplacementResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CRequestMediaReplacementResponse & app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Shape} CRequestMediaReplacementResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CRequestMediaReplacementResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CRequestMediaReplacementResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.offerSdp = value;
                                    else
                                        delete message.offerSdp;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CRequestMediaReplacementResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CRequestMediaReplacementResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                            if (error)
                                return "turnInfo." + error;
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CRequestMediaReplacementResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CRequestMediaReplacementResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CRequestMediaReplacementResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CRequestMediaReplacementResponse";
                    };

                    return CRequestMediaReplacementResponse;
                })();

                softphone.CEndCallRequest = (function() {

                    /**
                     * Properties of a CEndCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CEndCallRequest.$Properties
                     * @property {string|null} [callId] CEndCallRequest callId
                     * @property {app.zyno.talk.softphone.CallEndReason|null} [reason] CEndCallRequest reason
                     * @property {string|null} [notificationId] CEndCallRequest notificationId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CEndCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICEndCallRequest
                     * @augments app.zyno.talk.softphone.CEndCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CEndCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CEndCallRequest.
                     * @typedef {app.zyno.talk.softphone.CEndCallRequest.$Properties} app.zyno.talk.softphone.CEndCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CEndCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CEndCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CEndCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CEndCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CEndCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @instance
                     */
                    CEndCallRequest.prototype.callId = "";

                    /**
                     * CEndCallRequest reason.
                     * @member {app.zyno.talk.softphone.CallEndReason|null|undefined} reason
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @instance
                     */
                    CEndCallRequest.prototype.reason = null;

                    /**
                     * CEndCallRequest notificationId.
                     * @member {string|null|undefined} notificationId
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @instance
                     */
                    CEndCallRequest.prototype.notificationId = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CEndCallRequest.prototype, "_reason", {
                        get: $util.oneOfGetter($oneOfFields = ["reason"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CEndCallRequest.prototype, "_notificationId", {
                        get: $util.oneOfGetter($oneOfFields = ["notificationId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CEndCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CEndCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CEndCallRequest.$Properties} message CEndCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CEndCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.reason != null && $Object.hasOwnProperty.call(message, "reason"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.reason);
                        if (message.notificationId != null && $Object.hasOwnProperty.call(message, "notificationId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.notificationId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CEndCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CEndCallRequest & app.zyno.talk.softphone.CEndCallRequest.$Shape} CEndCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CEndCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CEndCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    message.reason = reader.int32();
                                    message._reason = "reason";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.notificationId = reader.stringVerify();
                                    message._notificationId = "notificationId";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CEndCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CEndCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.reason != null && $Object.hasOwnProperty.call(message, "reason")) {
                            properties._reason = 1;
                            if (typeof message.reason !== "number" || (message.reason | 0) !== message.reason)
                                return "reason: enum value expected";
                        }
                        if (message.notificationId != null && $Object.hasOwnProperty.call(message, "notificationId")) {
                            properties._notificationId = 1;
                            if (!$util.isString(message.notificationId))
                                return "notificationId: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CEndCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CEndCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CEndCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CEndCallRequest";
                    };

                    return CEndCallRequest;
                })();

                softphone.CEndCallResponse = (function() {

                    /**
                     * Properties of a CEndCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CEndCallResponse.$Properties
                     * @property {boolean|null} [reconnectInitiated] CEndCallResponse reconnectInitiated
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CEndCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICEndCallResponse
                     * @augments app.zyno.talk.softphone.CEndCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CEndCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CEndCallResponse.
                     * @typedef {app.zyno.talk.softphone.CEndCallResponse.$Properties} app.zyno.talk.softphone.CEndCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CEndCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CEndCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CEndCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CEndCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CEndCallResponse reconnectInitiated.
                     * @member {boolean|null|undefined} reconnectInitiated
                     * @memberof app.zyno.talk.softphone.CEndCallResponse
                     * @instance
                     */
                    CEndCallResponse.prototype.reconnectInitiated = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CEndCallResponse.prototype, "_reconnectInitiated", {
                        get: $util.oneOfGetter($oneOfFields = ["reconnectInitiated"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CEndCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CEndCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CEndCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CEndCallResponse.$Properties} message CEndCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CEndCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.reconnectInitiated != null && $Object.hasOwnProperty.call(message, "reconnectInitiated"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.reconnectInitiated);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CEndCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CEndCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CEndCallResponse & app.zyno.talk.softphone.CEndCallResponse.$Shape} CEndCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CEndCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CEndCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 0)
                                        break;
                                    message.reconnectInitiated = reader.bool();
                                    message._reconnectInitiated = "reconnectInitiated";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CEndCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CEndCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CEndCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.reconnectInitiated != null && $Object.hasOwnProperty.call(message, "reconnectInitiated")) {
                            properties._reconnectInitiated = 1;
                            if (typeof message.reconnectInitiated !== "boolean")
                                return "reconnectInitiated: boolean expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CEndCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CEndCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CEndCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CEndCallResponse";
                    };

                    return CEndCallResponse;
                })();

                softphone.CReattachCallSessionRequest = (function() {

                    /**
                     * Properties of a CReattachCallSessionRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties
                     * @property {string|null} [callId] CReattachCallSessionRequest callId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CReattachCallSessionRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICReattachCallSessionRequest
                     * @augments app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CReattachCallSessionRequest.
                     * @typedef {app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties} app.zyno.talk.softphone.CReattachCallSessionRequest.$Shape
                     */

                    /**
                     * Constructs a new CReattachCallSessionRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CReattachCallSessionRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CReattachCallSessionRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CReattachCallSessionRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionRequest
                     * @instance
                     */
                    CReattachCallSessionRequest.prototype.callId = "";

                    /**
                     * Encodes the specified CReattachCallSessionRequest message. Does not implicitly {@link app.zyno.talk.softphone.CReattachCallSessionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties} message CReattachCallSessionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CReattachCallSessionRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CReattachCallSessionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CReattachCallSessionRequest & app.zyno.talk.softphone.CReattachCallSessionRequest.$Shape} CReattachCallSessionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CReattachCallSessionRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CReattachCallSessionRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CReattachCallSessionRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CReattachCallSessionRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CReattachCallSessionRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CReattachCallSessionRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CReattachCallSessionRequest";
                    };

                    return CReattachCallSessionRequest;
                })();

                softphone.CReattachCallSessionResponse = (function() {

                    /**
                     * Properties of a CReattachCallSessionResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties
                     * @property {app.zyno.talk.softphone.CallStatus|null} [status] CReattachCallSessionResponse status
                     * @property {boolean|null} [isHeld] CReattachCallSessionResponse isHeld
                     * @property {app.zyno.talk.softphone.CallPhase|null} [phase] CReattachCallSessionResponse phase
                     * @property {string|null} [offerSdp] CReattachCallSessionResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CReattachCallSessionResponse turnInfo
                     * @property {app.zyno.talk.softphone.RenegotiationKind|null} [offerKind] CReattachCallSessionResponse offerKind
                     * @property {boolean|null} [mediaSuspended] CReattachCallSessionResponse mediaSuspended
                     * @property {string|null} [newCallId] CReattachCallSessionResponse newCallId
                     * @property {string|null} [failureCause] CReattachCallSessionResponse failureCause
                     * @property {string|null} [callerNumber] CReattachCallSessionResponse callerNumber
                     * @property {string|null} [callerName] CReattachCallSessionResponse callerName
                     * @property {Object.<string,string>|null} [popupInfo] CReattachCallSessionResponse popupInfo
                     * @property {boolean|null} [hasPopupInfo] CReattachCallSessionResponse hasPopupInfo
                     * @property {string|null} [transferReason] CReattachCallSessionResponse transferReason
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CReattachCallSessionResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICReattachCallSessionResponse
                     * @augments app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CReattachCallSessionResponse.
                     * @typedef {app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties} app.zyno.talk.softphone.CReattachCallSessionResponse.$Shape
                     */

                    /**
                     * Constructs a new CReattachCallSessionResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CReattachCallSessionResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CReattachCallSessionResponse = function (properties) {
                        this.popupInfo = {};
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CReattachCallSessionResponse status.
                     * @member {app.zyno.talk.softphone.CallStatus|null|undefined} status
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.status = null;

                    /**
                     * CReattachCallSessionResponse isHeld.
                     * @member {boolean|null|undefined} isHeld
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.isHeld = null;

                    /**
                     * CReattachCallSessionResponse phase.
                     * @member {app.zyno.talk.softphone.CallPhase|null|undefined} phase
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.phase = null;

                    /**
                     * CReattachCallSessionResponse offerSdp.
                     * @member {string|null|undefined} offerSdp
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.offerSdp = null;

                    /**
                     * CReattachCallSessionResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.turnInfo = null;

                    /**
                     * CReattachCallSessionResponse offerKind.
                     * @member {app.zyno.talk.softphone.RenegotiationKind|null|undefined} offerKind
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.offerKind = null;

                    /**
                     * CReattachCallSessionResponse mediaSuspended.
                     * @member {boolean|null|undefined} mediaSuspended
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.mediaSuspended = null;

                    /**
                     * CReattachCallSessionResponse newCallId.
                     * @member {string|null|undefined} newCallId
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.newCallId = null;

                    /**
                     * CReattachCallSessionResponse failureCause.
                     * @member {string|null|undefined} failureCause
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.failureCause = null;

                    /**
                     * CReattachCallSessionResponse callerNumber.
                     * @member {string|null|undefined} callerNumber
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.callerNumber = null;

                    /**
                     * CReattachCallSessionResponse callerName.
                     * @member {string|null|undefined} callerName
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.callerName = null;

                    /**
                     * CReattachCallSessionResponse popupInfo.
                     * @member {Object.<string,string>} popupInfo
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.popupInfo = $util.emptyObject;

                    /**
                     * CReattachCallSessionResponse hasPopupInfo.
                     * @member {boolean|null|undefined} hasPopupInfo
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.hasPopupInfo = null;

                    /**
                     * CReattachCallSessionResponse transferReason.
                     * @member {string|null|undefined} transferReason
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @instance
                     */
                    CReattachCallSessionResponse.prototype.transferReason = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_status", {
                        get: $util.oneOfGetter($oneOfFields = ["status"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_isHeld", {
                        get: $util.oneOfGetter($oneOfFields = ["isHeld"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_phase", {
                        get: $util.oneOfGetter($oneOfFields = ["phase"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_offerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["offerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_turnInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["turnInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_offerKind", {
                        get: $util.oneOfGetter($oneOfFields = ["offerKind"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_mediaSuspended", {
                        get: $util.oneOfGetter($oneOfFields = ["mediaSuspended"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_newCallId", {
                        get: $util.oneOfGetter($oneOfFields = ["newCallId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_failureCause", {
                        get: $util.oneOfGetter($oneOfFields = ["failureCause"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_callerNumber", {
                        get: $util.oneOfGetter($oneOfFields = ["callerNumber"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_callerName", {
                        get: $util.oneOfGetter($oneOfFields = ["callerName"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_hasPopupInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["hasPopupInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CReattachCallSessionResponse.prototype, "_transferReason", {
                        get: $util.oneOfGetter($oneOfFields = ["transferReason"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CReattachCallSessionResponse message. Does not implicitly {@link app.zyno.talk.softphone.CReattachCallSessionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties} message CReattachCallSessionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CReattachCallSessionResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isHeld);
                        if (message.phase != null && $Object.hasOwnProperty.call(message, "phase"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.phase);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
                        if (message.offerKind != null && $Object.hasOwnProperty.call(message, "offerKind"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.offerKind);
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.mediaSuspended);
                        if (message.newCallId != null && $Object.hasOwnProperty.call(message, "newCallId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.newCallId);
                        if (message.failureCause != null && $Object.hasOwnProperty.call(message, "failureCause"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.failureCause);
                        if (message.callerNumber != null && $Object.hasOwnProperty.call(message, "callerNumber"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.callerNumber);
                        if (message.callerName != null && $Object.hasOwnProperty.call(message, "callerName"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.callerName);
                        if (message.popupInfo != null && $Object.hasOwnProperty.call(message, "popupInfo"))
                            for (let keys = $Object.keys(message.popupInfo), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 13, wireType 2 =*/106).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.popupInfo[keys[i]]).ldelim();
                        if (message.hasPopupInfo != null && $Object.hasOwnProperty.call(message, "hasPopupInfo"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.hasPopupInfo);
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.transferReason);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CReattachCallSessionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CReattachCallSessionResponse & app.zyno.talk.softphone.CReattachCallSessionResponse.$Shape} CReattachCallSessionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CReattachCallSessionResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, key, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CReattachCallSessionResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 0)
                                        break;
                                    message.status = reader.int32();
                                    message._status = "status";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 0)
                                        break;
                                    message.isHeld = reader.bool();
                                    message._isHeld = "isHeld";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 0)
                                        break;
                                    message.phase = reader.int32();
                                    message._phase = "phase";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.offerSdp = reader.stringVerify();
                                    message._offerSdp = "offerSdp";
                                    continue;
                                }
                            case 6: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    message._turnInfo = "turnInfo";
                                    continue;
                                }
                            case 7: {
                                    if (wireType !== 0)
                                        break;
                                    message.offerKind = reader.int32();
                                    message._offerKind = "offerKind";
                                    continue;
                                }
                            case 8: {
                                    if (wireType !== 0)
                                        break;
                                    message.mediaSuspended = reader.bool();
                                    message._mediaSuspended = "mediaSuspended";
                                    continue;
                                }
                            case 9: {
                                    if (wireType !== 2)
                                        break;
                                    message.newCallId = reader.stringVerify();
                                    message._newCallId = "newCallId";
                                    continue;
                                }
                            case 10: {
                                    if (wireType !== 2)
                                        break;
                                    message.failureCause = reader.stringVerify();
                                    message._failureCause = "failureCause";
                                    continue;
                                }
                            case 11: {
                                    if (wireType !== 2)
                                        break;
                                    message.callerNumber = reader.stringVerify();
                                    message._callerNumber = "callerNumber";
                                    continue;
                                }
                            case 12: {
                                    if (wireType !== 2)
                                        break;
                                    message.callerName = reader.stringVerify();
                                    message._callerName = "callerName";
                                    continue;
                                }
                            case 13: {
                                    if (wireType !== 2)
                                        break;
                                    if (message.popupInfo === $util.emptyObject)
                                        message.popupInfo = {};
                                    let end2 = reader.size() + reader.pos;
                                    if (end2 > reader.len)
                                        throw $RangeError("index out of range");
                                    reader.len = end2;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        let tag2 = reader.tag();
                                        wireType = tag2 & 7;
                                        switch (tag2 >>>= 3) {
                                        case 1:
                                            if (wireType !== 2)
                                                break;
                                            key = reader.stringVerify();
                                            continue;
                                        case 2:
                                            if (wireType !== 2)
                                                break;
                                            value = reader.stringVerify();
                                            continue;
                                        }
                                        reader.skipType(wireType, _depth, tag2);
                                    }
                                    if (reader.pos !== end2)
                                        throw $RangeError("index out of range");
                                    reader.len = end;
                                    if (key === "__proto__")
                                        $util.makeProp(message.popupInfo, key);
                                    message.popupInfo[key] = value;
                                    continue;
                                }
                            case 14: {
                                    if (wireType !== 0)
                                        break;
                                    message.hasPopupInfo = reader.bool();
                                    message._hasPopupInfo = "hasPopupInfo";
                                    continue;
                                }
                            case 15: {
                                    if (wireType !== 2)
                                        break;
                                    message.transferReason = reader.stringVerify();
                                    message._transferReason = "transferReason";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CReattachCallSessionResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CReattachCallSessionResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status")) {
                            properties._status = 1;
                            if (typeof message.status !== "number" || (message.status | 0) !== message.status)
                                return "status: enum value expected";
                        }
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld")) {
                            properties._isHeld = 1;
                            if (typeof message.isHeld !== "boolean")
                                return "isHeld: boolean expected";
                        }
                        if (message.phase != null && $Object.hasOwnProperty.call(message, "phase")) {
                            properties._phase = 1;
                            if (typeof message.phase !== "number" || (message.phase | 0) !== message.phase)
                                return "phase: enum value expected";
                        }
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp")) {
                            properties._offerSdp = 1;
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        }
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            properties._turnInfo = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                                if (error)
                                    return "turnInfo." + error;
                            }
                        }
                        if (message.offerKind != null && $Object.hasOwnProperty.call(message, "offerKind")) {
                            properties._offerKind = 1;
                            if (typeof message.offerKind !== "number" || (message.offerKind | 0) !== message.offerKind)
                                return "offerKind: enum value expected";
                        }
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended")) {
                            properties._mediaSuspended = 1;
                            if (typeof message.mediaSuspended !== "boolean")
                                return "mediaSuspended: boolean expected";
                        }
                        if (message.newCallId != null && $Object.hasOwnProperty.call(message, "newCallId")) {
                            properties._newCallId = 1;
                            if (!$util.isString(message.newCallId))
                                return "newCallId: string expected";
                        }
                        if (message.failureCause != null && $Object.hasOwnProperty.call(message, "failureCause")) {
                            properties._failureCause = 1;
                            if (!$util.isString(message.failureCause))
                                return "failureCause: string expected";
                        }
                        if (message.callerNumber != null && $Object.hasOwnProperty.call(message, "callerNumber")) {
                            properties._callerNumber = 1;
                            if (!$util.isString(message.callerNumber))
                                return "callerNumber: string expected";
                        }
                        if (message.callerName != null && $Object.hasOwnProperty.call(message, "callerName")) {
                            properties._callerName = 1;
                            if (!$util.isString(message.callerName))
                                return "callerName: string expected";
                        }
                        if (message.popupInfo != null && $Object.hasOwnProperty.call(message, "popupInfo")) {
                            if (!$util.isObject(message.popupInfo))
                                return "popupInfo: object expected";
                            let key = $Object.keys(message.popupInfo);
                            for (let i = 0; i < key.length; ++i)
                                if (!$util.isString(message.popupInfo[key[i]]))
                                    return "popupInfo: string{k:string} expected";
                        }
                        if (message.hasPopupInfo != null && $Object.hasOwnProperty.call(message, "hasPopupInfo")) {
                            properties._hasPopupInfo = 1;
                            if (typeof message.hasPopupInfo !== "boolean")
                                return "hasPopupInfo: boolean expected";
                        }
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason")) {
                            properties._transferReason = 1;
                            if (!$util.isString(message.transferReason))
                                return "transferReason: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CReattachCallSessionResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CReattachCallSessionResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CReattachCallSessionResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CReattachCallSessionResponse";
                    };

                    return CReattachCallSessionResponse;
                })();

                softphone.CHoldCallRequest = (function() {

                    /**
                     * Properties of a CHoldCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CHoldCallRequest.$Properties
                     * @property {string|null} [callId] CHoldCallRequest callId
                     * @property {boolean|null} [hold] CHoldCallRequest hold
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CHoldCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICHoldCallRequest
                     * @augments app.zyno.talk.softphone.CHoldCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CHoldCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CHoldCallRequest.
                     * @typedef {app.zyno.talk.softphone.CHoldCallRequest.$Properties} app.zyno.talk.softphone.CHoldCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CHoldCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CHoldCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CHoldCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CHoldCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CHoldCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @instance
                     */
                    CHoldCallRequest.prototype.callId = "";

                    /**
                     * CHoldCallRequest hold.
                     * @member {boolean} hold
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @instance
                     */
                    CHoldCallRequest.prototype.hold = false;

                    /**
                     * Encodes the specified CHoldCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CHoldCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CHoldCallRequest.$Properties} message CHoldCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CHoldCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.hold != null && $Object.hasOwnProperty.call(message, "hold") && message.hold !== false)
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.hold);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CHoldCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CHoldCallRequest & app.zyno.talk.softphone.CHoldCallRequest.$Shape} CHoldCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CHoldCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CHoldCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.bool())
                                        message.hold = value;
                                    else
                                        delete message.hold;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CHoldCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CHoldCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.hold != null && $Object.hasOwnProperty.call(message, "hold"))
                            if (typeof message.hold !== "boolean")
                                return "hold: boolean expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CHoldCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CHoldCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CHoldCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CHoldCallRequest";
                    };

                    return CHoldCallRequest;
                })();

                softphone.CHoldCallResponse = (function() {

                    /**
                     * Properties of a CHoldCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CHoldCallResponse.$Properties
                     * @property {boolean|null} [isHeld] CHoldCallResponse isHeld
                     * @property {boolean|null} [mediaSuspended] CHoldCallResponse mediaSuspended
                     * @property {string|null} [offerSdp] CHoldCallResponse offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] CHoldCallResponse turnInfo
                     * @property {app.zyno.talk.softphone.RenegotiationKind|null} [offerKind] CHoldCallResponse offerKind
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CHoldCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICHoldCallResponse
                     * @augments app.zyno.talk.softphone.CHoldCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CHoldCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CHoldCallResponse.
                     * @typedef {app.zyno.talk.softphone.CHoldCallResponse.$Properties} app.zyno.talk.softphone.CHoldCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CHoldCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CHoldCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CHoldCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CHoldCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CHoldCallResponse isHeld.
                     * @member {boolean|null|undefined} isHeld
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @instance
                     */
                    CHoldCallResponse.prototype.isHeld = null;

                    /**
                     * CHoldCallResponse mediaSuspended.
                     * @member {boolean|null|undefined} mediaSuspended
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @instance
                     */
                    CHoldCallResponse.prototype.mediaSuspended = null;

                    /**
                     * CHoldCallResponse offerSdp.
                     * @member {string|null|undefined} offerSdp
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @instance
                     */
                    CHoldCallResponse.prototype.offerSdp = null;

                    /**
                     * CHoldCallResponse turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @instance
                     */
                    CHoldCallResponse.prototype.turnInfo = null;

                    /**
                     * CHoldCallResponse offerKind.
                     * @member {app.zyno.talk.softphone.RenegotiationKind|null|undefined} offerKind
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @instance
                     */
                    CHoldCallResponse.prototype.offerKind = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CHoldCallResponse.prototype, "_isHeld", {
                        get: $util.oneOfGetter($oneOfFields = ["isHeld"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CHoldCallResponse.prototype, "_mediaSuspended", {
                        get: $util.oneOfGetter($oneOfFields = ["mediaSuspended"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CHoldCallResponse.prototype, "_offerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["offerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CHoldCallResponse.prototype, "_turnInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["turnInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CHoldCallResponse.prototype, "_offerKind", {
                        get: $util.oneOfGetter($oneOfFields = ["offerKind"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CHoldCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CHoldCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CHoldCallResponse.$Properties} message CHoldCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CHoldCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isHeld);
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.mediaSuspended);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
                        if (message.offerKind != null && $Object.hasOwnProperty.call(message, "offerKind"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.offerKind);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CHoldCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CHoldCallResponse & app.zyno.talk.softphone.CHoldCallResponse.$Shape} CHoldCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CHoldCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CHoldCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 0)
                                        break;
                                    message.isHeld = reader.bool();
                                    message._isHeld = "isHeld";
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    message.mediaSuspended = reader.bool();
                                    message._mediaSuspended = "mediaSuspended";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.offerSdp = reader.stringVerify();
                                    message._offerSdp = "offerSdp";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    message._turnInfo = "turnInfo";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 0)
                                        break;
                                    message.offerKind = reader.int32();
                                    message._offerKind = "offerKind";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CHoldCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CHoldCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld")) {
                            properties._isHeld = 1;
                            if (typeof message.isHeld !== "boolean")
                                return "isHeld: boolean expected";
                        }
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended")) {
                            properties._mediaSuspended = 1;
                            if (typeof message.mediaSuspended !== "boolean")
                                return "mediaSuspended: boolean expected";
                        }
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp")) {
                            properties._offerSdp = 1;
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        }
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            properties._turnInfo = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                                if (error)
                                    return "turnInfo." + error;
                            }
                        }
                        if (message.offerKind != null && $Object.hasOwnProperty.call(message, "offerKind")) {
                            properties._offerKind = 1;
                            if (typeof message.offerKind !== "number" || (message.offerKind | 0) !== message.offerKind)
                                return "offerKind: enum value expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CHoldCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CHoldCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CHoldCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CHoldCallResponse";
                    };

                    return CHoldCallResponse;
                })();

                /**
                 * TransferType enum.
                 * @name app.zyno.talk.softphone.TransferType
                 * @enum {number}
                 * @property {number} BLIND=0 BLIND value
                 * @property {number} ATTENDED=1 ATTENDED value
                 */
                softphone.TransferType = (function() {
                    const valuesById = $Object.create(null), values = $Object.create(valuesById);
                    values[valuesById[0] = "BLIND"] = 0;
                    values[valuesById[1] = "ATTENDED"] = 1;
                    return values;
                })();

                softphone.CTransferCallRequest = (function() {

                    /**
                     * Properties of a CTransferCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CTransferCallRequest.$Properties
                     * @property {string|null} [callId] CTransferCallRequest callId
                     * @property {string|null} [destination] CTransferCallRequest destination
                     * @property {string|null} [replacesCallId] CTransferCallRequest replacesCallId
                     * @property {app.zyno.talk.softphone.TransferType|null} [transferType] CTransferCallRequest transferType
                     * @property {string|null} [transferReason] CTransferCallRequest transferReason
                     * @property {string|null} [operationId] CTransferCallRequest operationId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CTransferCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICTransferCallRequest
                     * @augments app.zyno.talk.softphone.CTransferCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CTransferCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CTransferCallRequest.
                     * @typedef {app.zyno.talk.softphone.CTransferCallRequest.$Properties} app.zyno.talk.softphone.CTransferCallRequest.$Shape
                     */

                    /**
                     * Constructs a new CTransferCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CTransferCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CTransferCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CTransferCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CTransferCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.callId = "";

                    /**
                     * CTransferCallRequest destination.
                     * @member {string} destination
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.destination = "";

                    /**
                     * CTransferCallRequest replacesCallId.
                     * @member {string|null|undefined} replacesCallId
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.replacesCallId = null;

                    /**
                     * CTransferCallRequest transferType.
                     * @member {app.zyno.talk.softphone.TransferType|null|undefined} transferType
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.transferType = null;

                    /**
                     * CTransferCallRequest transferReason.
                     * @member {string|null|undefined} transferReason
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.transferReason = null;

                    /**
                     * CTransferCallRequest operationId.
                     * @member {string|null|undefined} operationId
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @instance
                     */
                    CTransferCallRequest.prototype.operationId = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTransferCallRequest.prototype, "_replacesCallId", {
                        get: $util.oneOfGetter($oneOfFields = ["replacesCallId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTransferCallRequest.prototype, "_transferType", {
                        get: $util.oneOfGetter($oneOfFields = ["transferType"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTransferCallRequest.prototype, "_transferReason", {
                        get: $util.oneOfGetter($oneOfFields = ["transferReason"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CTransferCallRequest.prototype, "_operationId", {
                        get: $util.oneOfGetter($oneOfFields = ["operationId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CTransferCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.CTransferCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CTransferCallRequest.$Properties} message CTransferCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CTransferCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination") && message.destination !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.destination);
                        if (message.replacesCallId != null && $Object.hasOwnProperty.call(message, "replacesCallId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.replacesCallId);
                        if (message.transferType != null && $Object.hasOwnProperty.call(message, "transferType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.transferType);
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.transferReason);
                        if (message.operationId != null && $Object.hasOwnProperty.call(message, "operationId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.operationId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CTransferCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CTransferCallRequest & app.zyno.talk.softphone.CTransferCallRequest.$Shape} CTransferCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CTransferCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CTransferCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.destination = value;
                                    else
                                        delete message.destination;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.replacesCallId = reader.stringVerify();
                                    message._replacesCallId = "replacesCallId";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 0)
                                        break;
                                    message.transferType = reader.int32();
                                    message._transferType = "transferType";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.transferReason = reader.stringVerify();
                                    message._transferReason = "transferReason";
                                    continue;
                                }
                            case 6: {
                                    if (wireType !== 2)
                                        break;
                                    message.operationId = reader.stringVerify();
                                    message._operationId = "operationId";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CTransferCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CTransferCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.destination != null && $Object.hasOwnProperty.call(message, "destination"))
                            if (!$util.isString(message.destination))
                                return "destination: string expected";
                        if (message.replacesCallId != null && $Object.hasOwnProperty.call(message, "replacesCallId")) {
                            properties._replacesCallId = 1;
                            if (!$util.isString(message.replacesCallId))
                                return "replacesCallId: string expected";
                        }
                        if (message.transferType != null && $Object.hasOwnProperty.call(message, "transferType")) {
                            properties._transferType = 1;
                            if (typeof message.transferType !== "number" || (message.transferType | 0) !== message.transferType)
                                return "transferType: enum value expected";
                        }
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason")) {
                            properties._transferReason = 1;
                            if (!$util.isString(message.transferReason))
                                return "transferReason: string expected";
                        }
                        if (message.operationId != null && $Object.hasOwnProperty.call(message, "operationId")) {
                            properties._operationId = 1;
                            if (!$util.isString(message.operationId))
                                return "operationId: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CTransferCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CTransferCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CTransferCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CTransferCallRequest";
                    };

                    return CTransferCallRequest;
                })();

                softphone.CTransferCallResponse = (function() {

                    /**
                     * Properties of a CTransferCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CTransferCallResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CTransferCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICTransferCallResponse
                     * @augments app.zyno.talk.softphone.CTransferCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CTransferCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CTransferCallResponse.
                     * @typedef {app.zyno.talk.softphone.CTransferCallResponse.$Properties} app.zyno.talk.softphone.CTransferCallResponse.$Shape
                     */

                    /**
                     * Constructs a new CTransferCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CTransferCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CTransferCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CTransferCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified CTransferCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.CTransferCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CTransferCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CTransferCallResponse.$Properties} message CTransferCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CTransferCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CTransferCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CTransferCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CTransferCallResponse & app.zyno.talk.softphone.CTransferCallResponse.$Shape} CTransferCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CTransferCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CTransferCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CTransferCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CTransferCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CTransferCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for CTransferCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CTransferCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CTransferCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CTransferCallResponse";
                    };

                    return CTransferCallResponse;
                })();

                softphone.CGetTransferCapabilitiesRequest = (function() {

                    /**
                     * Properties of a CGetTransferCapabilitiesRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties
                     * @property {string|null} [callId] CGetTransferCapabilitiesRequest callId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CGetTransferCapabilitiesRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICGetTransferCapabilitiesRequest
                     * @augments app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CGetTransferCapabilitiesRequest.
                     * @typedef {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties} app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Shape
                     */

                    /**
                     * Constructs a new CGetTransferCapabilitiesRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CGetTransferCapabilitiesRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CGetTransferCapabilitiesRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CGetTransferCapabilitiesRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesRequest
                     * @instance
                     */
                    CGetTransferCapabilitiesRequest.prototype.callId = "";

                    /**
                     * Encodes the specified CGetTransferCapabilitiesRequest message. Does not implicitly {@link app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties} message CGetTransferCapabilitiesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CGetTransferCapabilitiesRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CGetTransferCapabilitiesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest & app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Shape} CGetTransferCapabilitiesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CGetTransferCapabilitiesRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CGetTransferCapabilitiesRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CGetTransferCapabilitiesRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CGetTransferCapabilitiesRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CGetTransferCapabilitiesRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CGetTransferCapabilitiesRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CGetTransferCapabilitiesRequest";
                    };

                    return CGetTransferCapabilitiesRequest;
                })();

                softphone.CGetTransferCapabilitiesResponse = (function() {

                    /**
                     * Properties of a CGetTransferCapabilitiesResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties
                     * @property {boolean|null} [operationReplay] CGetTransferCapabilitiesResponse operationReplay
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CGetTransferCapabilitiesResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICGetTransferCapabilitiesResponse
                     * @augments app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CGetTransferCapabilitiesResponse.
                     * @typedef {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties} app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Shape
                     */

                    /**
                     * Constructs a new CGetTransferCapabilitiesResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CGetTransferCapabilitiesResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CGetTransferCapabilitiesResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CGetTransferCapabilitiesResponse operationReplay.
                     * @member {boolean} operationReplay
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesResponse
                     * @instance
                     */
                    CGetTransferCapabilitiesResponse.prototype.operationReplay = false;

                    /**
                     * Encodes the specified CGetTransferCapabilitiesResponse message. Does not implicitly {@link app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties} message CGetTransferCapabilitiesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CGetTransferCapabilitiesResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.operationReplay != null && $Object.hasOwnProperty.call(message, "operationReplay") && message.operationReplay !== false)
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.operationReplay);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CGetTransferCapabilitiesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse & app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Shape} CGetTransferCapabilitiesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CGetTransferCapabilitiesResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CGetTransferCapabilitiesResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.bool())
                                        message.operationReplay = value;
                                    else
                                        delete message.operationReplay;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CGetTransferCapabilitiesResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CGetTransferCapabilitiesResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.operationReplay != null && $Object.hasOwnProperty.call(message, "operationReplay"))
                            if (typeof message.operationReplay !== "boolean")
                                return "operationReplay: boolean expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CGetTransferCapabilitiesResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CGetTransferCapabilitiesResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CGetTransferCapabilitiesResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CGetTransferCapabilitiesResponse";
                    };

                    return CGetTransferCapabilitiesResponse;
                })();

                softphone.CSendDtmfRequest = (function() {

                    /**
                     * Properties of a CSendDtmfRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CSendDtmfRequest.$Properties
                     * @property {string|null} [callId] CSendDtmfRequest callId
                     * @property {string|null} [digit] CSendDtmfRequest digit
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CSendDtmfRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICSendDtmfRequest
                     * @augments app.zyno.talk.softphone.CSendDtmfRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CSendDtmfRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CSendDtmfRequest.
                     * @typedef {app.zyno.talk.softphone.CSendDtmfRequest.$Properties} app.zyno.talk.softphone.CSendDtmfRequest.$Shape
                     */

                    /**
                     * Constructs a new CSendDtmfRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CSendDtmfRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CSendDtmfRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CSendDtmfRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CSendDtmfRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @instance
                     */
                    CSendDtmfRequest.prototype.callId = "";

                    /**
                     * CSendDtmfRequest digit.
                     * @member {string} digit
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @instance
                     */
                    CSendDtmfRequest.prototype.digit = "";

                    /**
                     * Encodes the specified CSendDtmfRequest message. Does not implicitly {@link app.zyno.talk.softphone.CSendDtmfRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CSendDtmfRequest.$Properties} message CSendDtmfRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CSendDtmfRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.digit != null && $Object.hasOwnProperty.call(message, "digit") && message.digit !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.digit);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CSendDtmfRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CSendDtmfRequest & app.zyno.talk.softphone.CSendDtmfRequest.$Shape} CSendDtmfRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CSendDtmfRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CSendDtmfRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.digit = value;
                                    else
                                        delete message.digit;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CSendDtmfRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CSendDtmfRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.digit != null && $Object.hasOwnProperty.call(message, "digit"))
                            if (!$util.isString(message.digit))
                                return "digit: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CSendDtmfRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CSendDtmfRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CSendDtmfRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CSendDtmfRequest";
                    };

                    return CSendDtmfRequest;
                })();

                softphone.CSendDtmfResponse = (function() {

                    /**
                     * Properties of a CSendDtmfResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CSendDtmfResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CSendDtmfResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICSendDtmfResponse
                     * @augments app.zyno.talk.softphone.CSendDtmfResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CSendDtmfResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CSendDtmfResponse.
                     * @typedef {app.zyno.talk.softphone.CSendDtmfResponse.$Properties} app.zyno.talk.softphone.CSendDtmfResponse.$Shape
                     */

                    /**
                     * Constructs a new CSendDtmfResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CSendDtmfResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CSendDtmfResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CSendDtmfResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified CSendDtmfResponse message. Does not implicitly {@link app.zyno.talk.softphone.CSendDtmfResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CSendDtmfResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CSendDtmfResponse.$Properties} message CSendDtmfResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CSendDtmfResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CSendDtmfResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CSendDtmfResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CSendDtmfResponse & app.zyno.talk.softphone.CSendDtmfResponse.$Shape} CSendDtmfResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CSendDtmfResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CSendDtmfResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CSendDtmfResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CSendDtmfResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CSendDtmfResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for CSendDtmfResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CSendDtmfResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CSendDtmfResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CSendDtmfResponse";
                    };

                    return CSendDtmfResponse;
                })();

                softphone.CGetTurnCredentialsRequest = (function() {

                    /**
                     * Properties of a CGetTurnCredentialsRequest.
                     * @typedef {Object} app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties
                     * @property {string|null} [extensionId] CGetTurnCredentialsRequest extensionId
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CGetTurnCredentialsRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICGetTurnCredentialsRequest
                     * @augments app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties instead.
                     */

                    /**
                     * Shape of a CGetTurnCredentialsRequest.
                     * @typedef {app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties} app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Shape
                     */

                    /**
                     * Constructs a new CGetTurnCredentialsRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CGetTurnCredentialsRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CGetTurnCredentialsRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CGetTurnCredentialsRequest extensionId.
                     * @member {string} extensionId
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsRequest
                     * @instance
                     */
                    CGetTurnCredentialsRequest.prototype.extensionId = "";

                    /**
                     * Encodes the specified CGetTurnCredentialsRequest message. Does not implicitly {@link app.zyno.talk.softphone.CGetTurnCredentialsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsRequest
                     * @static
                     * @param {app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties} message CGetTurnCredentialsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CGetTurnCredentialsRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId") && message.extensionId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.extensionId);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CGetTurnCredentialsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CGetTurnCredentialsRequest & app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Shape} CGetTurnCredentialsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CGetTurnCredentialsRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CGetTurnCredentialsRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.extensionId = value;
                                    else
                                        delete message.extensionId;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CGetTurnCredentialsRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CGetTurnCredentialsRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.extensionId != null && $Object.hasOwnProperty.call(message, "extensionId"))
                            if (!$util.isString(message.extensionId))
                                return "extensionId: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for CGetTurnCredentialsRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CGetTurnCredentialsRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CGetTurnCredentialsRequest";
                    };

                    return CGetTurnCredentialsRequest;
                })();

                softphone.CGetTurnCredentialsResponse = (function() {

                    /**
                     * Properties of a CGetTurnCredentialsResponse.
                     * @typedef {Object} app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CGetTurnCredentialsResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICGetTurnCredentialsResponse
                     * @augments app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties instead.
                     */

                    /**
                     * Shape of a CGetTurnCredentialsResponse.
                     * @typedef {app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties} app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Shape
                     */

                    /**
                     * Constructs a new CGetTurnCredentialsResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CGetTurnCredentialsResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CGetTurnCredentialsResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified CGetTurnCredentialsResponse message. Does not implicitly {@link app.zyno.talk.softphone.CGetTurnCredentialsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsResponse
                     * @static
                     * @param {app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties} message CGetTurnCredentialsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CGetTurnCredentialsResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CGetTurnCredentialsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CGetTurnCredentialsResponse & app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Shape} CGetTurnCredentialsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CGetTurnCredentialsResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CGetTurnCredentialsResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CGetTurnCredentialsResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CGetTurnCredentialsResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for CGetTurnCredentialsResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CGetTurnCredentialsResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CGetTurnCredentialsResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CGetTurnCredentialsResponse";
                    };

                    return CGetTurnCredentialsResponse;
                })();

                softphone.SUpdateCallStatusRequest = (function() {

                    /**
                     * Properties of a SUpdateCallStatusRequest.
                     * @typedef {Object} app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties
                     * @property {string|null} [callId] SUpdateCallStatusRequest callId
                     * @property {app.zyno.talk.softphone.CallStatus|null} [status] SUpdateCallStatusRequest status
                     * @property {string|null} [failureCause] SUpdateCallStatusRequest failureCause
                     * @property {string|null} [offerSdp] SUpdateCallStatusRequest offerSdp
                     * @property {boolean|null} [isHeld] SUpdateCallStatusRequest isHeld
                     * @property {boolean|null} [mediaSuspended] SUpdateCallStatusRequest mediaSuspended
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SUpdateCallStatusRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISUpdateCallStatusRequest
                     * @augments app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties instead.
                     */

                    /**
                     * Shape of a SUpdateCallStatusRequest.
                     * @typedef {app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties} app.zyno.talk.softphone.SUpdateCallStatusRequest.$Shape
                     */

                    /**
                     * Constructs a new SUpdateCallStatusRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SUpdateCallStatusRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SUpdateCallStatusRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SUpdateCallStatusRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.callId = "";

                    /**
                     * SUpdateCallStatusRequest status.
                     * @member {app.zyno.talk.softphone.CallStatus|null|undefined} status
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.status = null;

                    /**
                     * SUpdateCallStatusRequest failureCause.
                     * @member {string|null|undefined} failureCause
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.failureCause = null;

                    /**
                     * SUpdateCallStatusRequest offerSdp.
                     * @member {string|null|undefined} offerSdp
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.offerSdp = null;

                    /**
                     * SUpdateCallStatusRequest isHeld.
                     * @member {boolean|null|undefined} isHeld
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.isHeld = null;

                    /**
                     * SUpdateCallStatusRequest mediaSuspended.
                     * @member {boolean|null|undefined} mediaSuspended
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @instance
                     */
                    SUpdateCallStatusRequest.prototype.mediaSuspended = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SUpdateCallStatusRequest.prototype, "_status", {
                        get: $util.oneOfGetter($oneOfFields = ["status"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SUpdateCallStatusRequest.prototype, "_failureCause", {
                        get: $util.oneOfGetter($oneOfFields = ["failureCause"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SUpdateCallStatusRequest.prototype, "_offerSdp", {
                        get: $util.oneOfGetter($oneOfFields = ["offerSdp"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SUpdateCallStatusRequest.prototype, "_isHeld", {
                        get: $util.oneOfGetter($oneOfFields = ["isHeld"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SUpdateCallStatusRequest.prototype, "_mediaSuspended", {
                        get: $util.oneOfGetter($oneOfFields = ["mediaSuspended"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified SUpdateCallStatusRequest message. Does not implicitly {@link app.zyno.talk.softphone.SUpdateCallStatusRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @static
                     * @param {app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties} message SUpdateCallStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SUpdateCallStatusRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                        if (message.failureCause != null && $Object.hasOwnProperty.call(message, "failureCause"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.failureCause);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.offerSdp);
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isHeld);
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.mediaSuspended);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SUpdateCallStatusRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SUpdateCallStatusRequest & app.zyno.talk.softphone.SUpdateCallStatusRequest.$Shape} SUpdateCallStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SUpdateCallStatusRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SUpdateCallStatusRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    message.status = reader.int32();
                                    message._status = "status";
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.failureCause = reader.stringVerify();
                                    message._failureCause = "failureCause";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.offerSdp = reader.stringVerify();
                                    message._offerSdp = "offerSdp";
                                    continue;
                                }
                            case 6: {
                                    if (wireType !== 0)
                                        break;
                                    message.isHeld = reader.bool();
                                    message._isHeld = "isHeld";
                                    continue;
                                }
                            case 7: {
                                    if (wireType !== 0)
                                        break;
                                    message.mediaSuspended = reader.bool();
                                    message._mediaSuspended = "mediaSuspended";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SUpdateCallStatusRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SUpdateCallStatusRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.status != null && $Object.hasOwnProperty.call(message, "status")) {
                            properties._status = 1;
                            if (typeof message.status !== "number" || (message.status | 0) !== message.status)
                                return "status: enum value expected";
                        }
                        if (message.failureCause != null && $Object.hasOwnProperty.call(message, "failureCause")) {
                            properties._failureCause = 1;
                            if (!$util.isString(message.failureCause))
                                return "failureCause: string expected";
                        }
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp")) {
                            properties._offerSdp = 1;
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        }
                        if (message.isHeld != null && $Object.hasOwnProperty.call(message, "isHeld")) {
                            properties._isHeld = 1;
                            if (typeof message.isHeld !== "boolean")
                                return "isHeld: boolean expected";
                        }
                        if (message.mediaSuspended != null && $Object.hasOwnProperty.call(message, "mediaSuspended")) {
                            properties._mediaSuspended = 1;
                            if (typeof message.mediaSuspended !== "boolean")
                                return "mediaSuspended: boolean expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for SUpdateCallStatusRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SUpdateCallStatusRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SUpdateCallStatusRequest";
                    };

                    return SUpdateCallStatusRequest;
                })();

                softphone.SUpdateCallStatusResponse = (function() {

                    /**
                     * Properties of a SUpdateCallStatusResponse.
                     * @typedef {Object} app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SUpdateCallStatusResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISUpdateCallStatusResponse
                     * @augments app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties instead.
                     */

                    /**
                     * Shape of a SUpdateCallStatusResponse.
                     * @typedef {app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties} app.zyno.talk.softphone.SUpdateCallStatusResponse.$Shape
                     */

                    /**
                     * Constructs a new SUpdateCallStatusResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SUpdateCallStatusResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SUpdateCallStatusResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified SUpdateCallStatusResponse message. Does not implicitly {@link app.zyno.talk.softphone.SUpdateCallStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusResponse
                     * @static
                     * @param {app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties} message SUpdateCallStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SUpdateCallStatusResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SUpdateCallStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SUpdateCallStatusResponse & app.zyno.talk.softphone.SUpdateCallStatusResponse.$Shape} SUpdateCallStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SUpdateCallStatusResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SUpdateCallStatusResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SUpdateCallStatusResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SUpdateCallStatusResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for SUpdateCallStatusResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SUpdateCallStatusResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SUpdateCallStatusResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SUpdateCallStatusResponse";
                    };

                    return SUpdateCallStatusResponse;
                })();

                /**
                 * RenegotiationKind enum.
                 * @name app.zyno.talk.softphone.RenegotiationKind
                 * @enum {number}
                 * @property {number} RENEGOTIATION_KIND_UNSPECIFIED=0 RENEGOTIATION_KIND_UNSPECIFIED value
                 * @property {number} RENEGOTIATION_ICE_RESTART=1 RENEGOTIATION_ICE_RESTART value
                 * @property {number} RENEGOTIATION_TOTAL_REPLACEMENT=2 RENEGOTIATION_TOTAL_REPLACEMENT value
                 */
                softphone.RenegotiationKind = (function() {
                    const valuesById = $Object.create(null), values = $Object.create(valuesById);
                    values[valuesById[0] = "RENEGOTIATION_KIND_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "RENEGOTIATION_ICE_RESTART"] = 1;
                    values[valuesById[2] = "RENEGOTIATION_TOTAL_REPLACEMENT"] = 2;
                    return values;
                })();

                softphone.SRenegotiateCallRequest = (function() {

                    /**
                     * Properties of a SRenegotiateCallRequest.
                     * @typedef {Object} app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties
                     * @property {string|null} [callId] SRenegotiateCallRequest callId
                     * @property {string|null} [offerSdp] SRenegotiateCallRequest offerSdp
                     * @property {app.zyno.talk.softphone.TurnInfo.$Properties|null} [turnInfo] SRenegotiateCallRequest turnInfo
                     * @property {app.zyno.talk.softphone.RenegotiationKind|null} [kind] SRenegotiateCallRequest kind
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SRenegotiateCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISRenegotiateCallRequest
                     * @augments app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties instead.
                     */

                    /**
                     * Shape of a SRenegotiateCallRequest.
                     * @typedef {app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties} app.zyno.talk.softphone.SRenegotiateCallRequest.$Shape
                     */

                    /**
                     * Constructs a new SRenegotiateCallRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SRenegotiateCallRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SRenegotiateCallRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SRenegotiateCallRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @instance
                     */
                    SRenegotiateCallRequest.prototype.callId = "";

                    /**
                     * SRenegotiateCallRequest offerSdp.
                     * @member {string} offerSdp
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @instance
                     */
                    SRenegotiateCallRequest.prototype.offerSdp = "";

                    /**
                     * SRenegotiateCallRequest turnInfo.
                     * @member {app.zyno.talk.softphone.TurnInfo.$Properties|null|undefined} turnInfo
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @instance
                     */
                    SRenegotiateCallRequest.prototype.turnInfo = null;

                    /**
                     * SRenegotiateCallRequest kind.
                     * @member {app.zyno.talk.softphone.RenegotiationKind} kind
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @instance
                     */
                    SRenegotiateCallRequest.prototype.kind = 0;

                    /**
                     * Encodes the specified SRenegotiateCallRequest message. Does not implicitly {@link app.zyno.talk.softphone.SRenegotiateCallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @static
                     * @param {app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties} message SRenegotiateCallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SRenegotiateCallRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp") && message.offerSdp !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.offerSdp);
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo"))
                            $root.app.zyno.talk.softphone.TurnInfo.encode(message.turnInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                        if (message.kind != null && $Object.hasOwnProperty.call(message, "kind") && message.kind !== 0)
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.kind);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SRenegotiateCallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SRenegotiateCallRequest & app.zyno.talk.softphone.SRenegotiateCallRequest.$Shape} SRenegotiateCallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SRenegotiateCallRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SRenegotiateCallRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.offerSdp = value;
                                    else
                                        delete message.offerSdp;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.turnInfo = $root.app.zyno.talk.softphone.TurnInfo.decode(reader, reader.size(), $undefined, _depth + 1, message.turnInfo);
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.int32())
                                        message.kind = value;
                                    else
                                        delete message.kind;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SRenegotiateCallRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SRenegotiateCallRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.offerSdp != null && $Object.hasOwnProperty.call(message, "offerSdp"))
                            if (!$util.isString(message.offerSdp))
                                return "offerSdp: string expected";
                        if (message.turnInfo != null && $Object.hasOwnProperty.call(message, "turnInfo")) {
                            let error = $root.app.zyno.talk.softphone.TurnInfo.verify(message.turnInfo, _depth + 1);
                            if (error)
                                return "turnInfo." + error;
                        }
                        if (message.kind != null && $Object.hasOwnProperty.call(message, "kind"))
                            if (typeof message.kind !== "number" || (message.kind | 0) !== message.kind)
                                return "kind: enum value expected";
                        return null;
                    };

                    /**
                     * Gets the type url for SRenegotiateCallRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SRenegotiateCallRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SRenegotiateCallRequest";
                    };

                    return SRenegotiateCallRequest;
                })();

                softphone.SRenegotiateCallResponse = (function() {

                    /**
                     * Properties of a SRenegotiateCallResponse.
                     * @typedef {Object} app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties
                     * @property {string|null} [answerSdp] SRenegotiateCallResponse answerSdp
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SRenegotiateCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISRenegotiateCallResponse
                     * @augments app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties instead.
                     */

                    /**
                     * Shape of a SRenegotiateCallResponse.
                     * @typedef {app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties} app.zyno.talk.softphone.SRenegotiateCallResponse.$Shape
                     */

                    /**
                     * Constructs a new SRenegotiateCallResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SRenegotiateCallResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SRenegotiateCallResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SRenegotiateCallResponse answerSdp.
                     * @member {string} answerSdp
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallResponse
                     * @instance
                     */
                    SRenegotiateCallResponse.prototype.answerSdp = "";

                    /**
                     * Encodes the specified SRenegotiateCallResponse message. Does not implicitly {@link app.zyno.talk.softphone.SRenegotiateCallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallResponse
                     * @static
                     * @param {app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties} message SRenegotiateCallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SRenegotiateCallResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp") && message.answerSdp !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.answerSdp);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SRenegotiateCallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SRenegotiateCallResponse & app.zyno.talk.softphone.SRenegotiateCallResponse.$Shape} SRenegotiateCallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SRenegotiateCallResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SRenegotiateCallResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.answerSdp = value;
                                    else
                                        delete message.answerSdp;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SRenegotiateCallResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SRenegotiateCallResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.answerSdp != null && $Object.hasOwnProperty.call(message, "answerSdp"))
                            if (!$util.isString(message.answerSdp))
                                return "answerSdp: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for SRenegotiateCallResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SRenegotiateCallResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SRenegotiateCallResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SRenegotiateCallResponse";
                    };

                    return SRenegotiateCallResponse;
                })();

                softphone.SRenegotiateCompleteRequest = (function() {

                    /**
                     * Properties of a SRenegotiateCompleteRequest.
                     * @typedef {Object} app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties
                     * @property {string|null} [callId] SRenegotiateCompleteRequest callId
                     * @property {boolean|null} [committed] SRenegotiateCompleteRequest committed
                     * @property {string|null} [newCallId] SRenegotiateCompleteRequest newCallId
                     * @property {string|null} [callerNumber] SRenegotiateCompleteRequest callerNumber
                     * @property {string|null} [callerName] SRenegotiateCompleteRequest callerName
                     * @property {Object.<string,string>|null} [popupInfo] SRenegotiateCompleteRequest popupInfo
                     * @property {boolean|null} [hasPopupInfo] SRenegotiateCompleteRequest hasPopupInfo
                     * @property {string|null} [transferReason] SRenegotiateCompleteRequest transferReason
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SRenegotiateCompleteRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISRenegotiateCompleteRequest
                     * @augments app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties instead.
                     */

                    /**
                     * Shape of a SRenegotiateCompleteRequest.
                     * @typedef {app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties} app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Shape
                     */

                    /**
                     * Constructs a new SRenegotiateCompleteRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SRenegotiateCompleteRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SRenegotiateCompleteRequest = function (properties) {
                        this.popupInfo = {};
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SRenegotiateCompleteRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.callId = "";

                    /**
                     * SRenegotiateCompleteRequest committed.
                     * @member {boolean} committed
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.committed = false;

                    /**
                     * SRenegotiateCompleteRequest newCallId.
                     * @member {string|null|undefined} newCallId
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.newCallId = null;

                    /**
                     * SRenegotiateCompleteRequest callerNumber.
                     * @member {string|null|undefined} callerNumber
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.callerNumber = null;

                    /**
                     * SRenegotiateCompleteRequest callerName.
                     * @member {string|null|undefined} callerName
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.callerName = null;

                    /**
                     * SRenegotiateCompleteRequest popupInfo.
                     * @member {Object.<string,string>} popupInfo
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.popupInfo = $util.emptyObject;

                    /**
                     * SRenegotiateCompleteRequest hasPopupInfo.
                     * @member {boolean|null|undefined} hasPopupInfo
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.hasPopupInfo = null;

                    /**
                     * SRenegotiateCompleteRequest transferReason.
                     * @member {string|null|undefined} transferReason
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @instance
                     */
                    SRenegotiateCompleteRequest.prototype.transferReason = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SRenegotiateCompleteRequest.prototype, "_newCallId", {
                        get: $util.oneOfGetter($oneOfFields = ["newCallId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SRenegotiateCompleteRequest.prototype, "_callerNumber", {
                        get: $util.oneOfGetter($oneOfFields = ["callerNumber"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SRenegotiateCompleteRequest.prototype, "_callerName", {
                        get: $util.oneOfGetter($oneOfFields = ["callerName"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SRenegotiateCompleteRequest.prototype, "_hasPopupInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["hasPopupInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SRenegotiateCompleteRequest.prototype, "_transferReason", {
                        get: $util.oneOfGetter($oneOfFields = ["transferReason"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified SRenegotiateCompleteRequest message. Does not implicitly {@link app.zyno.talk.softphone.SRenegotiateCompleteRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @static
                     * @param {app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties} message SRenegotiateCompleteRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SRenegotiateCompleteRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.committed != null && $Object.hasOwnProperty.call(message, "committed") && message.committed !== false)
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.committed);
                        if (message.newCallId != null && $Object.hasOwnProperty.call(message, "newCallId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.newCallId);
                        if (message.callerNumber != null && $Object.hasOwnProperty.call(message, "callerNumber"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.callerNumber);
                        if (message.callerName != null && $Object.hasOwnProperty.call(message, "callerName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.callerName);
                        if (message.popupInfo != null && $Object.hasOwnProperty.call(message, "popupInfo"))
                            for (let keys = $Object.keys(message.popupInfo), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.popupInfo[keys[i]]).ldelim();
                        if (message.hasPopupInfo != null && $Object.hasOwnProperty.call(message, "hasPopupInfo"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.hasPopupInfo);
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.transferReason);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SRenegotiateCompleteRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SRenegotiateCompleteRequest & app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Shape} SRenegotiateCompleteRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SRenegotiateCompleteRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, key, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SRenegotiateCompleteRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.bool())
                                        message.committed = value;
                                    else
                                        delete message.committed;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.newCallId = reader.stringVerify();
                                    message._newCallId = "newCallId";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 2)
                                        break;
                                    message.callerNumber = reader.stringVerify();
                                    message._callerNumber = "callerNumber";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.callerName = reader.stringVerify();
                                    message._callerName = "callerName";
                                    continue;
                                }
                            case 6: {
                                    if (wireType !== 2)
                                        break;
                                    if (message.popupInfo === $util.emptyObject)
                                        message.popupInfo = {};
                                    let end2 = reader.size() + reader.pos;
                                    if (end2 > reader.len)
                                        throw $RangeError("index out of range");
                                    reader.len = end2;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        let tag2 = reader.tag();
                                        wireType = tag2 & 7;
                                        switch (tag2 >>>= 3) {
                                        case 1:
                                            if (wireType !== 2)
                                                break;
                                            key = reader.stringVerify();
                                            continue;
                                        case 2:
                                            if (wireType !== 2)
                                                break;
                                            value = reader.stringVerify();
                                            continue;
                                        }
                                        reader.skipType(wireType, _depth, tag2);
                                    }
                                    if (reader.pos !== end2)
                                        throw $RangeError("index out of range");
                                    reader.len = end;
                                    if (key === "__proto__")
                                        $util.makeProp(message.popupInfo, key);
                                    message.popupInfo[key] = value;
                                    continue;
                                }
                            case 7: {
                                    if (wireType !== 0)
                                        break;
                                    message.hasPopupInfo = reader.bool();
                                    message._hasPopupInfo = "hasPopupInfo";
                                    continue;
                                }
                            case 8: {
                                    if (wireType !== 2)
                                        break;
                                    message.transferReason = reader.stringVerify();
                                    message._transferReason = "transferReason";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SRenegotiateCompleteRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SRenegotiateCompleteRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.committed != null && $Object.hasOwnProperty.call(message, "committed"))
                            if (typeof message.committed !== "boolean")
                                return "committed: boolean expected";
                        if (message.newCallId != null && $Object.hasOwnProperty.call(message, "newCallId")) {
                            properties._newCallId = 1;
                            if (!$util.isString(message.newCallId))
                                return "newCallId: string expected";
                        }
                        if (message.callerNumber != null && $Object.hasOwnProperty.call(message, "callerNumber")) {
                            properties._callerNumber = 1;
                            if (!$util.isString(message.callerNumber))
                                return "callerNumber: string expected";
                        }
                        if (message.callerName != null && $Object.hasOwnProperty.call(message, "callerName")) {
                            properties._callerName = 1;
                            if (!$util.isString(message.callerName))
                                return "callerName: string expected";
                        }
                        if (message.popupInfo != null && $Object.hasOwnProperty.call(message, "popupInfo")) {
                            if (!$util.isObject(message.popupInfo))
                                return "popupInfo: object expected";
                            let key = $Object.keys(message.popupInfo);
                            for (let i = 0; i < key.length; ++i)
                                if (!$util.isString(message.popupInfo[key[i]]))
                                    return "popupInfo: string{k:string} expected";
                        }
                        if (message.hasPopupInfo != null && $Object.hasOwnProperty.call(message, "hasPopupInfo")) {
                            properties._hasPopupInfo = 1;
                            if (typeof message.hasPopupInfo !== "boolean")
                                return "hasPopupInfo: boolean expected";
                        }
                        if (message.transferReason != null && $Object.hasOwnProperty.call(message, "transferReason")) {
                            properties._transferReason = 1;
                            if (!$util.isString(message.transferReason))
                                return "transferReason: string expected";
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for SRenegotiateCompleteRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SRenegotiateCompleteRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SRenegotiateCompleteRequest";
                    };

                    return SRenegotiateCompleteRequest;
                })();

                softphone.SRenegotiateCompleteResponse = (function() {

                    /**
                     * Properties of a SRenegotiateCompleteResponse.
                     * @typedef {Object} app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SRenegotiateCompleteResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISRenegotiateCompleteResponse
                     * @augments app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties instead.
                     */

                    /**
                     * Shape of a SRenegotiateCompleteResponse.
                     * @typedef {app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties} app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Shape
                     */

                    /**
                     * Constructs a new SRenegotiateCompleteResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SRenegotiateCompleteResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SRenegotiateCompleteResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified SRenegotiateCompleteResponse message. Does not implicitly {@link app.zyno.talk.softphone.SRenegotiateCompleteResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteResponse
                     * @static
                     * @param {app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties} message SRenegotiateCompleteResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SRenegotiateCompleteResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SRenegotiateCompleteResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SRenegotiateCompleteResponse & app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Shape} SRenegotiateCompleteResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SRenegotiateCompleteResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SRenegotiateCompleteResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SRenegotiateCompleteResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SRenegotiateCompleteResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for SRenegotiateCompleteResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SRenegotiateCompleteResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SRenegotiateCompleteResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SRenegotiateCompleteResponse";
                    };

                    return SRenegotiateCompleteResponse;
                })();

                softphone.SMediaFailureHintRequest = (function() {

                    /**
                     * Properties of a SMediaFailureHintRequest.
                     * @typedef {Object} app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties
                     * @property {string|null} [callId] SMediaFailureHintRequest callId
                     * @property {string|null} [reason] SMediaFailureHintRequest reason
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SMediaFailureHintRequest.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISMediaFailureHintRequest
                     * @augments app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties instead.
                     */

                    /**
                     * Shape of a SMediaFailureHintRequest.
                     * @typedef {app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties} app.zyno.talk.softphone.SMediaFailureHintRequest.$Shape
                     */

                    /**
                     * Constructs a new SMediaFailureHintRequest.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SMediaFailureHintRequest.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SMediaFailureHintRequest = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SMediaFailureHintRequest callId.
                     * @member {string} callId
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @instance
                     */
                    SMediaFailureHintRequest.prototype.callId = "";

                    /**
                     * SMediaFailureHintRequest reason.
                     * @member {string} reason
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @instance
                     */
                    SMediaFailureHintRequest.prototype.reason = "";

                    /**
                     * Encodes the specified SMediaFailureHintRequest message. Does not implicitly {@link app.zyno.talk.softphone.SMediaFailureHintRequest.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @static
                     * @param {app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties} message SMediaFailureHintRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SMediaFailureHintRequest.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId") && message.callId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.callId);
                        if (message.reason != null && $Object.hasOwnProperty.call(message, "reason") && message.reason !== "")
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SMediaFailureHintRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SMediaFailureHintRequest & app.zyno.talk.softphone.SMediaFailureHintRequest.$Shape} SMediaFailureHintRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SMediaFailureHintRequest.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SMediaFailureHintRequest();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.callId = value;
                                    else
                                        delete message.callId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.reason = value;
                                    else
                                        delete message.reason;
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SMediaFailureHintRequest message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SMediaFailureHintRequest.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        if (message.callId != null && $Object.hasOwnProperty.call(message, "callId"))
                            if (!$util.isString(message.callId))
                                return "callId: string expected";
                        if (message.reason != null && $Object.hasOwnProperty.call(message, "reason"))
                            if (!$util.isString(message.reason))
                                return "reason: string expected";
                        return null;
                    };

                    /**
                     * Gets the type url for SMediaFailureHintRequest
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintRequest
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SMediaFailureHintRequest.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SMediaFailureHintRequest";
                    };

                    return SMediaFailureHintRequest;
                })();

                softphone.SMediaFailureHintResponse = (function() {

                    /**
                     * Properties of a SMediaFailureHintResponse.
                     * @typedef {Object} app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SMediaFailureHintResponse.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISMediaFailureHintResponse
                     * @augments app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties instead.
                     */

                    /**
                     * Shape of a SMediaFailureHintResponse.
                     * @typedef {app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties} app.zyno.talk.softphone.SMediaFailureHintResponse.$Shape
                     */

                    /**
                     * Constructs a new SMediaFailureHintResponse.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SMediaFailureHintResponse.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SMediaFailureHintResponse = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * Encodes the specified SMediaFailureHintResponse message. Does not implicitly {@link app.zyno.talk.softphone.SMediaFailureHintResponse.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintResponse
                     * @static
                     * @param {app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties} message SMediaFailureHintResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SMediaFailureHintResponse.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SMediaFailureHintResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SMediaFailureHintResponse & app.zyno.talk.softphone.SMediaFailureHintResponse.$Shape} SMediaFailureHintResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SMediaFailureHintResponse.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SMediaFailureHintResponse();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            reader.skipType(tag & 7, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SMediaFailureHintResponse message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SMediaFailureHintResponse.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        return null;
                    };

                    /**
                     * Gets the type url for SMediaFailureHintResponse
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SMediaFailureHintResponse
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SMediaFailureHintResponse.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SMediaFailureHintResponse";
                    };

                    return SMediaFailureHintResponse;
                })();

                softphone.CMessageStream = (function() {

                    /**
                     * Properties of a CMessageStream.
                     * @typedef {Object} app.zyno.talk.softphone.CMessageStream.$Properties
                     * @property {string|null} [requestId] CMessageStream requestId
                     * @property {boolean|null} [reply] CMessageStream reply
                     * @property {string|null} [error] CMessageStream error
                     * @property {boolean|null} [userError] CMessageStream userError
                     * @property {app.zyno.talk.softphone.TraceContext.$Properties|null} [trace] CMessageStream trace
                     * @property {app.zyno.talk.softphone.PingPong.$Properties|null} [pingPong] CMessageStream pingPong
                     * @property {app.zyno.talk.softphone.ByteStreamOperation.$Properties|null} [byteStreamOperation] CMessageStream byteStreamOperation
                     * @property {app.zyno.talk.softphone.CPlaceCallRequest.$Properties|null} [cPlaceCallRequest] CMessageStream cPlaceCallRequest
                     * @property {app.zyno.talk.softphone.CAcceptCallRequest.$Properties|null} [cAcceptCallRequest] CMessageStream cAcceptCallRequest
                     * @property {app.zyno.talk.softphone.CEndCallRequest.$Properties|null} [cEndCallRequest] CMessageStream cEndCallRequest
                     * @property {app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties|null} [cReattachCallSessionRequest] CMessageStream cReattachCallSessionRequest
                     * @property {app.zyno.talk.softphone.CHoldCallRequest.$Properties|null} [cHoldCallRequest] CMessageStream cHoldCallRequest
                     * @property {app.zyno.talk.softphone.CTransferCallRequest.$Properties|null} [cTransferCallRequest] CMessageStream cTransferCallRequest
                     * @property {app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties|null} [cGetTurnCredentialsRequest] CMessageStream cGetTurnCredentialsRequest
                     * @property {app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties|null} [cSubmitAnswerRequest] CMessageStream cSubmitAnswerRequest
                     * @property {app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties|null} [cRequestIceRestartRequest] CMessageStream cRequestIceRestartRequest
                     * @property {app.zyno.talk.softphone.CSendDtmfRequest.$Properties|null} [cSendDtmfRequest] CMessageStream cSendDtmfRequest
                     * @property {app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties|null} [cRequestMediaReplacementRequest] CMessageStream cRequestMediaReplacementRequest
                     * @property {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties|null} [cPlaceAiAgentTestCallRequest] CMessageStream cPlaceAiAgentTestCallRequest
                     * @property {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties|null} [cGetTransferCapabilitiesRequest] CMessageStream cGetTransferCapabilitiesRequest
                     * @property {app.zyno.talk.softphone.CPickupCallRequest.$Properties|null} [cPickupCallRequest] CMessageStream cPickupCallRequest
                     * @property {app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties|null} [cRetrieveParkedCallRequest] CMessageStream cRetrieveParkedCallRequest
                     * @property {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null} [cCommitTargetAttachmentRequest] CMessageStream cCommitTargetAttachmentRequest
                     * @property {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null} [cGetTargetAttachmentRequest] CMessageStream cGetTargetAttachmentRequest
                     * @property {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null} [cAbortTargetAttachmentRequest] CMessageStream cAbortTargetAttachmentRequest
                     * @property {app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties|null} [sUpdateCallStatusResponse] CMessageStream sUpdateCallStatusResponse
                     * @property {app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties|null} [sRenegotiateCallResponse] CMessageStream sRenegotiateCallResponse
                     * @property {app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties|null} [sMediaFailureHintResponse] CMessageStream sMediaFailureHintResponse
                     * @property {app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties|null} [sRenegotiateCompleteResponse] CMessageStream sRenegotiateCompleteResponse
                     * @property {"pingPong"|"byteStreamOperation"|"cPlaceCallRequest"|"cAcceptCallRequest"|"cEndCallRequest"|"cReattachCallSessionRequest"|"cHoldCallRequest"|"cTransferCallRequest"|"cGetTurnCredentialsRequest"|"cSubmitAnswerRequest"|"cRequestIceRestartRequest"|"cSendDtmfRequest"|"cRequestMediaReplacementRequest"|"cPlaceAiAgentTestCallRequest"|"cGetTransferCapabilitiesRequest"|"cPickupCallRequest"|"cRetrieveParkedCallRequest"|"cCommitTargetAttachmentRequest"|"cGetTargetAttachmentRequest"|"cAbortTargetAttachmentRequest"|"sUpdateCallStatusResponse"|"sRenegotiateCallResponse"|"sMediaFailureHintResponse"|"sRenegotiateCompleteResponse"} [payload] CMessageStream payload
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a CMessageStream.
                     * @memberof app.zyno.talk.softphone
                     * @interface ICMessageStream
                     * @augments app.zyno.talk.softphone.CMessageStream.$Properties
                     * @deprecated Use app.zyno.talk.softphone.CMessageStream.$Properties instead.
                     */

                    /**
                     * Narrowed shape of a CMessageStream.
                     * @typedef {{
                     *   requestId?: string|null;
                     *   reply?: boolean|null;
                     *   error?: string|null;
                     *   userError?: boolean|null;
                     *   trace?: app.zyno.talk.softphone.TraceContext.$Shape|null;
                     *   pingPong?: app.zyno.talk.softphone.PingPong.$Shape|null;
                     *   byteStreamOperation?: app.zyno.talk.softphone.ByteStreamOperation.$Shape|null;
                     *   cPlaceCallRequest?: app.zyno.talk.softphone.CPlaceCallRequest.$Shape|null;
                     *   cAcceptCallRequest?: app.zyno.talk.softphone.CAcceptCallRequest.$Shape|null;
                     *   cEndCallRequest?: app.zyno.talk.softphone.CEndCallRequest.$Shape|null;
                     *   cReattachCallSessionRequest?: app.zyno.talk.softphone.CReattachCallSessionRequest.$Shape|null;
                     *   cHoldCallRequest?: app.zyno.talk.softphone.CHoldCallRequest.$Shape|null;
                     *   cTransferCallRequest?: app.zyno.talk.softphone.CTransferCallRequest.$Shape|null;
                     *   cGetTurnCredentialsRequest?: app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Shape|null;
                     *   cSubmitAnswerRequest?: app.zyno.talk.softphone.CSubmitAnswerRequest.$Shape|null;
                     *   cRequestIceRestartRequest?: app.zyno.talk.softphone.CRequestIceRestartRequest.$Shape|null;
                     *   cSendDtmfRequest?: app.zyno.talk.softphone.CSendDtmfRequest.$Shape|null;
                     *   cRequestMediaReplacementRequest?: app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Shape|null;
                     *   cPlaceAiAgentTestCallRequest?: app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Shape|null;
                     *   cGetTransferCapabilitiesRequest?: app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Shape|null;
                     *   cPickupCallRequest?: app.zyno.talk.softphone.CPickupCallRequest.$Shape|null;
                     *   cRetrieveParkedCallRequest?: app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Shape|null;
                     *   cCommitTargetAttachmentRequest?: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape|null;
                     *   cGetTargetAttachmentRequest?: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape|null;
                     *   cAbortTargetAttachmentRequest?: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape|null;
                     *   sUpdateCallStatusResponse?: app.zyno.talk.softphone.SUpdateCallStatusResponse.$Shape|null;
                     *   sRenegotiateCallResponse?: app.zyno.talk.softphone.SRenegotiateCallResponse.$Shape|null;
                     *   sMediaFailureHintResponse?: app.zyno.talk.softphone.SMediaFailureHintResponse.$Shape|null;
                     *   sRenegotiateCompleteResponse?: app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Shape|null;
                     *   $unknowns?: Array.<Uint8Array>;
                     * } & (
                     *   ({ payload?: undefined; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "pingPong"; pingPong: app.zyno.talk.softphone.PingPong.$Shape; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "byteStreamOperation"; pingPong?: null; byteStreamOperation: app.zyno.talk.softphone.ByteStreamOperation.$Shape; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cPlaceCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest: app.zyno.talk.softphone.CPlaceCallRequest.$Shape; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cAcceptCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest: app.zyno.talk.softphone.CAcceptCallRequest.$Shape; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cEndCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest: app.zyno.talk.softphone.CEndCallRequest.$Shape; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cReattachCallSessionRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest: app.zyno.talk.softphone.CReattachCallSessionRequest.$Shape; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cHoldCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest: app.zyno.talk.softphone.CHoldCallRequest.$Shape; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cTransferCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest: app.zyno.talk.softphone.CTransferCallRequest.$Shape; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cGetTurnCredentialsRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest: app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Shape; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cSubmitAnswerRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest: app.zyno.talk.softphone.CSubmitAnswerRequest.$Shape; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cRequestIceRestartRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest: app.zyno.talk.softphone.CRequestIceRestartRequest.$Shape; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cSendDtmfRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest: app.zyno.talk.softphone.CSendDtmfRequest.$Shape; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cRequestMediaReplacementRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest: app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Shape; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cPlaceAiAgentTestCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest: app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Shape; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cGetTransferCapabilitiesRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest: app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Shape; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cPickupCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest: app.zyno.talk.softphone.CPickupCallRequest.$Shape; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cRetrieveParkedCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest: app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Shape; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cCommitTargetAttachmentRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cGetTargetAttachmentRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "cAbortTargetAttachmentRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest: app.zyno.talk.softphone.CTargetAttachmentRequest.$Shape; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "sUpdateCallStatusResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse: app.zyno.talk.softphone.SUpdateCallStatusResponse.$Shape; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "sRenegotiateCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse: app.zyno.talk.softphone.SRenegotiateCallResponse.$Shape; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse?: null }|{ payload?: "sMediaFailureHintResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse: app.zyno.talk.softphone.SMediaFailureHintResponse.$Shape; sRenegotiateCompleteResponse?: null }|{ payload?: "sRenegotiateCompleteResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallRequest?: null; cAcceptCallRequest?: null; cEndCallRequest?: null; cReattachCallSessionRequest?: null; cHoldCallRequest?: null; cTransferCallRequest?: null; cGetTurnCredentialsRequest?: null; cSubmitAnswerRequest?: null; cRequestIceRestartRequest?: null; cSendDtmfRequest?: null; cRequestMediaReplacementRequest?: null; cPlaceAiAgentTestCallRequest?: null; cGetTransferCapabilitiesRequest?: null; cPickupCallRequest?: null; cRetrieveParkedCallRequest?: null; cCommitTargetAttachmentRequest?: null; cGetTargetAttachmentRequest?: null; cAbortTargetAttachmentRequest?: null; sUpdateCallStatusResponse?: null; sRenegotiateCallResponse?: null; sMediaFailureHintResponse?: null; sRenegotiateCompleteResponse: app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Shape })
                     * )} app.zyno.talk.softphone.CMessageStream.$Shape
                     */

                    /**
                     * Constructs a new CMessageStream.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a CMessageStream.
                     * @constructor
                     * @param {app.zyno.talk.softphone.CMessageStream.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const CMessageStream = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * CMessageStream requestId.
                     * @member {string} requestId
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.requestId = "";

                    /**
                     * CMessageStream reply.
                     * @member {boolean} reply
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.reply = false;

                    /**
                     * CMessageStream error.
                     * @member {string|null|undefined} error
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.error = null;

                    /**
                     * CMessageStream userError.
                     * @member {boolean|null|undefined} userError
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.userError = null;

                    /**
                     * CMessageStream trace.
                     * @member {app.zyno.talk.softphone.TraceContext.$Properties|null|undefined} trace
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.trace = null;

                    /**
                     * CMessageStream pingPong.
                     * @member {app.zyno.talk.softphone.PingPong.$Properties|null|undefined} pingPong
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.pingPong = null;

                    /**
                     * CMessageStream byteStreamOperation.
                     * @member {app.zyno.talk.softphone.ByteStreamOperation.$Properties|null|undefined} byteStreamOperation
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.byteStreamOperation = null;

                    /**
                     * CMessageStream cPlaceCallRequest.
                     * @member {app.zyno.talk.softphone.CPlaceCallRequest.$Properties|null|undefined} cPlaceCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cPlaceCallRequest = null;

                    /**
                     * CMessageStream cAcceptCallRequest.
                     * @member {app.zyno.talk.softphone.CAcceptCallRequest.$Properties|null|undefined} cAcceptCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cAcceptCallRequest = null;

                    /**
                     * CMessageStream cEndCallRequest.
                     * @member {app.zyno.talk.softphone.CEndCallRequest.$Properties|null|undefined} cEndCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cEndCallRequest = null;

                    /**
                     * CMessageStream cReattachCallSessionRequest.
                     * @member {app.zyno.talk.softphone.CReattachCallSessionRequest.$Properties|null|undefined} cReattachCallSessionRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cReattachCallSessionRequest = null;

                    /**
                     * CMessageStream cHoldCallRequest.
                     * @member {app.zyno.talk.softphone.CHoldCallRequest.$Properties|null|undefined} cHoldCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cHoldCallRequest = null;

                    /**
                     * CMessageStream cTransferCallRequest.
                     * @member {app.zyno.talk.softphone.CTransferCallRequest.$Properties|null|undefined} cTransferCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cTransferCallRequest = null;

                    /**
                     * CMessageStream cGetTurnCredentialsRequest.
                     * @member {app.zyno.talk.softphone.CGetTurnCredentialsRequest.$Properties|null|undefined} cGetTurnCredentialsRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cGetTurnCredentialsRequest = null;

                    /**
                     * CMessageStream cSubmitAnswerRequest.
                     * @member {app.zyno.talk.softphone.CSubmitAnswerRequest.$Properties|null|undefined} cSubmitAnswerRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cSubmitAnswerRequest = null;

                    /**
                     * CMessageStream cRequestIceRestartRequest.
                     * @member {app.zyno.talk.softphone.CRequestIceRestartRequest.$Properties|null|undefined} cRequestIceRestartRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cRequestIceRestartRequest = null;

                    /**
                     * CMessageStream cSendDtmfRequest.
                     * @member {app.zyno.talk.softphone.CSendDtmfRequest.$Properties|null|undefined} cSendDtmfRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cSendDtmfRequest = null;

                    /**
                     * CMessageStream cRequestMediaReplacementRequest.
                     * @member {app.zyno.talk.softphone.CRequestMediaReplacementRequest.$Properties|null|undefined} cRequestMediaReplacementRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cRequestMediaReplacementRequest = null;

                    /**
                     * CMessageStream cPlaceAiAgentTestCallRequest.
                     * @member {app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.$Properties|null|undefined} cPlaceAiAgentTestCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cPlaceAiAgentTestCallRequest = null;

                    /**
                     * CMessageStream cGetTransferCapabilitiesRequest.
                     * @member {app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.$Properties|null|undefined} cGetTransferCapabilitiesRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cGetTransferCapabilitiesRequest = null;

                    /**
                     * CMessageStream cPickupCallRequest.
                     * @member {app.zyno.talk.softphone.CPickupCallRequest.$Properties|null|undefined} cPickupCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cPickupCallRequest = null;

                    /**
                     * CMessageStream cRetrieveParkedCallRequest.
                     * @member {app.zyno.talk.softphone.CRetrieveParkedCallRequest.$Properties|null|undefined} cRetrieveParkedCallRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cRetrieveParkedCallRequest = null;

                    /**
                     * CMessageStream cCommitTargetAttachmentRequest.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null|undefined} cCommitTargetAttachmentRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cCommitTargetAttachmentRequest = null;

                    /**
                     * CMessageStream cGetTargetAttachmentRequest.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null|undefined} cGetTargetAttachmentRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cGetTargetAttachmentRequest = null;

                    /**
                     * CMessageStream cAbortTargetAttachmentRequest.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentRequest.$Properties|null|undefined} cAbortTargetAttachmentRequest
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.cAbortTargetAttachmentRequest = null;

                    /**
                     * CMessageStream sUpdateCallStatusResponse.
                     * @member {app.zyno.talk.softphone.SUpdateCallStatusResponse.$Properties|null|undefined} sUpdateCallStatusResponse
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.sUpdateCallStatusResponse = null;

                    /**
                     * CMessageStream sRenegotiateCallResponse.
                     * @member {app.zyno.talk.softphone.SRenegotiateCallResponse.$Properties|null|undefined} sRenegotiateCallResponse
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.sRenegotiateCallResponse = null;

                    /**
                     * CMessageStream sMediaFailureHintResponse.
                     * @member {app.zyno.talk.softphone.SMediaFailureHintResponse.$Properties|null|undefined} sMediaFailureHintResponse
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.sMediaFailureHintResponse = null;

                    /**
                     * CMessageStream sRenegotiateCompleteResponse.
                     * @member {app.zyno.talk.softphone.SRenegotiateCompleteResponse.$Properties|null|undefined} sRenegotiateCompleteResponse
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    CMessageStream.prototype.sRenegotiateCompleteResponse = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CMessageStream.prototype, "_error", {
                        get: $util.oneOfGetter($oneOfFields = ["error"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CMessageStream.prototype, "_userError", {
                        get: $util.oneOfGetter($oneOfFields = ["userError"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(CMessageStream.prototype, "_trace", {
                        get: $util.oneOfGetter($oneOfFields = ["trace"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * CMessageStream payload.
                     * @member {"pingPong"|"byteStreamOperation"|"cPlaceCallRequest"|"cAcceptCallRequest"|"cEndCallRequest"|"cReattachCallSessionRequest"|"cHoldCallRequest"|"cTransferCallRequest"|"cGetTurnCredentialsRequest"|"cSubmitAnswerRequest"|"cRequestIceRestartRequest"|"cSendDtmfRequest"|"cRequestMediaReplacementRequest"|"cPlaceAiAgentTestCallRequest"|"cGetTransferCapabilitiesRequest"|"cPickupCallRequest"|"cRetrieveParkedCallRequest"|"cCommitTargetAttachmentRequest"|"cGetTargetAttachmentRequest"|"cAbortTargetAttachmentRequest"|"sUpdateCallStatusResponse"|"sRenegotiateCallResponse"|"sMediaFailureHintResponse"|"sRenegotiateCompleteResponse"|undefined} payload
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @instance
                     */
                    $Object.defineProperty(CMessageStream.prototype, "payload", {
                        get: $util.oneOfGetter($oneOfFields = ["pingPong", "byteStreamOperation", "cPlaceCallRequest", "cAcceptCallRequest", "cEndCallRequest", "cReattachCallSessionRequest", "cHoldCallRequest", "cTransferCallRequest", "cGetTurnCredentialsRequest", "cSubmitAnswerRequest", "cRequestIceRestartRequest", "cSendDtmfRequest", "cRequestMediaReplacementRequest", "cPlaceAiAgentTestCallRequest", "cGetTransferCapabilitiesRequest", "cPickupCallRequest", "cRetrieveParkedCallRequest", "cCommitTargetAttachmentRequest", "cGetTargetAttachmentRequest", "cAbortTargetAttachmentRequest", "sUpdateCallStatusResponse", "sRenegotiateCallResponse", "sMediaFailureHintResponse", "sRenegotiateCompleteResponse"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified CMessageStream message. Does not implicitly {@link app.zyno.talk.softphone.CMessageStream.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @static
                     * @param {app.zyno.talk.softphone.CMessageStream.$Properties} message CMessageStream message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CMessageStream.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId") && message.requestId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                        if (message.reply != null && $Object.hasOwnProperty.call(message, "reply") && message.reply !== false)
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.reply);
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.error);
                        if (message.userError != null && $Object.hasOwnProperty.call(message, "userError"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.userError);
                        if (message.trace != null && $Object.hasOwnProperty.call(message, "trace"))
                            $root.app.zyno.talk.softphone.TraceContext.encode(message.trace, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
                        if (message.pingPong != null && $Object.hasOwnProperty.call(message, "pingPong"))
                            $root.app.zyno.talk.softphone.PingPong.encode(message.pingPong, writer.uint32(/* id 50, wireType 2 =*/402).fork(), _depth + 1).ldelim();
                        if (message.byteStreamOperation != null && $Object.hasOwnProperty.call(message, "byteStreamOperation"))
                            $root.app.zyno.talk.softphone.ByteStreamOperation.encode(message.byteStreamOperation, writer.uint32(/* id 51, wireType 2 =*/410).fork(), _depth + 1).ldelim();
                        if (message.cPlaceCallRequest != null && $Object.hasOwnProperty.call(message, "cPlaceCallRequest"))
                            $root.app.zyno.talk.softphone.CPlaceCallRequest.encode(message.cPlaceCallRequest, writer.uint32(/* id 1000, wireType 2 =*/8002).fork(), _depth + 1).ldelim();
                        if (message.cAcceptCallRequest != null && $Object.hasOwnProperty.call(message, "cAcceptCallRequest"))
                            $root.app.zyno.talk.softphone.CAcceptCallRequest.encode(message.cAcceptCallRequest, writer.uint32(/* id 1001, wireType 2 =*/8010).fork(), _depth + 1).ldelim();
                        if (message.cEndCallRequest != null && $Object.hasOwnProperty.call(message, "cEndCallRequest"))
                            $root.app.zyno.talk.softphone.CEndCallRequest.encode(message.cEndCallRequest, writer.uint32(/* id 1002, wireType 2 =*/8018).fork(), _depth + 1).ldelim();
                        if (message.cReattachCallSessionRequest != null && $Object.hasOwnProperty.call(message, "cReattachCallSessionRequest"))
                            $root.app.zyno.talk.softphone.CReattachCallSessionRequest.encode(message.cReattachCallSessionRequest, writer.uint32(/* id 1003, wireType 2 =*/8026).fork(), _depth + 1).ldelim();
                        if (message.cHoldCallRequest != null && $Object.hasOwnProperty.call(message, "cHoldCallRequest"))
                            $root.app.zyno.talk.softphone.CHoldCallRequest.encode(message.cHoldCallRequest, writer.uint32(/* id 1004, wireType 2 =*/8034).fork(), _depth + 1).ldelim();
                        if (message.cTransferCallRequest != null && $Object.hasOwnProperty.call(message, "cTransferCallRequest"))
                            $root.app.zyno.talk.softphone.CTransferCallRequest.encode(message.cTransferCallRequest, writer.uint32(/* id 1005, wireType 2 =*/8042).fork(), _depth + 1).ldelim();
                        if (message.cGetTurnCredentialsRequest != null && $Object.hasOwnProperty.call(message, "cGetTurnCredentialsRequest"))
                            $root.app.zyno.talk.softphone.CGetTurnCredentialsRequest.encode(message.cGetTurnCredentialsRequest, writer.uint32(/* id 1007, wireType 2 =*/8058).fork(), _depth + 1).ldelim();
                        if (message.cSubmitAnswerRequest != null && $Object.hasOwnProperty.call(message, "cSubmitAnswerRequest"))
                            $root.app.zyno.talk.softphone.CSubmitAnswerRequest.encode(message.cSubmitAnswerRequest, writer.uint32(/* id 1008, wireType 2 =*/8066).fork(), _depth + 1).ldelim();
                        if (message.cRequestIceRestartRequest != null && $Object.hasOwnProperty.call(message, "cRequestIceRestartRequest"))
                            $root.app.zyno.talk.softphone.CRequestIceRestartRequest.encode(message.cRequestIceRestartRequest, writer.uint32(/* id 1009, wireType 2 =*/8074).fork(), _depth + 1).ldelim();
                        if (message.cSendDtmfRequest != null && $Object.hasOwnProperty.call(message, "cSendDtmfRequest"))
                            $root.app.zyno.talk.softphone.CSendDtmfRequest.encode(message.cSendDtmfRequest, writer.uint32(/* id 1010, wireType 2 =*/8082).fork(), _depth + 1).ldelim();
                        if (message.cRequestMediaReplacementRequest != null && $Object.hasOwnProperty.call(message, "cRequestMediaReplacementRequest"))
                            $root.app.zyno.talk.softphone.CRequestMediaReplacementRequest.encode(message.cRequestMediaReplacementRequest, writer.uint32(/* id 1011, wireType 2 =*/8090).fork(), _depth + 1).ldelim();
                        if (message.cPlaceAiAgentTestCallRequest != null && $Object.hasOwnProperty.call(message, "cPlaceAiAgentTestCallRequest"))
                            $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.encode(message.cPlaceAiAgentTestCallRequest, writer.uint32(/* id 1012, wireType 2 =*/8098).fork(), _depth + 1).ldelim();
                        if (message.cGetTransferCapabilitiesRequest != null && $Object.hasOwnProperty.call(message, "cGetTransferCapabilitiesRequest"))
                            $root.app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.encode(message.cGetTransferCapabilitiesRequest, writer.uint32(/* id 1013, wireType 2 =*/8106).fork(), _depth + 1).ldelim();
                        if (message.cPickupCallRequest != null && $Object.hasOwnProperty.call(message, "cPickupCallRequest"))
                            $root.app.zyno.talk.softphone.CPickupCallRequest.encode(message.cPickupCallRequest, writer.uint32(/* id 1014, wireType 2 =*/8114).fork(), _depth + 1).ldelim();
                        if (message.cRetrieveParkedCallRequest != null && $Object.hasOwnProperty.call(message, "cRetrieveParkedCallRequest"))
                            $root.app.zyno.talk.softphone.CRetrieveParkedCallRequest.encode(message.cRetrieveParkedCallRequest, writer.uint32(/* id 1015, wireType 2 =*/8122).fork(), _depth + 1).ldelim();
                        if (message.cCommitTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cCommitTargetAttachmentRequest"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentRequest.encode(message.cCommitTargetAttachmentRequest, writer.uint32(/* id 1016, wireType 2 =*/8130).fork(), _depth + 1).ldelim();
                        if (message.cGetTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cGetTargetAttachmentRequest"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentRequest.encode(message.cGetTargetAttachmentRequest, writer.uint32(/* id 1017, wireType 2 =*/8138).fork(), _depth + 1).ldelim();
                        if (message.cAbortTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cAbortTargetAttachmentRequest"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentRequest.encode(message.cAbortTargetAttachmentRequest, writer.uint32(/* id 1018, wireType 2 =*/8146).fork(), _depth + 1).ldelim();
                        if (message.sUpdateCallStatusResponse != null && $Object.hasOwnProperty.call(message, "sUpdateCallStatusResponse"))
                            $root.app.zyno.talk.softphone.SUpdateCallStatusResponse.encode(message.sUpdateCallStatusResponse, writer.uint32(/* id 2000, wireType 2 =*/16002).fork(), _depth + 1).ldelim();
                        if (message.sRenegotiateCallResponse != null && $Object.hasOwnProperty.call(message, "sRenegotiateCallResponse"))
                            $root.app.zyno.talk.softphone.SRenegotiateCallResponse.encode(message.sRenegotiateCallResponse, writer.uint32(/* id 2001, wireType 2 =*/16010).fork(), _depth + 1).ldelim();
                        if (message.sMediaFailureHintResponse != null && $Object.hasOwnProperty.call(message, "sMediaFailureHintResponse"))
                            $root.app.zyno.talk.softphone.SMediaFailureHintResponse.encode(message.sMediaFailureHintResponse, writer.uint32(/* id 2002, wireType 2 =*/16018).fork(), _depth + 1).ldelim();
                        if (message.sRenegotiateCompleteResponse != null && $Object.hasOwnProperty.call(message, "sRenegotiateCompleteResponse"))
                            $root.app.zyno.talk.softphone.SRenegotiateCompleteResponse.encode(message.sRenegotiateCompleteResponse, writer.uint32(/* id 2003, wireType 2 =*/16026).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a CMessageStream message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.CMessageStream & app.zyno.talk.softphone.CMessageStream.$Shape} CMessageStream
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CMessageStream.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.CMessageStream();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.requestId = value;
                                    else
                                        delete message.requestId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.bool())
                                        message.reply = value;
                                    else
                                        delete message.reply;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.error = reader.stringVerify();
                                    message._error = "error";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 0)
                                        break;
                                    message.userError = reader.bool();
                                    message._userError = "userError";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.trace = $root.app.zyno.talk.softphone.TraceContext.decode(reader, reader.size(), $undefined, _depth + 1, message.trace);
                                    message._trace = "trace";
                                    continue;
                                }
                            case 50: {
                                    if (wireType !== 2)
                                        break;
                                    message.pingPong = $root.app.zyno.talk.softphone.PingPong.decode(reader, reader.size(), $undefined, _depth + 1, message.pingPong);
                                    message.payload = "pingPong";
                                    continue;
                                }
                            case 51: {
                                    if (wireType !== 2)
                                        break;
                                    message.byteStreamOperation = $root.app.zyno.talk.softphone.ByteStreamOperation.decode(reader, reader.size(), $undefined, _depth + 1, message.byteStreamOperation);
                                    message.payload = "byteStreamOperation";
                                    continue;
                                }
                            case 1000: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPlaceCallRequest = $root.app.zyno.talk.softphone.CPlaceCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cPlaceCallRequest);
                                    message.payload = "cPlaceCallRequest";
                                    continue;
                                }
                            case 1001: {
                                    if (wireType !== 2)
                                        break;
                                    message.cAcceptCallRequest = $root.app.zyno.talk.softphone.CAcceptCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cAcceptCallRequest);
                                    message.payload = "cAcceptCallRequest";
                                    continue;
                                }
                            case 1002: {
                                    if (wireType !== 2)
                                        break;
                                    message.cEndCallRequest = $root.app.zyno.talk.softphone.CEndCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cEndCallRequest);
                                    message.payload = "cEndCallRequest";
                                    continue;
                                }
                            case 1003: {
                                    if (wireType !== 2)
                                        break;
                                    message.cReattachCallSessionRequest = $root.app.zyno.talk.softphone.CReattachCallSessionRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cReattachCallSessionRequest);
                                    message.payload = "cReattachCallSessionRequest";
                                    continue;
                                }
                            case 1004: {
                                    if (wireType !== 2)
                                        break;
                                    message.cHoldCallRequest = $root.app.zyno.talk.softphone.CHoldCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cHoldCallRequest);
                                    message.payload = "cHoldCallRequest";
                                    continue;
                                }
                            case 1005: {
                                    if (wireType !== 2)
                                        break;
                                    message.cTransferCallRequest = $root.app.zyno.talk.softphone.CTransferCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cTransferCallRequest);
                                    message.payload = "cTransferCallRequest";
                                    continue;
                                }
                            case 1007: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTurnCredentialsRequest = $root.app.zyno.talk.softphone.CGetTurnCredentialsRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTurnCredentialsRequest);
                                    message.payload = "cGetTurnCredentialsRequest";
                                    continue;
                                }
                            case 1008: {
                                    if (wireType !== 2)
                                        break;
                                    message.cSubmitAnswerRequest = $root.app.zyno.talk.softphone.CSubmitAnswerRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cSubmitAnswerRequest);
                                    message.payload = "cSubmitAnswerRequest";
                                    continue;
                                }
                            case 1009: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRequestIceRestartRequest = $root.app.zyno.talk.softphone.CRequestIceRestartRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cRequestIceRestartRequest);
                                    message.payload = "cRequestIceRestartRequest";
                                    continue;
                                }
                            case 1010: {
                                    if (wireType !== 2)
                                        break;
                                    message.cSendDtmfRequest = $root.app.zyno.talk.softphone.CSendDtmfRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cSendDtmfRequest);
                                    message.payload = "cSendDtmfRequest";
                                    continue;
                                }
                            case 1011: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRequestMediaReplacementRequest = $root.app.zyno.talk.softphone.CRequestMediaReplacementRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cRequestMediaReplacementRequest);
                                    message.payload = "cRequestMediaReplacementRequest";
                                    continue;
                                }
                            case 1012: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPlaceAiAgentTestCallRequest = $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cPlaceAiAgentTestCallRequest);
                                    message.payload = "cPlaceAiAgentTestCallRequest";
                                    continue;
                                }
                            case 1013: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTransferCapabilitiesRequest = $root.app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTransferCapabilitiesRequest);
                                    message.payload = "cGetTransferCapabilitiesRequest";
                                    continue;
                                }
                            case 1014: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPickupCallRequest = $root.app.zyno.talk.softphone.CPickupCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cPickupCallRequest);
                                    message.payload = "cPickupCallRequest";
                                    continue;
                                }
                            case 1015: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRetrieveParkedCallRequest = $root.app.zyno.talk.softphone.CRetrieveParkedCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cRetrieveParkedCallRequest);
                                    message.payload = "cRetrieveParkedCallRequest";
                                    continue;
                                }
                            case 1016: {
                                    if (wireType !== 2)
                                        break;
                                    message.cCommitTargetAttachmentRequest = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cCommitTargetAttachmentRequest);
                                    message.payload = "cCommitTargetAttachmentRequest";
                                    continue;
                                }
                            case 1017: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTargetAttachmentRequest = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTargetAttachmentRequest);
                                    message.payload = "cGetTargetAttachmentRequest";
                                    continue;
                                }
                            case 1018: {
                                    if (wireType !== 2)
                                        break;
                                    message.cAbortTargetAttachmentRequest = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.cAbortTargetAttachmentRequest);
                                    message.payload = "cAbortTargetAttachmentRequest";
                                    continue;
                                }
                            case 2000: {
                                    if (wireType !== 2)
                                        break;
                                    message.sUpdateCallStatusResponse = $root.app.zyno.talk.softphone.SUpdateCallStatusResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.sUpdateCallStatusResponse);
                                    message.payload = "sUpdateCallStatusResponse";
                                    continue;
                                }
                            case 2001: {
                                    if (wireType !== 2)
                                        break;
                                    message.sRenegotiateCallResponse = $root.app.zyno.talk.softphone.SRenegotiateCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.sRenegotiateCallResponse);
                                    message.payload = "sRenegotiateCallResponse";
                                    continue;
                                }
                            case 2002: {
                                    if (wireType !== 2)
                                        break;
                                    message.sMediaFailureHintResponse = $root.app.zyno.talk.softphone.SMediaFailureHintResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.sMediaFailureHintResponse);
                                    message.payload = "sMediaFailureHintResponse";
                                    continue;
                                }
                            case 2003: {
                                    if (wireType !== 2)
                                        break;
                                    message.sRenegotiateCompleteResponse = $root.app.zyno.talk.softphone.SRenegotiateCompleteResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.sRenegotiateCompleteResponse);
                                    message.payload = "sRenegotiateCompleteResponse";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a CMessageStream message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CMessageStream.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId"))
                            if (!$util.isString(message.requestId))
                                return "requestId: string expected";
                        if (message.reply != null && $Object.hasOwnProperty.call(message, "reply"))
                            if (typeof message.reply !== "boolean")
                                return "reply: boolean expected";
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error")) {
                            properties._error = 1;
                            if (!$util.isString(message.error))
                                return "error: string expected";
                        }
                        if (message.userError != null && $Object.hasOwnProperty.call(message, "userError")) {
                            properties._userError = 1;
                            if (typeof message.userError !== "boolean")
                                return "userError: boolean expected";
                        }
                        if (message.trace != null && $Object.hasOwnProperty.call(message, "trace")) {
                            properties._trace = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TraceContext.verify(message.trace, _depth + 1);
                                if (error)
                                    return "trace." + error;
                            }
                        }
                        if (message.pingPong != null && $Object.hasOwnProperty.call(message, "pingPong")) {
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.PingPong.verify(message.pingPong, _depth + 1);
                                if (error)
                                    return "pingPong." + error;
                            }
                        }
                        if (message.byteStreamOperation != null && $Object.hasOwnProperty.call(message, "byteStreamOperation")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.ByteStreamOperation.verify(message.byteStreamOperation, _depth + 1);
                                if (error)
                                    return "byteStreamOperation." + error;
                            }
                        }
                        if (message.cPlaceCallRequest != null && $Object.hasOwnProperty.call(message, "cPlaceCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CPlaceCallRequest.verify(message.cPlaceCallRequest, _depth + 1);
                                if (error)
                                    return "cPlaceCallRequest." + error;
                            }
                        }
                        if (message.cAcceptCallRequest != null && $Object.hasOwnProperty.call(message, "cAcceptCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CAcceptCallRequest.verify(message.cAcceptCallRequest, _depth + 1);
                                if (error)
                                    return "cAcceptCallRequest." + error;
                            }
                        }
                        if (message.cEndCallRequest != null && $Object.hasOwnProperty.call(message, "cEndCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CEndCallRequest.verify(message.cEndCallRequest, _depth + 1);
                                if (error)
                                    return "cEndCallRequest." + error;
                            }
                        }
                        if (message.cReattachCallSessionRequest != null && $Object.hasOwnProperty.call(message, "cReattachCallSessionRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CReattachCallSessionRequest.verify(message.cReattachCallSessionRequest, _depth + 1);
                                if (error)
                                    return "cReattachCallSessionRequest." + error;
                            }
                        }
                        if (message.cHoldCallRequest != null && $Object.hasOwnProperty.call(message, "cHoldCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CHoldCallRequest.verify(message.cHoldCallRequest, _depth + 1);
                                if (error)
                                    return "cHoldCallRequest." + error;
                            }
                        }
                        if (message.cTransferCallRequest != null && $Object.hasOwnProperty.call(message, "cTransferCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTransferCallRequest.verify(message.cTransferCallRequest, _depth + 1);
                                if (error)
                                    return "cTransferCallRequest." + error;
                            }
                        }
                        if (message.cGetTurnCredentialsRequest != null && $Object.hasOwnProperty.call(message, "cGetTurnCredentialsRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CGetTurnCredentialsRequest.verify(message.cGetTurnCredentialsRequest, _depth + 1);
                                if (error)
                                    return "cGetTurnCredentialsRequest." + error;
                            }
                        }
                        if (message.cSubmitAnswerRequest != null && $Object.hasOwnProperty.call(message, "cSubmitAnswerRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CSubmitAnswerRequest.verify(message.cSubmitAnswerRequest, _depth + 1);
                                if (error)
                                    return "cSubmitAnswerRequest." + error;
                            }
                        }
                        if (message.cRequestIceRestartRequest != null && $Object.hasOwnProperty.call(message, "cRequestIceRestartRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CRequestIceRestartRequest.verify(message.cRequestIceRestartRequest, _depth + 1);
                                if (error)
                                    return "cRequestIceRestartRequest." + error;
                            }
                        }
                        if (message.cSendDtmfRequest != null && $Object.hasOwnProperty.call(message, "cSendDtmfRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CSendDtmfRequest.verify(message.cSendDtmfRequest, _depth + 1);
                                if (error)
                                    return "cSendDtmfRequest." + error;
                            }
                        }
                        if (message.cRequestMediaReplacementRequest != null && $Object.hasOwnProperty.call(message, "cRequestMediaReplacementRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CRequestMediaReplacementRequest.verify(message.cRequestMediaReplacementRequest, _depth + 1);
                                if (error)
                                    return "cRequestMediaReplacementRequest." + error;
                            }
                        }
                        if (message.cPlaceAiAgentTestCallRequest != null && $Object.hasOwnProperty.call(message, "cPlaceAiAgentTestCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallRequest.verify(message.cPlaceAiAgentTestCallRequest, _depth + 1);
                                if (error)
                                    return "cPlaceAiAgentTestCallRequest." + error;
                            }
                        }
                        if (message.cGetTransferCapabilitiesRequest != null && $Object.hasOwnProperty.call(message, "cGetTransferCapabilitiesRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CGetTransferCapabilitiesRequest.verify(message.cGetTransferCapabilitiesRequest, _depth + 1);
                                if (error)
                                    return "cGetTransferCapabilitiesRequest." + error;
                            }
                        }
                        if (message.cPickupCallRequest != null && $Object.hasOwnProperty.call(message, "cPickupCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CPickupCallRequest.verify(message.cPickupCallRequest, _depth + 1);
                                if (error)
                                    return "cPickupCallRequest." + error;
                            }
                        }
                        if (message.cRetrieveParkedCallRequest != null && $Object.hasOwnProperty.call(message, "cRetrieveParkedCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CRetrieveParkedCallRequest.verify(message.cRetrieveParkedCallRequest, _depth + 1);
                                if (error)
                                    return "cRetrieveParkedCallRequest." + error;
                            }
                        }
                        if (message.cCommitTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cCommitTargetAttachmentRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.verify(message.cCommitTargetAttachmentRequest, _depth + 1);
                                if (error)
                                    return "cCommitTargetAttachmentRequest." + error;
                            }
                        }
                        if (message.cGetTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cGetTargetAttachmentRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.verify(message.cGetTargetAttachmentRequest, _depth + 1);
                                if (error)
                                    return "cGetTargetAttachmentRequest." + error;
                            }
                        }
                        if (message.cAbortTargetAttachmentRequest != null && $Object.hasOwnProperty.call(message, "cAbortTargetAttachmentRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentRequest.verify(message.cAbortTargetAttachmentRequest, _depth + 1);
                                if (error)
                                    return "cAbortTargetAttachmentRequest." + error;
                            }
                        }
                        if (message.sUpdateCallStatusResponse != null && $Object.hasOwnProperty.call(message, "sUpdateCallStatusResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SUpdateCallStatusResponse.verify(message.sUpdateCallStatusResponse, _depth + 1);
                                if (error)
                                    return "sUpdateCallStatusResponse." + error;
                            }
                        }
                        if (message.sRenegotiateCallResponse != null && $Object.hasOwnProperty.call(message, "sRenegotiateCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SRenegotiateCallResponse.verify(message.sRenegotiateCallResponse, _depth + 1);
                                if (error)
                                    return "sRenegotiateCallResponse." + error;
                            }
                        }
                        if (message.sMediaFailureHintResponse != null && $Object.hasOwnProperty.call(message, "sMediaFailureHintResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SMediaFailureHintResponse.verify(message.sMediaFailureHintResponse, _depth + 1);
                                if (error)
                                    return "sMediaFailureHintResponse." + error;
                            }
                        }
                        if (message.sRenegotiateCompleteResponse != null && $Object.hasOwnProperty.call(message, "sRenegotiateCompleteResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SRenegotiateCompleteResponse.verify(message.sRenegotiateCompleteResponse, _depth + 1);
                                if (error)
                                    return "sRenegotiateCompleteResponse." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for CMessageStream
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.CMessageStream
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    CMessageStream.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.CMessageStream";
                    };

                    return CMessageStream;
                })();

                softphone.SMessageStream = (function() {

                    /**
                     * Properties of a SMessageStream.
                     * @typedef {Object} app.zyno.talk.softphone.SMessageStream.$Properties
                     * @property {string|null} [requestId] SMessageStream requestId
                     * @property {boolean|null} [reply] SMessageStream reply
                     * @property {string|null} [error] SMessageStream error
                     * @property {boolean|null} [userError] SMessageStream userError
                     * @property {app.zyno.talk.softphone.TraceContext.$Properties|null} [trace] SMessageStream trace
                     * @property {app.zyno.talk.softphone.PingPong.$Properties|null} [pingPong] SMessageStream pingPong
                     * @property {app.zyno.talk.softphone.ByteStreamOperation.$Properties|null} [byteStreamOperation] SMessageStream byteStreamOperation
                     * @property {app.zyno.talk.softphone.CPlaceCallResponse.$Properties|null} [cPlaceCallResponse] SMessageStream cPlaceCallResponse
                     * @property {app.zyno.talk.softphone.CAcceptCallResponse.$Properties|null} [cAcceptCallResponse] SMessageStream cAcceptCallResponse
                     * @property {app.zyno.talk.softphone.CEndCallResponse.$Properties|null} [cEndCallResponse] SMessageStream cEndCallResponse
                     * @property {app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties|null} [cReattachCallSessionResponse] SMessageStream cReattachCallSessionResponse
                     * @property {app.zyno.talk.softphone.CHoldCallResponse.$Properties|null} [cHoldCallResponse] SMessageStream cHoldCallResponse
                     * @property {app.zyno.talk.softphone.CTransferCallResponse.$Properties|null} [cTransferCallResponse] SMessageStream cTransferCallResponse
                     * @property {app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties|null} [cGetTurnCredentialsResponse] SMessageStream cGetTurnCredentialsResponse
                     * @property {app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties|null} [cSubmitAnswerResponse] SMessageStream cSubmitAnswerResponse
                     * @property {app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties|null} [cRequestIceRestartResponse] SMessageStream cRequestIceRestartResponse
                     * @property {app.zyno.talk.softphone.CSendDtmfResponse.$Properties|null} [cSendDtmfResponse] SMessageStream cSendDtmfResponse
                     * @property {app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties|null} [cRequestMediaReplacementResponse] SMessageStream cRequestMediaReplacementResponse
                     * @property {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties|null} [cPlaceAiAgentTestCallResponse] SMessageStream cPlaceAiAgentTestCallResponse
                     * @property {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties|null} [cGetTransferCapabilitiesResponse] SMessageStream cGetTransferCapabilitiesResponse
                     * @property {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null} [cPickupCallResponse] SMessageStream cPickupCallResponse
                     * @property {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null} [cRetrieveParkedCallResponse] SMessageStream cRetrieveParkedCallResponse
                     * @property {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null} [cCommitTargetAttachmentResponse] SMessageStream cCommitTargetAttachmentResponse
                     * @property {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null} [cGetTargetAttachmentResponse] SMessageStream cGetTargetAttachmentResponse
                     * @property {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null} [cAbortTargetAttachmentResponse] SMessageStream cAbortTargetAttachmentResponse
                     * @property {app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties|null} [sUpdateCallStatusRequest] SMessageStream sUpdateCallStatusRequest
                     * @property {app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties|null} [sRenegotiateCallRequest] SMessageStream sRenegotiateCallRequest
                     * @property {app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties|null} [sMediaFailureHintRequest] SMessageStream sMediaFailureHintRequest
                     * @property {app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties|null} [sRenegotiateCompleteRequest] SMessageStream sRenegotiateCompleteRequest
                     * @property {"pingPong"|"byteStreamOperation"|"cPlaceCallResponse"|"cAcceptCallResponse"|"cEndCallResponse"|"cReattachCallSessionResponse"|"cHoldCallResponse"|"cTransferCallResponse"|"cGetTurnCredentialsResponse"|"cSubmitAnswerResponse"|"cRequestIceRestartResponse"|"cSendDtmfResponse"|"cRequestMediaReplacementResponse"|"cPlaceAiAgentTestCallResponse"|"cGetTransferCapabilitiesResponse"|"cPickupCallResponse"|"cRetrieveParkedCallResponse"|"cCommitTargetAttachmentResponse"|"cGetTargetAttachmentResponse"|"cAbortTargetAttachmentResponse"|"sUpdateCallStatusRequest"|"sRenegotiateCallRequest"|"sMediaFailureHintRequest"|"sRenegotiateCompleteRequest"} [payload] SMessageStream payload
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */

                    /**
                     * Properties of a SMessageStream.
                     * @memberof app.zyno.talk.softphone
                     * @interface ISMessageStream
                     * @augments app.zyno.talk.softphone.SMessageStream.$Properties
                     * @deprecated Use app.zyno.talk.softphone.SMessageStream.$Properties instead.
                     */

                    /**
                     * Narrowed shape of a SMessageStream.
                     * @typedef {{
                     *   requestId?: string|null;
                     *   reply?: boolean|null;
                     *   error?: string|null;
                     *   userError?: boolean|null;
                     *   trace?: app.zyno.talk.softphone.TraceContext.$Shape|null;
                     *   pingPong?: app.zyno.talk.softphone.PingPong.$Shape|null;
                     *   byteStreamOperation?: app.zyno.talk.softphone.ByteStreamOperation.$Shape|null;
                     *   cPlaceCallResponse?: app.zyno.talk.softphone.CPlaceCallResponse.$Shape|null;
                     *   cAcceptCallResponse?: app.zyno.talk.softphone.CAcceptCallResponse.$Shape|null;
                     *   cEndCallResponse?: app.zyno.talk.softphone.CEndCallResponse.$Shape|null;
                     *   cReattachCallSessionResponse?: app.zyno.talk.softphone.CReattachCallSessionResponse.$Shape|null;
                     *   cHoldCallResponse?: app.zyno.talk.softphone.CHoldCallResponse.$Shape|null;
                     *   cTransferCallResponse?: app.zyno.talk.softphone.CTransferCallResponse.$Shape|null;
                     *   cGetTurnCredentialsResponse?: app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Shape|null;
                     *   cSubmitAnswerResponse?: app.zyno.talk.softphone.CSubmitAnswerResponse.$Shape|null;
                     *   cRequestIceRestartResponse?: app.zyno.talk.softphone.CRequestIceRestartResponse.$Shape|null;
                     *   cSendDtmfResponse?: app.zyno.talk.softphone.CSendDtmfResponse.$Shape|null;
                     *   cRequestMediaReplacementResponse?: app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Shape|null;
                     *   cPlaceAiAgentTestCallResponse?: app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Shape|null;
                     *   cGetTransferCapabilitiesResponse?: app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Shape|null;
                     *   cPickupCallResponse?: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape|null;
                     *   cRetrieveParkedCallResponse?: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape|null;
                     *   cCommitTargetAttachmentResponse?: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape|null;
                     *   cGetTargetAttachmentResponse?: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape|null;
                     *   cAbortTargetAttachmentResponse?: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape|null;
                     *   sUpdateCallStatusRequest?: app.zyno.talk.softphone.SUpdateCallStatusRequest.$Shape|null;
                     *   sRenegotiateCallRequest?: app.zyno.talk.softphone.SRenegotiateCallRequest.$Shape|null;
                     *   sMediaFailureHintRequest?: app.zyno.talk.softphone.SMediaFailureHintRequest.$Shape|null;
                     *   sRenegotiateCompleteRequest?: app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Shape|null;
                     *   $unknowns?: Array.<Uint8Array>;
                     * } & (
                     *   ({ payload?: undefined; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "pingPong"; pingPong: app.zyno.talk.softphone.PingPong.$Shape; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "byteStreamOperation"; pingPong?: null; byteStreamOperation: app.zyno.talk.softphone.ByteStreamOperation.$Shape; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cPlaceCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse: app.zyno.talk.softphone.CPlaceCallResponse.$Shape; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cAcceptCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse: app.zyno.talk.softphone.CAcceptCallResponse.$Shape; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cEndCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse: app.zyno.talk.softphone.CEndCallResponse.$Shape; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cReattachCallSessionResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse: app.zyno.talk.softphone.CReattachCallSessionResponse.$Shape; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cHoldCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse: app.zyno.talk.softphone.CHoldCallResponse.$Shape; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cTransferCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse: app.zyno.talk.softphone.CTransferCallResponse.$Shape; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cGetTurnCredentialsResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse: app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Shape; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cSubmitAnswerResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse: app.zyno.talk.softphone.CSubmitAnswerResponse.$Shape; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cRequestIceRestartResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse: app.zyno.talk.softphone.CRequestIceRestartResponse.$Shape; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cSendDtmfResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse: app.zyno.talk.softphone.CSendDtmfResponse.$Shape; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cRequestMediaReplacementResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse: app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Shape; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cPlaceAiAgentTestCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse: app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Shape; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cGetTransferCapabilitiesResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse: app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Shape; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cPickupCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cRetrieveParkedCallResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cCommitTargetAttachmentResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cGetTargetAttachmentResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "cAbortTargetAttachmentResponse"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse: app.zyno.talk.softphone.CTargetAttachmentResponse.$Shape; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "sUpdateCallStatusRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest: app.zyno.talk.softphone.SUpdateCallStatusRequest.$Shape; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "sRenegotiateCallRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest: app.zyno.talk.softphone.SRenegotiateCallRequest.$Shape; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest?: null }|{ payload?: "sMediaFailureHintRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest: app.zyno.talk.softphone.SMediaFailureHintRequest.$Shape; sRenegotiateCompleteRequest?: null }|{ payload?: "sRenegotiateCompleteRequest"; pingPong?: null; byteStreamOperation?: null; cPlaceCallResponse?: null; cAcceptCallResponse?: null; cEndCallResponse?: null; cReattachCallSessionResponse?: null; cHoldCallResponse?: null; cTransferCallResponse?: null; cGetTurnCredentialsResponse?: null; cSubmitAnswerResponse?: null; cRequestIceRestartResponse?: null; cSendDtmfResponse?: null; cRequestMediaReplacementResponse?: null; cPlaceAiAgentTestCallResponse?: null; cGetTransferCapabilitiesResponse?: null; cPickupCallResponse?: null; cRetrieveParkedCallResponse?: null; cCommitTargetAttachmentResponse?: null; cGetTargetAttachmentResponse?: null; cAbortTargetAttachmentResponse?: null; sUpdateCallStatusRequest?: null; sRenegotiateCallRequest?: null; sMediaFailureHintRequest?: null; sRenegotiateCompleteRequest: app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Shape })
                     * )} app.zyno.talk.softphone.SMessageStream.$Shape
                     */

                    /**
                     * Constructs a new SMessageStream.
                     * @memberof app.zyno.talk.softphone
                     * @classdesc Represents a SMessageStream.
                     * @constructor
                     * @param {app.zyno.talk.softphone.SMessageStream.$Properties=} [properties] Properties to set
                     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
                     */
                    const SMessageStream = function (properties) {
                        if (properties)
                            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    };

                    /**
                     * SMessageStream requestId.
                     * @member {string} requestId
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.requestId = "";

                    /**
                     * SMessageStream reply.
                     * @member {boolean} reply
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.reply = false;

                    /**
                     * SMessageStream error.
                     * @member {string|null|undefined} error
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.error = null;

                    /**
                     * SMessageStream userError.
                     * @member {boolean|null|undefined} userError
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.userError = null;

                    /**
                     * SMessageStream trace.
                     * @member {app.zyno.talk.softphone.TraceContext.$Properties|null|undefined} trace
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.trace = null;

                    /**
                     * SMessageStream pingPong.
                     * @member {app.zyno.talk.softphone.PingPong.$Properties|null|undefined} pingPong
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.pingPong = null;

                    /**
                     * SMessageStream byteStreamOperation.
                     * @member {app.zyno.talk.softphone.ByteStreamOperation.$Properties|null|undefined} byteStreamOperation
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.byteStreamOperation = null;

                    /**
                     * SMessageStream cPlaceCallResponse.
                     * @member {app.zyno.talk.softphone.CPlaceCallResponse.$Properties|null|undefined} cPlaceCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cPlaceCallResponse = null;

                    /**
                     * SMessageStream cAcceptCallResponse.
                     * @member {app.zyno.talk.softphone.CAcceptCallResponse.$Properties|null|undefined} cAcceptCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cAcceptCallResponse = null;

                    /**
                     * SMessageStream cEndCallResponse.
                     * @member {app.zyno.talk.softphone.CEndCallResponse.$Properties|null|undefined} cEndCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cEndCallResponse = null;

                    /**
                     * SMessageStream cReattachCallSessionResponse.
                     * @member {app.zyno.talk.softphone.CReattachCallSessionResponse.$Properties|null|undefined} cReattachCallSessionResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cReattachCallSessionResponse = null;

                    /**
                     * SMessageStream cHoldCallResponse.
                     * @member {app.zyno.talk.softphone.CHoldCallResponse.$Properties|null|undefined} cHoldCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cHoldCallResponse = null;

                    /**
                     * SMessageStream cTransferCallResponse.
                     * @member {app.zyno.talk.softphone.CTransferCallResponse.$Properties|null|undefined} cTransferCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cTransferCallResponse = null;

                    /**
                     * SMessageStream cGetTurnCredentialsResponse.
                     * @member {app.zyno.talk.softphone.CGetTurnCredentialsResponse.$Properties|null|undefined} cGetTurnCredentialsResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cGetTurnCredentialsResponse = null;

                    /**
                     * SMessageStream cSubmitAnswerResponse.
                     * @member {app.zyno.talk.softphone.CSubmitAnswerResponse.$Properties|null|undefined} cSubmitAnswerResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cSubmitAnswerResponse = null;

                    /**
                     * SMessageStream cRequestIceRestartResponse.
                     * @member {app.zyno.talk.softphone.CRequestIceRestartResponse.$Properties|null|undefined} cRequestIceRestartResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cRequestIceRestartResponse = null;

                    /**
                     * SMessageStream cSendDtmfResponse.
                     * @member {app.zyno.talk.softphone.CSendDtmfResponse.$Properties|null|undefined} cSendDtmfResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cSendDtmfResponse = null;

                    /**
                     * SMessageStream cRequestMediaReplacementResponse.
                     * @member {app.zyno.talk.softphone.CRequestMediaReplacementResponse.$Properties|null|undefined} cRequestMediaReplacementResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cRequestMediaReplacementResponse = null;

                    /**
                     * SMessageStream cPlaceAiAgentTestCallResponse.
                     * @member {app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.$Properties|null|undefined} cPlaceAiAgentTestCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cPlaceAiAgentTestCallResponse = null;

                    /**
                     * SMessageStream cGetTransferCapabilitiesResponse.
                     * @member {app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.$Properties|null|undefined} cGetTransferCapabilitiesResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cGetTransferCapabilitiesResponse = null;

                    /**
                     * SMessageStream cPickupCallResponse.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null|undefined} cPickupCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cPickupCallResponse = null;

                    /**
                     * SMessageStream cRetrieveParkedCallResponse.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null|undefined} cRetrieveParkedCallResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cRetrieveParkedCallResponse = null;

                    /**
                     * SMessageStream cCommitTargetAttachmentResponse.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null|undefined} cCommitTargetAttachmentResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cCommitTargetAttachmentResponse = null;

                    /**
                     * SMessageStream cGetTargetAttachmentResponse.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null|undefined} cGetTargetAttachmentResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cGetTargetAttachmentResponse = null;

                    /**
                     * SMessageStream cAbortTargetAttachmentResponse.
                     * @member {app.zyno.talk.softphone.CTargetAttachmentResponse.$Properties|null|undefined} cAbortTargetAttachmentResponse
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.cAbortTargetAttachmentResponse = null;

                    /**
                     * SMessageStream sUpdateCallStatusRequest.
                     * @member {app.zyno.talk.softphone.SUpdateCallStatusRequest.$Properties|null|undefined} sUpdateCallStatusRequest
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.sUpdateCallStatusRequest = null;

                    /**
                     * SMessageStream sRenegotiateCallRequest.
                     * @member {app.zyno.talk.softphone.SRenegotiateCallRequest.$Properties|null|undefined} sRenegotiateCallRequest
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.sRenegotiateCallRequest = null;

                    /**
                     * SMessageStream sMediaFailureHintRequest.
                     * @member {app.zyno.talk.softphone.SMediaFailureHintRequest.$Properties|null|undefined} sMediaFailureHintRequest
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.sMediaFailureHintRequest = null;

                    /**
                     * SMessageStream sRenegotiateCompleteRequest.
                     * @member {app.zyno.talk.softphone.SRenegotiateCompleteRequest.$Properties|null|undefined} sRenegotiateCompleteRequest
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    SMessageStream.prototype.sRenegotiateCompleteRequest = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SMessageStream.prototype, "_error", {
                        get: $util.oneOfGetter($oneOfFields = ["error"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SMessageStream.prototype, "_userError", {
                        get: $util.oneOfGetter($oneOfFields = ["userError"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    $Object.defineProperty(SMessageStream.prototype, "_trace", {
                        get: $util.oneOfGetter($oneOfFields = ["trace"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * SMessageStream payload.
                     * @member {"pingPong"|"byteStreamOperation"|"cPlaceCallResponse"|"cAcceptCallResponse"|"cEndCallResponse"|"cReattachCallSessionResponse"|"cHoldCallResponse"|"cTransferCallResponse"|"cGetTurnCredentialsResponse"|"cSubmitAnswerResponse"|"cRequestIceRestartResponse"|"cSendDtmfResponse"|"cRequestMediaReplacementResponse"|"cPlaceAiAgentTestCallResponse"|"cGetTransferCapabilitiesResponse"|"cPickupCallResponse"|"cRetrieveParkedCallResponse"|"cCommitTargetAttachmentResponse"|"cGetTargetAttachmentResponse"|"cAbortTargetAttachmentResponse"|"sUpdateCallStatusRequest"|"sRenegotiateCallRequest"|"sMediaFailureHintRequest"|"sRenegotiateCompleteRequest"|undefined} payload
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @instance
                     */
                    $Object.defineProperty(SMessageStream.prototype, "payload", {
                        get: $util.oneOfGetter($oneOfFields = ["pingPong", "byteStreamOperation", "cPlaceCallResponse", "cAcceptCallResponse", "cEndCallResponse", "cReattachCallSessionResponse", "cHoldCallResponse", "cTransferCallResponse", "cGetTurnCredentialsResponse", "cSubmitAnswerResponse", "cRequestIceRestartResponse", "cSendDtmfResponse", "cRequestMediaReplacementResponse", "cPlaceAiAgentTestCallResponse", "cGetTransferCapabilitiesResponse", "cPickupCallResponse", "cRetrieveParkedCallResponse", "cCommitTargetAttachmentResponse", "cGetTargetAttachmentResponse", "cAbortTargetAttachmentResponse", "sUpdateCallStatusRequest", "sRenegotiateCallRequest", "sMediaFailureHintRequest", "sRenegotiateCompleteRequest"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Encodes the specified SMessageStream message. Does not implicitly {@link app.zyno.talk.softphone.SMessageStream.verify|verify} messages.
                     * @function encode
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @static
                     * @param {app.zyno.talk.softphone.SMessageStream.$Properties} message SMessageStream message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SMessageStream.encode = function (message, writer, _depth) {
                        if (!writer)
                            writer = $Writer.create();
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            throw $Error("max depth exceeded");
                        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId") && message.requestId !== "")
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                        if (message.reply != null && $Object.hasOwnProperty.call(message, "reply") && message.reply !== false)
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.reply);
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.error);
                        if (message.userError != null && $Object.hasOwnProperty.call(message, "userError"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.userError);
                        if (message.trace != null && $Object.hasOwnProperty.call(message, "trace"))
                            $root.app.zyno.talk.softphone.TraceContext.encode(message.trace, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
                        if (message.pingPong != null && $Object.hasOwnProperty.call(message, "pingPong"))
                            $root.app.zyno.talk.softphone.PingPong.encode(message.pingPong, writer.uint32(/* id 50, wireType 2 =*/402).fork(), _depth + 1).ldelim();
                        if (message.byteStreamOperation != null && $Object.hasOwnProperty.call(message, "byteStreamOperation"))
                            $root.app.zyno.talk.softphone.ByteStreamOperation.encode(message.byteStreamOperation, writer.uint32(/* id 51, wireType 2 =*/410).fork(), _depth + 1).ldelim();
                        if (message.cPlaceCallResponse != null && $Object.hasOwnProperty.call(message, "cPlaceCallResponse"))
                            $root.app.zyno.talk.softphone.CPlaceCallResponse.encode(message.cPlaceCallResponse, writer.uint32(/* id 1000, wireType 2 =*/8002).fork(), _depth + 1).ldelim();
                        if (message.cAcceptCallResponse != null && $Object.hasOwnProperty.call(message, "cAcceptCallResponse"))
                            $root.app.zyno.talk.softphone.CAcceptCallResponse.encode(message.cAcceptCallResponse, writer.uint32(/* id 1001, wireType 2 =*/8010).fork(), _depth + 1).ldelim();
                        if (message.cEndCallResponse != null && $Object.hasOwnProperty.call(message, "cEndCallResponse"))
                            $root.app.zyno.talk.softphone.CEndCallResponse.encode(message.cEndCallResponse, writer.uint32(/* id 1002, wireType 2 =*/8018).fork(), _depth + 1).ldelim();
                        if (message.cReattachCallSessionResponse != null && $Object.hasOwnProperty.call(message, "cReattachCallSessionResponse"))
                            $root.app.zyno.talk.softphone.CReattachCallSessionResponse.encode(message.cReattachCallSessionResponse, writer.uint32(/* id 1003, wireType 2 =*/8026).fork(), _depth + 1).ldelim();
                        if (message.cHoldCallResponse != null && $Object.hasOwnProperty.call(message, "cHoldCallResponse"))
                            $root.app.zyno.talk.softphone.CHoldCallResponse.encode(message.cHoldCallResponse, writer.uint32(/* id 1004, wireType 2 =*/8034).fork(), _depth + 1).ldelim();
                        if (message.cTransferCallResponse != null && $Object.hasOwnProperty.call(message, "cTransferCallResponse"))
                            $root.app.zyno.talk.softphone.CTransferCallResponse.encode(message.cTransferCallResponse, writer.uint32(/* id 1005, wireType 2 =*/8042).fork(), _depth + 1).ldelim();
                        if (message.cGetTurnCredentialsResponse != null && $Object.hasOwnProperty.call(message, "cGetTurnCredentialsResponse"))
                            $root.app.zyno.talk.softphone.CGetTurnCredentialsResponse.encode(message.cGetTurnCredentialsResponse, writer.uint32(/* id 1007, wireType 2 =*/8058).fork(), _depth + 1).ldelim();
                        if (message.cSubmitAnswerResponse != null && $Object.hasOwnProperty.call(message, "cSubmitAnswerResponse"))
                            $root.app.zyno.talk.softphone.CSubmitAnswerResponse.encode(message.cSubmitAnswerResponse, writer.uint32(/* id 1008, wireType 2 =*/8066).fork(), _depth + 1).ldelim();
                        if (message.cRequestIceRestartResponse != null && $Object.hasOwnProperty.call(message, "cRequestIceRestartResponse"))
                            $root.app.zyno.talk.softphone.CRequestIceRestartResponse.encode(message.cRequestIceRestartResponse, writer.uint32(/* id 1009, wireType 2 =*/8074).fork(), _depth + 1).ldelim();
                        if (message.cSendDtmfResponse != null && $Object.hasOwnProperty.call(message, "cSendDtmfResponse"))
                            $root.app.zyno.talk.softphone.CSendDtmfResponse.encode(message.cSendDtmfResponse, writer.uint32(/* id 1010, wireType 2 =*/8082).fork(), _depth + 1).ldelim();
                        if (message.cRequestMediaReplacementResponse != null && $Object.hasOwnProperty.call(message, "cRequestMediaReplacementResponse"))
                            $root.app.zyno.talk.softphone.CRequestMediaReplacementResponse.encode(message.cRequestMediaReplacementResponse, writer.uint32(/* id 1011, wireType 2 =*/8090).fork(), _depth + 1).ldelim();
                        if (message.cPlaceAiAgentTestCallResponse != null && $Object.hasOwnProperty.call(message, "cPlaceAiAgentTestCallResponse"))
                            $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.encode(message.cPlaceAiAgentTestCallResponse, writer.uint32(/* id 1012, wireType 2 =*/8098).fork(), _depth + 1).ldelim();
                        if (message.cGetTransferCapabilitiesResponse != null && $Object.hasOwnProperty.call(message, "cGetTransferCapabilitiesResponse"))
                            $root.app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.encode(message.cGetTransferCapabilitiesResponse, writer.uint32(/* id 1013, wireType 2 =*/8106).fork(), _depth + 1).ldelim();
                        if (message.cPickupCallResponse != null && $Object.hasOwnProperty.call(message, "cPickupCallResponse"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentResponse.encode(message.cPickupCallResponse, writer.uint32(/* id 1014, wireType 2 =*/8114).fork(), _depth + 1).ldelim();
                        if (message.cRetrieveParkedCallResponse != null && $Object.hasOwnProperty.call(message, "cRetrieveParkedCallResponse"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentResponse.encode(message.cRetrieveParkedCallResponse, writer.uint32(/* id 1015, wireType 2 =*/8122).fork(), _depth + 1).ldelim();
                        if (message.cCommitTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cCommitTargetAttachmentResponse"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentResponse.encode(message.cCommitTargetAttachmentResponse, writer.uint32(/* id 1016, wireType 2 =*/8130).fork(), _depth + 1).ldelim();
                        if (message.cGetTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cGetTargetAttachmentResponse"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentResponse.encode(message.cGetTargetAttachmentResponse, writer.uint32(/* id 1017, wireType 2 =*/8138).fork(), _depth + 1).ldelim();
                        if (message.cAbortTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cAbortTargetAttachmentResponse"))
                            $root.app.zyno.talk.softphone.CTargetAttachmentResponse.encode(message.cAbortTargetAttachmentResponse, writer.uint32(/* id 1018, wireType 2 =*/8146).fork(), _depth + 1).ldelim();
                        if (message.sUpdateCallStatusRequest != null && $Object.hasOwnProperty.call(message, "sUpdateCallStatusRequest"))
                            $root.app.zyno.talk.softphone.SUpdateCallStatusRequest.encode(message.sUpdateCallStatusRequest, writer.uint32(/* id 2000, wireType 2 =*/16002).fork(), _depth + 1).ldelim();
                        if (message.sRenegotiateCallRequest != null && $Object.hasOwnProperty.call(message, "sRenegotiateCallRequest"))
                            $root.app.zyno.talk.softphone.SRenegotiateCallRequest.encode(message.sRenegotiateCallRequest, writer.uint32(/* id 2001, wireType 2 =*/16010).fork(), _depth + 1).ldelim();
                        if (message.sMediaFailureHintRequest != null && $Object.hasOwnProperty.call(message, "sMediaFailureHintRequest"))
                            $root.app.zyno.talk.softphone.SMediaFailureHintRequest.encode(message.sMediaFailureHintRequest, writer.uint32(/* id 2002, wireType 2 =*/16018).fork(), _depth + 1).ldelim();
                        if (message.sRenegotiateCompleteRequest != null && $Object.hasOwnProperty.call(message, "sRenegotiateCompleteRequest"))
                            $root.app.zyno.talk.softphone.SRenegotiateCompleteRequest.encode(message.sRenegotiateCompleteRequest, writer.uint32(/* id 2003, wireType 2 =*/16026).fork(), _depth + 1).ldelim();
                        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                            for (let i = 0; i < message.$unknowns.length; ++i)
                                writer.raw(message.$unknowns[i]);
                        return writer;
                    };

                    /**
                     * Decodes a SMessageStream message from the specified reader or buffer.
                     * @function decode
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {app.zyno.talk.softphone.SMessageStream & app.zyno.talk.softphone.SMessageStream.$Shape} SMessageStream
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SMessageStream.decode = function (reader, length, _end, _depth, _target) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $Reader.recursionLimit)
                            throw $Error("max depth exceeded");
                        let end, message, value;
                        if (length === $undefined)
                            end = reader.len;
                        else {
                            end = reader.pos + length;
                            if (end > reader.len)
                                throw $RangeError("index out of range");
                            length = reader.len;
                            reader.len = end;
                        }
                        message = _target || new $root.app.zyno.talk.softphone.SMessageStream();
                        while (reader.pos < end) {
                            let start = reader.pos;
                            let tag = reader.tag();
                            if (tag === _end) {
                                _end = $undefined;
                                break;
                            }
                            let wireType = tag & 7;
                            switch (tag >>>= 3) {
                            case 1: {
                                    if (wireType !== 2)
                                        break;
                                    if ((value = reader.stringVerify()).length)
                                        message.requestId = value;
                                    else
                                        delete message.requestId;
                                    continue;
                                }
                            case 2: {
                                    if (wireType !== 0)
                                        break;
                                    if (value = reader.bool())
                                        message.reply = value;
                                    else
                                        delete message.reply;
                                    continue;
                                }
                            case 3: {
                                    if (wireType !== 2)
                                        break;
                                    message.error = reader.stringVerify();
                                    message._error = "error";
                                    continue;
                                }
                            case 4: {
                                    if (wireType !== 0)
                                        break;
                                    message.userError = reader.bool();
                                    message._userError = "userError";
                                    continue;
                                }
                            case 5: {
                                    if (wireType !== 2)
                                        break;
                                    message.trace = $root.app.zyno.talk.softphone.TraceContext.decode(reader, reader.size(), $undefined, _depth + 1, message.trace);
                                    message._trace = "trace";
                                    continue;
                                }
                            case 50: {
                                    if (wireType !== 2)
                                        break;
                                    message.pingPong = $root.app.zyno.talk.softphone.PingPong.decode(reader, reader.size(), $undefined, _depth + 1, message.pingPong);
                                    message.payload = "pingPong";
                                    continue;
                                }
                            case 51: {
                                    if (wireType !== 2)
                                        break;
                                    message.byteStreamOperation = $root.app.zyno.talk.softphone.ByteStreamOperation.decode(reader, reader.size(), $undefined, _depth + 1, message.byteStreamOperation);
                                    message.payload = "byteStreamOperation";
                                    continue;
                                }
                            case 1000: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPlaceCallResponse = $root.app.zyno.talk.softphone.CPlaceCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cPlaceCallResponse);
                                    message.payload = "cPlaceCallResponse";
                                    continue;
                                }
                            case 1001: {
                                    if (wireType !== 2)
                                        break;
                                    message.cAcceptCallResponse = $root.app.zyno.talk.softphone.CAcceptCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cAcceptCallResponse);
                                    message.payload = "cAcceptCallResponse";
                                    continue;
                                }
                            case 1002: {
                                    if (wireType !== 2)
                                        break;
                                    message.cEndCallResponse = $root.app.zyno.talk.softphone.CEndCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cEndCallResponse);
                                    message.payload = "cEndCallResponse";
                                    continue;
                                }
                            case 1003: {
                                    if (wireType !== 2)
                                        break;
                                    message.cReattachCallSessionResponse = $root.app.zyno.talk.softphone.CReattachCallSessionResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cReattachCallSessionResponse);
                                    message.payload = "cReattachCallSessionResponse";
                                    continue;
                                }
                            case 1004: {
                                    if (wireType !== 2)
                                        break;
                                    message.cHoldCallResponse = $root.app.zyno.talk.softphone.CHoldCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cHoldCallResponse);
                                    message.payload = "cHoldCallResponse";
                                    continue;
                                }
                            case 1005: {
                                    if (wireType !== 2)
                                        break;
                                    message.cTransferCallResponse = $root.app.zyno.talk.softphone.CTransferCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cTransferCallResponse);
                                    message.payload = "cTransferCallResponse";
                                    continue;
                                }
                            case 1007: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTurnCredentialsResponse = $root.app.zyno.talk.softphone.CGetTurnCredentialsResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTurnCredentialsResponse);
                                    message.payload = "cGetTurnCredentialsResponse";
                                    continue;
                                }
                            case 1008: {
                                    if (wireType !== 2)
                                        break;
                                    message.cSubmitAnswerResponse = $root.app.zyno.talk.softphone.CSubmitAnswerResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cSubmitAnswerResponse);
                                    message.payload = "cSubmitAnswerResponse";
                                    continue;
                                }
                            case 1009: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRequestIceRestartResponse = $root.app.zyno.talk.softphone.CRequestIceRestartResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cRequestIceRestartResponse);
                                    message.payload = "cRequestIceRestartResponse";
                                    continue;
                                }
                            case 1010: {
                                    if (wireType !== 2)
                                        break;
                                    message.cSendDtmfResponse = $root.app.zyno.talk.softphone.CSendDtmfResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cSendDtmfResponse);
                                    message.payload = "cSendDtmfResponse";
                                    continue;
                                }
                            case 1011: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRequestMediaReplacementResponse = $root.app.zyno.talk.softphone.CRequestMediaReplacementResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cRequestMediaReplacementResponse);
                                    message.payload = "cRequestMediaReplacementResponse";
                                    continue;
                                }
                            case 1012: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPlaceAiAgentTestCallResponse = $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cPlaceAiAgentTestCallResponse);
                                    message.payload = "cPlaceAiAgentTestCallResponse";
                                    continue;
                                }
                            case 1013: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTransferCapabilitiesResponse = $root.app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTransferCapabilitiesResponse);
                                    message.payload = "cGetTransferCapabilitiesResponse";
                                    continue;
                                }
                            case 1014: {
                                    if (wireType !== 2)
                                        break;
                                    message.cPickupCallResponse = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cPickupCallResponse);
                                    message.payload = "cPickupCallResponse";
                                    continue;
                                }
                            case 1015: {
                                    if (wireType !== 2)
                                        break;
                                    message.cRetrieveParkedCallResponse = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cRetrieveParkedCallResponse);
                                    message.payload = "cRetrieveParkedCallResponse";
                                    continue;
                                }
                            case 1016: {
                                    if (wireType !== 2)
                                        break;
                                    message.cCommitTargetAttachmentResponse = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cCommitTargetAttachmentResponse);
                                    message.payload = "cCommitTargetAttachmentResponse";
                                    continue;
                                }
                            case 1017: {
                                    if (wireType !== 2)
                                        break;
                                    message.cGetTargetAttachmentResponse = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cGetTargetAttachmentResponse);
                                    message.payload = "cGetTargetAttachmentResponse";
                                    continue;
                                }
                            case 1018: {
                                    if (wireType !== 2)
                                        break;
                                    message.cAbortTargetAttachmentResponse = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.decode(reader, reader.size(), $undefined, _depth + 1, message.cAbortTargetAttachmentResponse);
                                    message.payload = "cAbortTargetAttachmentResponse";
                                    continue;
                                }
                            case 2000: {
                                    if (wireType !== 2)
                                        break;
                                    message.sUpdateCallStatusRequest = $root.app.zyno.talk.softphone.SUpdateCallStatusRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.sUpdateCallStatusRequest);
                                    message.payload = "sUpdateCallStatusRequest";
                                    continue;
                                }
                            case 2001: {
                                    if (wireType !== 2)
                                        break;
                                    message.sRenegotiateCallRequest = $root.app.zyno.talk.softphone.SRenegotiateCallRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.sRenegotiateCallRequest);
                                    message.payload = "sRenegotiateCallRequest";
                                    continue;
                                }
                            case 2002: {
                                    if (wireType !== 2)
                                        break;
                                    message.sMediaFailureHintRequest = $root.app.zyno.talk.softphone.SMediaFailureHintRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.sMediaFailureHintRequest);
                                    message.payload = "sMediaFailureHintRequest";
                                    continue;
                                }
                            case 2003: {
                                    if (wireType !== 2)
                                        break;
                                    message.sRenegotiateCompleteRequest = $root.app.zyno.talk.softphone.SRenegotiateCompleteRequest.decode(reader, reader.size(), $undefined, _depth + 1, message.sRenegotiateCompleteRequest);
                                    message.payload = "sRenegotiateCompleteRequest";
                                    continue;
                                }
                            }
                            reader.skipType(wireType, _depth, tag);
                            if (!reader.discardUnknown) {
                                $util.makeProp(message, "$unknowns", false);
                                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                            }
                        }
                        if (length !== $undefined) {
                            if (reader.pos !== end)
                                throw $RangeError("index out of range");
                            reader.len = length;
                        }
                        if (_end !== $undefined)
                            throw $Error("missing end group");
                        return message;
                    };

                    /**
                     * Verifies a SMessageStream message.
                     * @function verify
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SMessageStream.verify = function (message, _depth) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (_depth === $undefined)
                            _depth = 0;
                        if (_depth > $util.recursionLimit)
                            return "max depth exceeded";
                        let properties = {};
                        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId"))
                            if (!$util.isString(message.requestId))
                                return "requestId: string expected";
                        if (message.reply != null && $Object.hasOwnProperty.call(message, "reply"))
                            if (typeof message.reply !== "boolean")
                                return "reply: boolean expected";
                        if (message.error != null && $Object.hasOwnProperty.call(message, "error")) {
                            properties._error = 1;
                            if (!$util.isString(message.error))
                                return "error: string expected";
                        }
                        if (message.userError != null && $Object.hasOwnProperty.call(message, "userError")) {
                            properties._userError = 1;
                            if (typeof message.userError !== "boolean")
                                return "userError: boolean expected";
                        }
                        if (message.trace != null && $Object.hasOwnProperty.call(message, "trace")) {
                            properties._trace = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.TraceContext.verify(message.trace, _depth + 1);
                                if (error)
                                    return "trace." + error;
                            }
                        }
                        if (message.pingPong != null && $Object.hasOwnProperty.call(message, "pingPong")) {
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.PingPong.verify(message.pingPong, _depth + 1);
                                if (error)
                                    return "pingPong." + error;
                            }
                        }
                        if (message.byteStreamOperation != null && $Object.hasOwnProperty.call(message, "byteStreamOperation")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.ByteStreamOperation.verify(message.byteStreamOperation, _depth + 1);
                                if (error)
                                    return "byteStreamOperation." + error;
                            }
                        }
                        if (message.cPlaceCallResponse != null && $Object.hasOwnProperty.call(message, "cPlaceCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CPlaceCallResponse.verify(message.cPlaceCallResponse, _depth + 1);
                                if (error)
                                    return "cPlaceCallResponse." + error;
                            }
                        }
                        if (message.cAcceptCallResponse != null && $Object.hasOwnProperty.call(message, "cAcceptCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CAcceptCallResponse.verify(message.cAcceptCallResponse, _depth + 1);
                                if (error)
                                    return "cAcceptCallResponse." + error;
                            }
                        }
                        if (message.cEndCallResponse != null && $Object.hasOwnProperty.call(message, "cEndCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CEndCallResponse.verify(message.cEndCallResponse, _depth + 1);
                                if (error)
                                    return "cEndCallResponse." + error;
                            }
                        }
                        if (message.cReattachCallSessionResponse != null && $Object.hasOwnProperty.call(message, "cReattachCallSessionResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CReattachCallSessionResponse.verify(message.cReattachCallSessionResponse, _depth + 1);
                                if (error)
                                    return "cReattachCallSessionResponse." + error;
                            }
                        }
                        if (message.cHoldCallResponse != null && $Object.hasOwnProperty.call(message, "cHoldCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CHoldCallResponse.verify(message.cHoldCallResponse, _depth + 1);
                                if (error)
                                    return "cHoldCallResponse." + error;
                            }
                        }
                        if (message.cTransferCallResponse != null && $Object.hasOwnProperty.call(message, "cTransferCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTransferCallResponse.verify(message.cTransferCallResponse, _depth + 1);
                                if (error)
                                    return "cTransferCallResponse." + error;
                            }
                        }
                        if (message.cGetTurnCredentialsResponse != null && $Object.hasOwnProperty.call(message, "cGetTurnCredentialsResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CGetTurnCredentialsResponse.verify(message.cGetTurnCredentialsResponse, _depth + 1);
                                if (error)
                                    return "cGetTurnCredentialsResponse." + error;
                            }
                        }
                        if (message.cSubmitAnswerResponse != null && $Object.hasOwnProperty.call(message, "cSubmitAnswerResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CSubmitAnswerResponse.verify(message.cSubmitAnswerResponse, _depth + 1);
                                if (error)
                                    return "cSubmitAnswerResponse." + error;
                            }
                        }
                        if (message.cRequestIceRestartResponse != null && $Object.hasOwnProperty.call(message, "cRequestIceRestartResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CRequestIceRestartResponse.verify(message.cRequestIceRestartResponse, _depth + 1);
                                if (error)
                                    return "cRequestIceRestartResponse." + error;
                            }
                        }
                        if (message.cSendDtmfResponse != null && $Object.hasOwnProperty.call(message, "cSendDtmfResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CSendDtmfResponse.verify(message.cSendDtmfResponse, _depth + 1);
                                if (error)
                                    return "cSendDtmfResponse." + error;
                            }
                        }
                        if (message.cRequestMediaReplacementResponse != null && $Object.hasOwnProperty.call(message, "cRequestMediaReplacementResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CRequestMediaReplacementResponse.verify(message.cRequestMediaReplacementResponse, _depth + 1);
                                if (error)
                                    return "cRequestMediaReplacementResponse." + error;
                            }
                        }
                        if (message.cPlaceAiAgentTestCallResponse != null && $Object.hasOwnProperty.call(message, "cPlaceAiAgentTestCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CPlaceAiAgentTestCallResponse.verify(message.cPlaceAiAgentTestCallResponse, _depth + 1);
                                if (error)
                                    return "cPlaceAiAgentTestCallResponse." + error;
                            }
                        }
                        if (message.cGetTransferCapabilitiesResponse != null && $Object.hasOwnProperty.call(message, "cGetTransferCapabilitiesResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CGetTransferCapabilitiesResponse.verify(message.cGetTransferCapabilitiesResponse, _depth + 1);
                                if (error)
                                    return "cGetTransferCapabilitiesResponse." + error;
                            }
                        }
                        if (message.cPickupCallResponse != null && $Object.hasOwnProperty.call(message, "cPickupCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.verify(message.cPickupCallResponse, _depth + 1);
                                if (error)
                                    return "cPickupCallResponse." + error;
                            }
                        }
                        if (message.cRetrieveParkedCallResponse != null && $Object.hasOwnProperty.call(message, "cRetrieveParkedCallResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.verify(message.cRetrieveParkedCallResponse, _depth + 1);
                                if (error)
                                    return "cRetrieveParkedCallResponse." + error;
                            }
                        }
                        if (message.cCommitTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cCommitTargetAttachmentResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.verify(message.cCommitTargetAttachmentResponse, _depth + 1);
                                if (error)
                                    return "cCommitTargetAttachmentResponse." + error;
                            }
                        }
                        if (message.cGetTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cGetTargetAttachmentResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.verify(message.cGetTargetAttachmentResponse, _depth + 1);
                                if (error)
                                    return "cGetTargetAttachmentResponse." + error;
                            }
                        }
                        if (message.cAbortTargetAttachmentResponse != null && $Object.hasOwnProperty.call(message, "cAbortTargetAttachmentResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.CTargetAttachmentResponse.verify(message.cAbortTargetAttachmentResponse, _depth + 1);
                                if (error)
                                    return "cAbortTargetAttachmentResponse." + error;
                            }
                        }
                        if (message.sUpdateCallStatusRequest != null && $Object.hasOwnProperty.call(message, "sUpdateCallStatusRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SUpdateCallStatusRequest.verify(message.sUpdateCallStatusRequest, _depth + 1);
                                if (error)
                                    return "sUpdateCallStatusRequest." + error;
                            }
                        }
                        if (message.sRenegotiateCallRequest != null && $Object.hasOwnProperty.call(message, "sRenegotiateCallRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SRenegotiateCallRequest.verify(message.sRenegotiateCallRequest, _depth + 1);
                                if (error)
                                    return "sRenegotiateCallRequest." + error;
                            }
                        }
                        if (message.sMediaFailureHintRequest != null && $Object.hasOwnProperty.call(message, "sMediaFailureHintRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SMediaFailureHintRequest.verify(message.sMediaFailureHintRequest, _depth + 1);
                                if (error)
                                    return "sMediaFailureHintRequest." + error;
                            }
                        }
                        if (message.sRenegotiateCompleteRequest != null && $Object.hasOwnProperty.call(message, "sRenegotiateCompleteRequest")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.app.zyno.talk.softphone.SRenegotiateCompleteRequest.verify(message.sRenegotiateCompleteRequest, _depth + 1);
                                if (error)
                                    return "sRenegotiateCompleteRequest." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Gets the type url for SMessageStream
                     * @function getTypeUrl
                     * @memberof app.zyno.talk.softphone.SMessageStream
                     * @static
                     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
                     * @returns {string} The type url
                     */
                    SMessageStream.getTypeUrl = function(prefix) {
                        if (prefix === $undefined)
                            prefix = "type.googleapis.com";
                        return prefix + "/app.zyno.talk.softphone.SMessageStream";
                    };

                    return SMessageStream;
                })();

                return softphone;
            })();

            return talk;
        })();

        return zyno;
    })();

    return app;
})();

export {
  $root as default
};
